import { ɵɵdefineComponent, ɵɵelement, ɵɵclassMapInterpolate1, ɵɵclassProp, ɵsetClassMetadata, Component, Input, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, ɵɵdefineInjectable, Injectable, EventEmitter, ɵɵgetCurrentView, ɵɵelementStart, ɵɵlistener, ɵɵrestoreView, ɵɵnextContext, ɵɵtext, ɵɵelementEnd, ɵɵpropertyInterpolate2, ɵɵproperty, ɵɵadvance, ɵɵtextInterpolate1, ɵɵtemplate, ɵɵdirectiveInject, Renderer2, ɵɵviewQuery, ElementRef, ɵɵqueryRefresh, ɵɵloadQuery, ɵɵtextInterpolate, ɵɵpropertyInterpolate1, ɵɵpropertyInterpolate, ViewChild, ɵɵi18n, ɵɵi18nExp, ɵɵi18nApply, Output, ɵɵtextInterpolate3, ɵɵinject, ɵɵi18nStart, ɵɵi18nEnd, ɵɵattribute, ɵɵNgOnChangesFeature, ɵɵprojectionDef, ɵɵprojection, ɵɵnamespaceSVG, ɵɵsanitizeUrl, ɵɵpureFunction1, ɵɵi18nPostprocess, ɵɵsanitizeHtml, Inject, ɵɵpipe, ɵɵpipeBind1, ɵɵelementContainerStart, ɵɵelementContainerEnd, ɵɵattributeInterpolate2, ɵɵstyleProp, ɵɵpureFunction0 } from '@angular/core';
import { CommonModule, NgClass, NgIf, NgForOf, CurrencyPipe, NgStyle, UpperCasePipe } from '@angular/common';
import { takeUntil, distinctUntilChanged, tap, map, catchError, debounceTime } from 'rxjs/operators';
import { filter, isEmpty, cloneDeep, trim, get, find, sortBy } from 'lodash';
import { Subject, fromEvent, interval, EMPTY, BehaviorSubject } from 'rxjs';
import { Validators, NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, ReactiveFormsModule, NgModel, MaxLengthValidator, FormsModule, FormControl, FormBuilder, ɵangular_packages_forms_forms_ba } from '@angular/forms';
import { MatFormField, MatLabel, MatFormFieldModule, MatHint, MatError, MatSuffix } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatCard, MatCardModule, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatOption, MatNativeDateModule, MatOptgroup } from '@angular/material/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { MatIconModule, MatIcon, MatIconRegistry } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatButtonModule, MatButton } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MatDialogClose, MatDialog, MAT_DIALOG_DATA, MatDialogContent, MatDialogActions, MatDialogTitle } from '@angular/material/dialog';
import { MatSelectModule, MatSelect } from '@angular/material/select';
import { MatRadioModule, MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTableModule, MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatCellDef, MatHeaderRowDef, MatRowDef, MatHeaderCell, MatCell, MatHeaderRow, MatRow } from '@angular/material/table';
import { MatSortModule, MatSort, MatSortHeader } from '@angular/material/sort';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { HttpClient } from '@angular/common/http';
import { MaskedInputDirective, TextMaskModule } from 'angular2-text-mask';
import { ActivatedRoute, Router, PRIMARY_OUTLET } from '@angular/router';
import { FileUploader, FileSelectDirective, FileUploadModule } from 'ng2-file-upload';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ComponentPortal } from '@angular/cdk/portal';
import { Overlay } from '@angular/cdk/overlay';
import * as moment_ from 'moment';

class SpacerComponent {
    constructor() { }
    ngOnInit() { }
}
SpacerComponent.ɵfac = function SpacerComponent_Factory(t) { return new (t || SpacerComponent)(); };
SpacerComponent.ɵcmp = ɵɵdefineComponent({ type: SpacerComponent, selectors: [["ts-spacer"]], inputs: { horizontal: "horizontal", size: "size" }, decls: 1, vars: 5, template: function SpacerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "div");
    } if (rf & 2) {
        ɵɵclassMapInterpolate1("nsc-ts-spacer nsc-ts-spacer--", ctx.size, "");
        ɵɵclassProp("nsc-ts-spacer--horizontal", ctx.horizontal);
    } }, styles: [".nsc-ts-spacer[_ngcontent-%COMP%]{height:10px;width:10px}.nsc-ts-spacer--sm[_ngcontent-%COMP%]{height:20px;width:20px}.nsc-ts-spacer--xsm[_ngcontent-%COMP%]{height:5px;width:5px}.nsc-ts-spacer--md[_ngcontent-%COMP%]{height:30px;width:30px}.nsc-ts-spacer--lg[_ngcontent-%COMP%]{height:40px;width:40px}.nsc-ts-spacer--horizontal[_ngcontent-%COMP%]{display:inline-block}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(SpacerComponent, [{
        type: Component,
        args: [{
                selector: 'ts-spacer',
                templateUrl: './spacer.component.html',
                styleUrls: ['./spacer.component.scss']
            }]
    }], function () { return []; }, { horizontal: [{
            type: Input
        }], size: [{
            type: Input
        }] }); })();

class SpacerModule {
}
SpacerModule.ɵfac = function SpacerModule_Factory(t) { return new (t || SpacerModule)(); };
SpacerModule.ɵmod = ɵɵdefineNgModule({ type: SpacerModule });
SpacerModule.ɵinj = ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(SpacerModule, { declarations: [SpacerComponent], imports: [CommonModule], exports: [SpacerComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(SpacerModule, [{
        type: NgModule,
        args: [{
                declarations: [SpacerComponent],
                imports: [
                    CommonModule
                ],
                exports: [SpacerComponent]
            }]
    }], null, null); })();

class SharedCommonValues {
    constructor() {
        this.SISCloudAPIntegrationProvider = 'SISCLOUDAPI';
        this.address = {
            hintZipDomestic: '',
            hintZipInternational: '(Optional)',
            hintPhoneDomestic: '(XXX) XXX-XXXX',
            hintPhoneInternational: 'Enter digits or dashes only (591-12345678)',
            labelStateUS: 'State/Territory/APO',
            labelStateCA: 'Province/Territory',
            labelStateInternational: 'State/Province/Territory',
            labelState: 'State',
            validationPhoneDomestic: [
                Validators.minLength(10),
                Validators.pattern(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/)
            ],
            validationPhoneInternational: [
                Validators.minLength(10),
                Validators.pattern(/^(\d+|\d+(-\d+)+)((-){0,1}(x|X){1}(-){0,1}\d+)?$/)
            ],
            validationZipCA: [
                Validators.required,
                Validators.minLength(3),
                Validators.pattern(/^[A-Za-z]\d[A-Za-z](( )?\d[A-Za-z]\d)?$/)
            ],
            validationZipUS: [
                Validators.required,
                Validators.minLength(5),
                Validators.pattern(/^\d{5}(-\d{4})?$/)
            ]
        };
        // regex used to validate an email has a tld;
        this.emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        // configuration to disable reactive form fields;
        this.nullDisabled = {
            value: null,
            disabled: true
        };
        this.applicationType = {
            studentSelfService: 'SSS',
            myHub: 'H',
            saml: 'O',
        };
        this.routes = {
            schoolSelect: {
                labelName: 'School Select',
                routePath: 'school/select',
            },
            // pass in router.navigate(commands, extras) calls when we want to NOT add history to the browser;
            extras: { replaceUrl: true }
        };
        this.api = {
            // value to check if any variable is undefined
            undefined: 'undefined',
            // XmitCode deliveryMethod-Countries
            mailUsa: 'MU',
            expressUsa: 'XU',
            mailCaMex: 'MC',
            expressCaMex: 'XC',
            mailInternational: 'MI',
            expressInternational: 'XI',
            rushMailUsa: 'RMU',
            rushExpressUsa: 'RXU',
            rushMailCaMex: 'RMC',
            rushExpressCaMex: 'RXC',
            rushMailInternational: 'RMI',
            rushExpressInternational: 'RXI',
            rushCertifiedMailUsa: 'RCU',
            FedExInternational: 'FI',
            FedExCanadaMexico: 'FC',
            FedExUsa: 'FU',
            RushFedExInternational: 'RFI',
            RushFedExCanadaMexico: 'RFC',
            RushFedExUsa: 'RFU',
            certifiedMailUsa: 'CU',
            // school profile values;
            both: 'B',
            no: 'N',
            optional: 'O',
            required: 'R',
            yes: 'Y',
            yesSMS: 'T',
            // delivery method types;
            electronic: 'E',
            etx: 'T',
            fax: 'F',
            faxMail: 'A',
            faxExpress: 'B',
            hold: 'H',
            mail: 'M',
            overnight: 'O',
            express: 'O',
            // country codes;
            ca: 'CA',
            mx: 'MX',
            us: 'US',
            oh: 'OH',
            international: 'ZZ',
            // recipient types;
            business: 'O',
            college: 'S',
            me: 'M',
            organization: 'A',
            // recipient order status
            pending: 'P',
            // path types;
            free: 'F',
            pay: 'P',
            // transcript when options;
            afterCourseIsCompleted: 'R',
            afterDegreeIsAwarded: 'D',
            afterDegreeIsPosted: 'S',
            afterGradesAreChanged: 'C',
            afterGradesArePosted: 'G',
            afterHonorsArePosted: 'H',
            holdForCurrentTermSchedule: 'U',
            holdForFallTermGrades: 'F',
            holdForSpringTermGrades: 'T',
            now: 'N',
            // eligibility obor -speede schools
            obor: 'OBOR',
            speede: 'SPDE',
            etxNetwork: 'ETX',
            lsac: 'LSAC',
            amcas: 'AMCAS',
            liason: 'LIAISON',
            // file formats
            pdf: 'PDF',
            xml: 'XML',
            edi: 'EDI',
            // delivery fee terms
            totalFee: 'totalFee',
            deliveryMethod: 'deliveryMethod'
        };
        this.xmitCodesToExcludeInDeliveryMethods = ['ET', 'RET', 'EP', 'REP', 'H', 'RH', 'MC', 'RMC', 'MI',
            'RMI', 'FI', 'RFI', 'FC', 'RFC', 'XI', 'RXI', 'XC', 'RXC'];
        this.select = {
            // used when adding a Not in List value to a SELECT form field;
            notInList: {
                name: 'Not in List',
                value: 'NOT IN LIST'
            }
        };
        this.autocomplete = {
            custom: {
                backSearchLinkLabel: 'Back',
            },
            // option to display in the autocomplete when there are no matches;
            // disabled because it is not a valid option for the user to choose, they must type in a different value;
            noMatch: {
                schlName: 'There is no match for the school entered',
                disabled: true // make sure this value isn't selectable;
            },
            // option to display  when adding a `Not in List` value to an autocomplete form field;
            // this is enabled to allow the form to trigger a `Not in List` INPUT to display;
            notInList: {
                schlName: 'Not in List'
            },
            searchType: {
                wildCardSearch: 'W',
                startsWithSearch: 'S'
            },
        };
        this.addressValidationMessages = {
            missingPrimary: 'Invalid Address: Primary address is not found.',
            missingPrimaryBuildingNumber: 'Invalid Address: Street number is missing.',
            internationalMissingStreetNumber: 'Invalid Address: Street number or name is missing or invalid.',
            cityNotFound: 'Invalid Address: City/State/Zip is not found for this address.',
            internationalCityNotFound: 'Invalid Address: Primary address is not found for this City/Province/Postal Code',
            addressAmbigous: 'Invalid Address: Address matched multiple addresses',
            addressAmbigousInternational: 'Invalid Address: Multiple Addresses Found',
            secondaryAddress: 'Invalid Address: APT/Suite number is missing or invalid.',
            addressInvalid: 'Invalid Address: No matches found.',
            notEnoughInput: 'Not all components of the Address are provided, please verify',
            privateMailBox: 'Could not confirm private mailbox',
            ruralAddressMissingSecondaryNumber: 'Invalid Address: PO, RR, or HC box number is missing or invalid.',
            newAddressSuggested: 'The entered address has been formatted to USPS standards. Please make a selection or edit the entered address.',
            newInternationalAddressSuggested: 'The entered address has been formatted to the delivery standards. Please make a selection or edit the entered address.',
            invalidAddressMessage: 'USPS was unable to find the address you entered as deliverable.  Addresses on a university or college campus  are controlled by the school and may not be registered with the US Postal Service. Please check with the recipient for an alternate or updated address.',
            invalidAddressMessageInternational: 'We are unable to find the address you entered as deliverable.   Addresses on a university or college campus  are controlled by the school and may not be registered. Please check with the recipient for an alternate or updated address.',
            invalidAddressAndCannotContinue: 'USPS was unable to find the address you entered as deliverable for Express Mail. Please edit the address or change the delivery method to a non-Express Mail option if you need to use this address.Addresses on a university or college campus  are controlled by the school and may not be registered with the US Postal Service. Please check with the recipient for an alternate or updated address.',
            invalidInternationalAddressAndCannotContinue: 'We are unable to find the address you entered as deliverable for Express Mail. Please edit the address or change the delivery method to a non-Express Mail option if you need to use this address.Addresses on a university or college campus are controlled by the school and may not be registered. Please check with the recipient for an alternate or updated address.',
            addressSuggestedAndCannnotContinue: 'You must provide a recognized USPS address for Express Mail deliveries. If you want to use the address you entered, you will need to change the delivery method to a non-Express Mail option.',
            internationalAddressSuggestedAndCannnotContinue: 'You must provide a recognized  address for Express Mail deliveries. If you want to use the address you entered, you will need to change the delivery method to a non-Express Mail option.',
            acknowlelgeAddressUS: 'The entered address could not be found in the US Postal Service database. By selecting "Yes", you are acknowledging that your order may not be deliverable. It is your responsibility to provide an accurate address, Do you want to continue with this address?',
            acknowlelgeAddressInternational: 'The entered address could not be found. By selecting "Yes", you are acknowledging that your order may not be deliverable. It is your responsibility to provide an accurate address. Do you want to continue with this address?',
            securePrintInvalidAddressUS: 'You must provide a recognized US Postal Service address for Express Mail deliveries. The US Postal Service was unable to find the address you entered as deliverable. Please enter another address or change the delivery method to a non-Express Mail option if you need to use this address. Addresses on a university or college campus are controlled by the school and may not be registered with the US Postal Service. Please check with the recipient for an alternate or updated address.',
            securePrintInvalidAddressInternational: 'You must provide a recognized address for Express Mail deliveries. We are unable to find the address you entered as deliverable. Please enter another address or change the delivery method to a non-Express Mail option if you need to use this address. Addresses on a university or college campus are controlled by the school and may not be registered. Please check with the recipient for an alternate or updated address.',
        };
        this.invalidDeliveryMethodWarningMessageCertifiedMailUS = 'Certified Mail/United States cannot be delivered to your selected State/Territory/APO. If you wish to send your transcript to the selected state, please select \'Previous\' and request a different delivery method for this recipient address.';
        // messages
        this.warningLoseInformation = 'You will lose the information entered on this page. Are you sure you want to continue back?';
        this.zeroFeeTNDialogContent = {
            title: 'Tennessee Electronic Transcript Exchange',
            content: '<p>The fees have been waived for this recipient order under the Tennessee Electronic Transcript Exchange program.</p>'
        };
        this.partnerNetworkInfoDialogContent = '<div tabindex="0"><h3 class="mat-title"><b>Partner Network Program</b></h3>' +
            '<p>The fees have been waived for this order under University of Phoenix network partner program.</p></div>';
        // value that triggers an electronic delivery method (route and display values);
        this.electronicDeliveryTypes = [this.api.electronic, this.api.etx];
        this.popupDialog = {
            okBtn: 'okBtnClicked',
        };
        // timeout values used when working with the loading indicator (progress-bar);
        this.loading = {
            delay: 2000,
            interval: 500
        };
        this.dateFormat = {
            fullDateTime: 'MM/DD/YYYY hh:mm:ss A',
            display: 'MM/DD/YYYY hh:mm A',
            input: 'MM/DD/YYYY',
            output: 'YYYY-MM-DD'
        };
        // international ZIP value to be used on POST;
        // also to be filtered out on the payment page when the user populates the form with saved data;
        this.defaultZip = 'N/A';
        this.creditCardRegEx = {
            americanExpress: new RegExp(/^3[47][0-9]{13}$/),
            dinersClub: new RegExp(/^3(?:0[0-5]|[68][0-9])[0-9]{11}$/),
            discover: new RegExp(/^6(?:011|5[0-9]{2})[0-9]{12}$/),
            jcb: new RegExp(/^(?:2131|1800|35\d{3})\d{11}$/),
            mastercard: new RegExp(/^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/),
            visa: new RegExp(/^4[0-9]{12}(?:[0-9]{3})?$/)
        };
        this.errorMessage = {
            orderReview: {
                noRecptSelected: 'You have not selected any recipients for your transcript(s).',
                maxRecptAllowed: 'You have reached the maximum number of recipients. Please complete your order.',
            }
        };
        this.chFlagOptions = [
            { value: 'P', name: 'Production Transcript Order' },
            { value: 'S', name: 'School Test Transcript Order' },
            { value: 'C', name: 'Clearinghouse Test Transcript Order' },
        ];
    }
    getServiceErrorMessage(item) {
        const subNetworkType = item === this.api.liason ? 'CAS' : item;
        const dialogContent = `<div class="row" tabindex="0">
        <div class="col-12">
        <h3>System Error</h3>
        <div class="mat-typography">
        <p> Please re-enter your ${subNetworkType} Transcript ID. We apologize for the inconvenience.</p>
        </div></div></div`;
        return dialogContent;
    }
    getQuantityFieldSuffix(quantity) {
        return (quantity === 1 ? ' Copy' : ' Copies');
    }
}
SharedCommonValues.ɵfac = function SharedCommonValues_Factory(t) { return new (t || SharedCommonValues)(); };
SharedCommonValues.ɵprov = ɵɵdefineInjectable({ token: SharedCommonValues, factory: SharedCommonValues.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(SharedCommonValues, [{
        type: Injectable
    }], null, null); })();

class ManageFields {
    disable(controls) {
        controls.forEach(control => {
            // disable the field, and then clear out any value;
            // clear out the value so if the field is shown again, it won't be shown with a selected value;
            control.setValue(null);
            control.disable();
        });
    }
    enable(controls) {
        controls.forEach(control => {
            // set the field as untouched so validatio doesn't automatically get applied (if no value is set);
            // without this, a newly enabled field may be shown with an error;
            // we dont want an error shown on fields that the user hasnt interacted with;
            // if a value is already defined, then it's ok to show a validation error;
            if (control.value === null || control.value === '') {
                control.markAsUntouched();
            }
            control.enable();
        });
    }
    reset(controls) {
        controls.forEach(control => {
            // the field is currently enabled;
            // we want to clear out any values, and prevent any error message from being displayed;
            control.markAsUntouched();
            control.setValue(null);
        });
    }
}
ManageFields.ɵfac = function ManageFields_Factory(t) { return new (t || ManageFields)(); };
ManageFields.ɵprov = ɵɵdefineInjectable({ token: ManageFields, factory: ManageFields.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(ManageFields, [{
        type: Injectable
    }], null, null); })();

class AutocompleteSearchService {
    constructor() {
        this.showAdvancedSearch = new EventEmitter();
        this.searchLinkLabelEmit = new EventEmitter();
        this.autocompleteLabelEmit = new EventEmitter();
        this.show = {
            AdvancedSearch: false
        };
    }
    setAutocompleteLabel(item) {
        this.autocompleteLabelEmit.emit(item);
    }
    setLinkLabel(val) {
        this.searchLinkLabelEmit.emit(val);
    }
    updateShowAdvancedSearch(val) {
        this.showAdvancedSearch.emit(val);
    }
}
AutocompleteSearchService.ɵfac = function AutocompleteSearchService_Factory(t) { return new (t || AutocompleteSearchService)(); };
AutocompleteSearchService.ɵprov = ɵɵdefineInjectable({ token: AutocompleteSearchService, factory: AutocompleteSearchService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(AutocompleteSearchService, [{
        type: Injectable
    }], function () { return []; }, null); })();

const _c0 = ["itemFilterInput"];
const _c1 = ["optionList"];
function FormFieldAutocompleteComponent_mat_card_5_mat_option_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "mat-option", 7);
    ɵɵlistener("click", function FormFieldAutocompleteComponent_mat_card_5_mat_option_3_Template_mat_option_click_0_listener() { ɵɵrestoreView(_r7); const option_r4 = ctx.$implicit; const ctx_r6 = ɵɵnextContext(2); return !option_r4.disabled && ctx_r6.selectOption(option_r4); })("mouseenter", function FormFieldAutocompleteComponent_mat_card_5_mat_option_3_Template_mat_option_mouseenter_0_listener($event) { ɵɵrestoreView(_r7); const i_r5 = ctx.index; const ctx_r8 = ɵɵnextContext(2); return ctx_r8.optionHoverHandler($event, i_r5); });
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const option_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵpropertyInterpolate2("id", "autocomplete-", ctx_r3.controlName, "-option-", i_r5, "");
    ɵɵproperty("disabled", option_r4.disabled)("ngClass", ctx_r3.optionClass(i_r5))("value", option_r4.schlName);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", option_r4.schlName, " ");
} }
function FormFieldAutocompleteComponent_mat_card_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-card", 4, 5);
    ɵɵelement(2, "div");
    ɵɵtemplate(3, FormFieldAutocompleteComponent_mat_card_5_mat_option_3_Template, 2, 6, "mat-option", 6);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵproperty("ngForOf", ctx_r1.values.autocomplete);
} }
class FormFieldAutocompleteComponent {
    constructor(sharedCommonValues, renderer, manageFields, autocompleteService) {
        this.sharedCommonValues = sharedCommonValues;
        this.renderer = renderer;
        this.manageFields = manageFields;
        this.autocompleteService = autocompleteService;
        this.loading = false;
        this.searchType = this.sharedCommonValues.autocomplete.searchType.startsWithSearch;
        this.minCharactersToTrigger = 2;
        this.unsubscribe$ = new Subject();
        this.focusTimeoutDelay = 250;
        this.highlightedItem = -1;
        this.show = {
            autocomplete: false,
            advancedSearch: false
        };
        this.values = {
            autocomplete: [] // options to display to the user;
        };
    }
    ngOnInit() {
        this.setLabel(true);
        this.configureAutocomplete();
        this.autocompleteService.autocompleteLabelEmit
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((val) => this.setLabel(val));
    }
    // on click outside of object hide option list
    ngAfterViewInit() {
        document.onclick = (args) => {
            let currentTarget = args.target.closest('mat-form-field, button');
            if (currentTarget === null) {
                this.onBlur();
                this.hideOptions();
            }
        };
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    configureAutocomplete() {
        fromEvent(this.itemFilterInput.nativeElement, 'keyup')
            .pipe(distinctUntilChanged())
            .subscribe((e) => {
            this.keyUpHandler(e);
        });
    }
    // set the label for the autocomplete;
    // since the autocomplete values come from an Ajax call, let the user know that loading is happening;
    setLabel(loading) {
        // control the number of periods after the label;
        // this will loop from 0 to 3 periods, to appear animated;
        let count = 0;
        const countMax = 3;
        // build the new label based on the count value;
        const setLabel = () => {
            let newLabel = this.labelSchoolLoading;
            if (count !== 0) {
                for (let index = 1; index <= count; index++) {
                    newLabel += '.';
                }
            }
            count = count === countMax ? 0 : count + 1;
            this.placeholder = newLabel;
        };
        // if loading, define the interval that will set the 'animated' label;
        // otherwise, clear the interval and set the loaded label;
        if (loading) {
            this.placeholder = this.labelSchoolLoading;
            this.loadingInterval = window.setInterval(setLabel, this.sharedCommonValues.loading.interval);
        }
        else {
            window.clearInterval(this.loadingInterval);
            this.placeholder = this.show.advancedSearch ? this.advancedContentData.advLabelSchoolLoaded : this.advancedContentData.defaultLabelSchoolLoaded;
        }
        this.autocompleteService.showAdvancedSearch
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((advancedSearchFlag) => {
            this.show.advancedSearch = advancedSearchFlag;
            this.setAdvancedSearchValues();
        });
    }
    setAdvancedSearchValues() {
        const autocompleteValues = this.getAutocompleteValues();
        // assigning the values
        this.placeholder = autocompleteValues.placeholder;
        this.searchType = autocompleteValues.searchType;
        this.minCharactersToTrigger = autocompleteValues.minCharactersToTrigger;
        this.manageFields.reset([this.group.controls.school]);
        this.group.controls.school.enable();
        // timeout makes sure that it is invoked after any other event has been triggered.
        // e.g. click events that need to run before the focus
        window.setTimeout(() => {
            try {
                this.renderer.selectRootElement(`#autocomplete-${this.controlName}-field`).focus();
            }
            catch (ignored) { }
        });
        this.autocompleteService.setLinkLabel(autocompleteValues.linkLabel);
    }
    getAutocompleteValues() {
        const autocompleteValues = {};
        autocompleteValues.placeholder = this.advancedContentData.defaultLabelSchoolLoaded;
        autocompleteValues.searchType = this.sharedCommonValues.autocomplete.searchType.startsWithSearch;
        autocompleteValues.minCharactersToTrigger = null;
        autocompleteValues.linkLabel = this.advancedContentData.defaultSearchLinkLabel;
        // setting advanced values for advanced search
        if (this.show.advancedSearch) {
            autocompleteValues.placeholder = this.advancedContentData.advLabelSchoolLoaded;
            autocompleteValues.searchType = this.sharedCommonValues.autocomplete.searchType.wildCardSearch;
            autocompleteValues.minCharactersToTrigger = 4;
            autocompleteValues.linkLabel = this.sharedCommonValues.autocomplete.custom.backSearchLinkLabel;
        }
        return autocompleteValues;
    }
    showOptions() {
        // I removed 'debounce' from the Event Observable and I am replicating it's behavior
        // with this inputTimeout timer object
        window.clearTimeout(this.inputTimeout);
        const value = this.itemFilterInput.nativeElement.value;
        this.highlightedItem = -1;
        if (value && value.length >= this.minCharactersToTrigger) {
            this.values.autocomplete = filter(this.options, (option) => {
                // create a list where the entered value matchs something in the name;
                if (this.searchType === this.sharedCommonValues.autocomplete.searchType.wildCardSearch) {
                    return option.schlName.toLowerCase().indexOf(value.toLowerCase()) > -1;
                }
                else if (this.searchType === this.sharedCommonValues.autocomplete.searchType.startsWithSearch) {
                    return option.schlName.toLowerCase().indexOf(value.toLowerCase()) === 0;
                }
                return option.schlName.toLowerCase().indexOf(value.toLowerCase()) === 0;
            });
            // push the 'not in list' option;
            if (this.notInList) {
                this.values.autocomplete.push(this.sharedCommonValues.autocomplete.notInList);
            }
            let injectSpacePoint = '.';
            if (this.prevAriaText) {
                injectSpacePoint = this.prevAriaText.slice(-1) === '.' ? ' ' : injectSpacePoint;
            }
            const ariaText = `This is an auto complete element and there are currently ${this.values.autocomplete.length}  ${this.values.autocomplete.length === 1 ? `result` : `results`}  available. Keyboard users, use the up and down arrows to select an option${injectSpacePoint}`;
            this.itemFilterInput.nativeElement.setAttribute('aria-label', ariaText);
            this.prevAriaText = ariaText;
            if (!this.notInList && this.values.autocomplete.length === 0) {
                this.values.autocomplete = [this.sharedCommonValues.autocomplete.noMatch];
                this.itemFilterInput.nativeElement.setAttribute('aria-label', this.sharedCommonValues.autocomplete.noMatch.schlName);
            }
            this.show.autocomplete = true;
        }
        // if the form is less than X characters, show nothing - not even an error message;
        else {
            this.values.autocomplete = [];
        }
    }
    hideOptions() {
        this.show.autocomplete = false;
        this.highlightedItem = -1;
        this.itemFilterInput.nativeElement.removeAttribute('aria-label');
    }
    // whenever an option of the form field is focused, clear any existing timeout, and show the autocomplete options;
    // so if the form field already has content in it on focus, options are shown;
    onFocus() {
        window.clearTimeout(this.focusTimeout);
        this.hideOptions();
        this.itemFilterInput.nativeElement.removeAttribute('aria-label');
    }
    // on leaving the input or option, start a timeout to hide the options;
    // we dont want to immediately hide the options because the user may be transitioning from the input to an option;
    // give the app time to manage that change in focus to options aren't hidden immediately on blur;
    onBlur() {
        this.focusTimeout = window.setTimeout(() => this.hideOptions(), this.focusTimeoutDelay);
    }
    blurInput() {
        console.debug('Focus is lost for the input field');
    }
    // on select of an option, set the input value and hide the options (since we no longer need them);
    // use the blur event to hide so there is a slight delay (so it is't jarring to the user);
    selectOption(item) {
        if (item) {
            this.group.controls[this.controlName].setValue(item.schlName);
            this.onBlur();
            this.hideOptions();
        }
    }
    // hovering on an option needs to overwrite whatever item was selected with the arrow keys
    optionHoverHandler(e, i) {
        this.highlightedItem = i;
        this.itemFilterInput.nativeElement.setAttribute('aria-label', this.values.autocomplete[i].schlName + ' not selected. ' + (i + 1) + ' of ' + this.values.autocomplete.length);
    }
    // sets the highlighted state for options
    optionClass(i) {
        if (i === this.highlightedItem) {
            return 'mat-selected';
        }
        return '';
    }
    // These two methods control scrolling. To make the scrolling work as expected, it gets a bit more
    // complicated than expected.
    scrollUpToOption(i) {
        const itemHeight = this.optionList.nativeElement.firstElementChild.offsetHeight;
        const oldScroll = this.optionList.nativeElement.scrollTop;
        const newScroll = i * itemHeight;
        this.optionList.nativeElement.scrollTop = oldScroll > newScroll ? newScroll : oldScroll;
    }
    scrollDownToOption(i) {
        const maxHeight = this.optionList.nativeElement.offsetHeight;
        const itemHeight = this.optionList.nativeElement.firstElementChild.offsetHeight;
        const oldScroll = this.optionList.nativeElement.scrollTop;
        const newScroll = (i - Math.floor(maxHeight / itemHeight) + 1) * itemHeight;
        this.optionList.nativeElement.scrollTop = oldScroll < newScroll ? newScroll : oldScroll;
    }
    // catch keyup events from the input field
    keyUpHandler(e) {
        if (this.show.autocomplete && this.values.autocomplete.length >= 1) {
            if (e.code === 'ArrowDown' || e.key === 'Down') {
                if (this.highlightedItem < this.values.autocomplete.length - 1) {
                    this.highlightedItem++;
                    // tslint:disable-next-line: max-line-length
                    this.itemFilterInput.nativeElement.setAttribute('aria-label', this.values.autocomplete[this.highlightedItem].schlName + ' not selected. ' + (this.highlightedItem + 1) + ' of ' + this.values.autocomplete.length);
                    if (this.highlightedItem > 4) {
                        setTimeout(() => { this.scrollDownToOption(this.highlightedItem); }, 200);
                        // window.setTimeout( this.scrollDownToOption(this.highlightedItem), 200);
                    }
                }
            }
            else if (e.code === 'ArrowUp' || e.key === 'Up') {
                if (this.highlightedItem > 0) {
                    this.highlightedItem--;
                    // tslint:disable-next-line:max-line-length
                    this.itemFilterInput.nativeElement.setAttribute('aria-label', this.values.autocomplete[this.highlightedItem].schlName + ' not selected. ' + (this.highlightedItem + 1) + ' of ' + this.values.autocomplete.length);
                    if (this.highlightedItem < this.values.autocomplete.length - 5) {
                        setTimeout(() => { this.scrollUpToOption(this.highlightedItem); }, 200);
                        // window.setTimeout(this.scrollUpToOption(this.highlightedItem), 200);
                    }
                }
            }
            else if (e.code === 'Enter' || e.key === 'Enter') {
                this.selectOption(this.values.autocomplete[this.highlightedItem]);
            }
            else {
                this.inputTimeout = window.setTimeout(() => this.showOptions(), this.inputTimeoutDelay);
            }
        }
        else {
            this.inputTimeout = window.setTimeout(() => this.showOptions(), this.inputTimeoutDelay);
        }
    }
}
FormFieldAutocompleteComponent.ɵfac = function FormFieldAutocompleteComponent_Factory(t) { return new (t || FormFieldAutocompleteComponent)(ɵɵdirectiveInject(SharedCommonValues), ɵɵdirectiveInject(Renderer2), ɵɵdirectiveInject(ManageFields), ɵɵdirectiveInject(AutocompleteSearchService)); };
FormFieldAutocompleteComponent.ɵcmp = ɵɵdefineComponent({ type: FormFieldAutocompleteComponent, selectors: [["ts-form-field-autocomplete"]], viewQuery: function FormFieldAutocompleteComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0, 3);
        ɵɵviewQuery(_c1, 3, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.itemFilterInput = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.optionList = _t.first);
    } }, inputs: { controlName: "controlName", group: "group", hint: "hint", idx: "idx", notInList: "notInList", options: "options", placeholder: "placeholder", loading: "loading", searchType: "searchType", minCharactersToTrigger: "minCharactersToTrigger", labelSchoolLoading: "labelSchoolLoading", advancedContentData: "advancedContentData" }, decls: 6, vars: 7, consts: [["appearance", "outline", 1, "nsc-ts-form-field-autocomplete", 3, "ngClass", "formGroup"], ["matInput", "", "autocomplete", "off", "type", "text", 3, "id", "formControlName", "placeholder", "focus", "click"], ["itemFilterInput", ""], ["role", "listbox", 4, "ngIf"], ["role", "listbox"], ["optionList", ""], [3, "id", "disabled", "ngClass", "value", "click", "mouseenter", 4, "ngFor", "ngForOf"], [3, "id", "disabled", "ngClass", "value", "click", "mouseenter"]], template: function FormFieldAutocompleteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-form-field", 0);
        ɵɵelementStart(1, "mat-label");
        ɵɵtext(2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "input", 1, 2);
        ɵɵlistener("focus", function FormFieldAutocompleteComponent_Template_input_focus_3_listener() { return ctx.onFocus(); })("click", function FormFieldAutocompleteComponent_Template_input_click_3_listener() { return ctx.blurInput(); });
        ɵɵelementEnd();
        ɵɵtemplate(5, FormFieldAutocompleteComponent_mat_card_5_Template, 4, 1, "mat-card", 3);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngClass", ctx.loading ? "nsc-ts-form-field-loading" : "")("formGroup", ctx.group);
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.placeholder);
        ɵɵadvance(1);
        ɵɵpropertyInterpolate1("id", "autocomplete-", ctx.controlName, "-field");
        ɵɵpropertyInterpolate("formControlName", ctx.controlName);
        ɵɵpropertyInterpolate("placeholder", ctx.placeholder);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.show.autocomplete);
    } }, directives: [MatFormField, NgClass, NgControlStatusGroup, FormGroupDirective, MatLabel, MatInput, DefaultValueAccessor, NgControlStatus, FormControlName, NgIf, MatCard, NgForOf, MatOption], styles: [".nsc-ts-form-field-autocomplete[_ngcontent-%COMP%]{width:100%}.nsc-ts-form-field-autocomplete[_ngcontent-%COMP%]   .mat-card[_ngcontent-%COMP%]{border:none;position:absolute;top:100%;width:100%;padding:0;z-index:1;max-height:256px;overflow:auto;-webkit-overflow-scrolling:touch}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(FormFieldAutocompleteComponent, [{
        type: Component,
        args: [{
                selector: 'ts-form-field-autocomplete',
                templateUrl: './form-field-autocomplete.component.html',
                styleUrls: ['./form-field-autocomplete.component.scss']
            }]
    }], function () { return [{ type: SharedCommonValues }, { type: Renderer2 }, { type: ManageFields }, { type: AutocompleteSearchService }]; }, { controlName: [{
            type: Input
        }], group: [{
            type: Input
        }], hint: [{
            type: Input
        }], idx: [{
            type: Input
        }], notInList: [{
            type: Input
        }], options: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], loading: [{
            type: Input
        }], searchType: [{
            type: Input
        }], minCharactersToTrigger: [{
            type: Input
        }], labelSchoolLoading: [{
            type: Input
        }], advancedContentData: [{
            type: Input
        }], itemFilterInput: [{
            type: ViewChild,
            args: ['itemFilterInput', { static: true }]
        }], optionList: [{
            type: ViewChild,
            args: ['optionList', { read: ElementRef, static: true }]
        }] }); })();

class AdvancedLinkComponent {
    constructor(autocompleteSearchService) {
        this.autocompleteSearchService = autocompleteSearchService;
        this.searchLinkEmit = new EventEmitter();
        this.unsubscribe$ = new Subject();
        this.show = {
            advancedSearch: false
        };
    }
    ngOnInit() {
        this.autocompleteSearchService.searchLinkLabelEmit
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((val) => {
            this.searchLinkLabel = val;
        });
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    searchLinkAction(e) {
        this.show.advancedSearch = !(this.show.advancedSearch) ? true : false;
        this.autocompleteSearchService.updateShowAdvancedSearch(this.show.advancedSearch);
        e.preventDefault();
    }
}
AdvancedLinkComponent.ɵfac = function AdvancedLinkComponent_Factory(t) { return new (t || AdvancedLinkComponent)(ɵɵdirectiveInject(AutocompleteSearchService)); };
AdvancedLinkComponent.ɵcmp = ɵɵdefineComponent({ type: AdvancedLinkComponent, selectors: [["ts-advanced-link"]], inputs: { searchLinkLabel: "searchLinkLabel", decoratorType: "decoratorType" }, outputs: { searchLinkEmit: "searchLinkEmit" }, decls: 2, vars: 1, consts: function () { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_advancedSearchLink$$LIB_COMPONENTS_FORM_FIELD_AUTOCOMPLETE_ADVANCED_LINK_ADVANCED_LINK_COMPONENT_TS_1 = goog.getMsg(" {$interpolation} ", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_0 = MSG_EXTERNAL_advancedSearchLink$$LIB_COMPONENTS_FORM_FIELD_AUTOCOMPLETE_ADVANCED_LINK_ADVANCED_LINK_COMPONENT_TS_1;
    }
    else {
        i18n_0 = $localize `:@@advancedSearchLink␟2b58959c270d0d87bcc1169b058ac17e530c439a␟9220944426841146774: ${"\uFFFD0\uFFFD"}:INTERPOLATION: `;
    } return [["tabindex", "0", "href", "#", 1, "nsc-ts-advancedSearch-link", 3, "click"], i18n_0]; }, template: function AdvancedLinkComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "a", 0);
        ɵɵlistener("click", function AdvancedLinkComponent_Template_a_click_0_listener($event) { return ctx.searchLinkAction($event); });
        ɵɵi18n(1, 1);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵi18nExp(ctx.searchLinkLabel);
        ɵɵi18nApply(1);
    } }, styles: [".nsc-ts-advancedSearch-link[_ngcontent-%COMP%]{text-decoration:underline}.nsc-ts-advancedSearch-link[_ngcontent-%COMP%]:hover{cursor:pointer}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(AdvancedLinkComponent, [{
        type: Component,
        args: [{
                selector: 'ts-advanced-link',
                templateUrl: './advanced-link.component.html',
                styleUrls: ['./advanced-link.component.scss']
            }]
    }], function () { return [{ type: AutocompleteSearchService }]; }, { searchLinkLabel: [{
            type: Input
        }], decoratorType: [{
            type: Input
        }], searchLinkEmit: [{
            type: Output
        }] }); })();

// import {
//  // MatIconModule,
//  // MatButtonToggleModule,
//   // MatDialogModule,
//  // MatButtonModule,
//   // MatCardModule,
//   // MatFormFieldModule,
//   // MatInputModule,
//   // MatSelectModule,
//   // MatRadioModule,
//   // MatSlideToggleModule,
//   // MatCheckboxModule,
//   // MatDatepickerModule,
//   // MatNativeDateModule,
//   // MatTableModule,
//   MatAutocompleteModule,
//   MatSliderModule,
//   MatMenuModule,
//   MatSidenavModule,
//   MatToolbarModule,
//   MatListModule,
//   MatGridListModule,
//   MatStepperModule,
//   MatTabsModule,
//   MatExpansionModule,
//   MatChipsModule,
//   MatProgressSpinnerModule,
//   MatProgressBarModule,
//   MatTooltipModule,
//   MatSnackBarModule,
//   // MatSortModule,
//   // MatPaginatorModule
// } from '@angular/material';
class MaterialModule {
}
MaterialModule.ɵfac = function MaterialModule_Factory(t) { return new (t || MaterialModule)(); };
MaterialModule.ɵmod = ɵɵdefineNgModule({ type: MaterialModule });
MaterialModule.ɵinj = ɵɵdefineInjector({ imports: [[
            BrowserAnimationsModule,
            MatButtonModule,
            MatButtonToggleModule,
            MatCardModule,
            MatCheckboxModule,
            MatDatepickerModule,
            MatDialogModule,
            MatFormFieldModule,
            MatIconModule,
            MatInputModule,
            MatNativeDateModule,
            MatPaginatorModule,
            MatRadioModule,
            MatSelectModule,
            MatSlideToggleModule,
            MatTableModule,
            MatSortModule
        ], MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatRadioModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatTableModule,
        MatSortModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(MaterialModule, { imports: [BrowserAnimationsModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatRadioModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatTableModule,
        MatSortModule], exports: [MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatRadioModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatTableModule,
        MatSortModule] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(MaterialModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    BrowserAnimationsModule,
                    MatButtonModule,
                    MatButtonToggleModule,
                    MatCardModule,
                    MatCheckboxModule,
                    MatDatepickerModule,
                    MatDialogModule,
                    MatFormFieldModule,
                    MatIconModule,
                    MatInputModule,
                    MatNativeDateModule,
                    MatPaginatorModule,
                    MatRadioModule,
                    MatSelectModule,
                    MatSlideToggleModule,
                    MatTableModule,
                    MatSortModule
                ],
                exports: [
                    MatButtonModule,
                    MatButtonToggleModule,
                    MatCardModule,
                    MatCheckboxModule,
                    MatDatepickerModule,
                    MatDialogModule,
                    MatFormFieldModule,
                    MatIconModule,
                    MatInputModule,
                    MatNativeDateModule,
                    MatPaginatorModule,
                    MatRadioModule,
                    MatSelectModule,
                    MatSlideToggleModule,
                    MatTableModule,
                    MatSortModule
                ]
            }]
    }], null, null); })();

class FormFieldAutocompleteModule {
}
FormFieldAutocompleteModule.ɵfac = function FormFieldAutocompleteModule_Factory(t) { return new (t || FormFieldAutocompleteModule)(); };
FormFieldAutocompleteModule.ɵmod = ɵɵdefineNgModule({ type: FormFieldAutocompleteModule });
FormFieldAutocompleteModule.ɵinj = ɵɵdefineInjector({ providers: [SharedCommonValues, ManageFields, AutocompleteSearchService], imports: [[
            BrowserAnimationsModule,
            BrowserModule,
            CommonModule,
            MaterialModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(FormFieldAutocompleteModule, { declarations: [FormFieldAutocompleteComponent, AdvancedLinkComponent], imports: [BrowserAnimationsModule,
        BrowserModule,
        CommonModule,
        MaterialModule,
        ReactiveFormsModule], exports: [FormFieldAutocompleteComponent, AdvancedLinkComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(FormFieldAutocompleteModule, [{
        type: NgModule,
        args: [{
                declarations: [FormFieldAutocompleteComponent, AdvancedLinkComponent],
                imports: [
                    BrowserAnimationsModule,
                    BrowserModule,
                    CommonModule,
                    MaterialModule,
                    ReactiveFormsModule
                ],
                providers: [SharedCommonValues, ManageFields, AutocompleteSearchService],
                exports: [FormFieldAutocompleteComponent, AdvancedLinkComponent]
            }]
    }], null, null); })();

function DialogAddresValidationComponent_div_4_div_1_br_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "br");
} }
function DialogAddresValidationComponent_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 10);
    ɵɵelementStart(1, "p");
    ɵɵelementStart(2, "strong");
    ɵɵi18n(3, 11);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "button", 12);
    ɵɵlistener("click", function DialogAddresValidationComponent_div_4_div_1_Template_button_click_4_listener() { ɵɵrestoreView(_r10); const ctx_r9 = ɵɵnextContext(2); return ctx_r9.dialogRef.close(ctx_r9.correctedAddressValues); });
    ɵɵtext(5);
    ɵɵtemplate(6, DialogAddresValidationComponent_div_4_div_1_br_6_Template, 1, 0, "br", 13);
    ɵɵtext(7);
    ɵɵelement(8, "br");
    ɵɵtext(9);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵadvance(5);
    ɵɵtextInterpolate1(" ", ctx_r5.correctedAddressValues.delivery_line_1 || ctx_r5.correctedAddressValues.address1, " ");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r5.correctedAddressValues.delivery_line_2 || ctx_r5.correctedAddressValues.address2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r5.correctedAddressValues.delivery_line_2 || ctx_r5.correctedAddressValues.address2, " ");
    ɵɵadvance(2);
    ɵɵtextInterpolate3(" ", ctx_r5.correctedAddressValues.components.city_name || ctx_r5.correctedAddressValues.components.locality, ",", ctx_r5.correctedAddressValues.components.state_abbreviation || ctx_r5.correctedAddressValues.components.administrative_area, " ", ctx_r5.correctedAddressValues.components.postal_code || ctx_r5.correctedAddressValues.components.zipcode + (ctx_r5.correctedAddressValues.components.plus4_code ? "-" + ctx_r5.correctedAddressValues.components.plus4_code : ""), " ");
} }
function DialogAddresValidationComponent_div_4_div_2_br_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "br");
} }
function DialogAddresValidationComponent_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 14);
    ɵɵelementStart(1, "strong");
    ɵɵi18n(2, 15);
    ɵɵelementEnd();
    ɵɵelement(3, "br");
    ɵɵelementStart(4, "p", 16);
    ɵɵtext(5);
    ɵɵtemplate(6, DialogAddresValidationComponent_div_4_div_2_br_6_Template, 1, 0, "br", 13);
    ɵɵtext(7);
    ɵɵelement(8, "br");
    ɵɵtext(9);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext(2);
    ɵɵadvance(5);
    ɵɵtextInterpolate1(" ", ctx_r6.enteredAddress.request.street, " ");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r6.enteredAddress.request.street2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r6.enteredAddress.request.street2, " ");
    ɵɵadvance(2);
    ɵɵtextInterpolate3(" ", ctx_r6.enteredAddress.request.city, " ", ctx_r6.enteredAddress.request.state, " ", ctx_r6.enteredAddress.request.zipcode, "");
} }
function DialogAddresValidationComponent_div_4_div_3_br_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "br");
} }
function DialogAddresValidationComponent_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 14);
    ɵɵelementStart(1, "p");
    ɵɵelementStart(2, "strong");
    ɵɵi18n(3, 17);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "button", 18);
    ɵɵlistener("click", function DialogAddresValidationComponent_div_4_div_3_Template_button_click_4_listener() { ɵɵrestoreView(_r14); const ctx_r13 = ɵɵnextContext(2); return ctx_r13.dialogRef.close(ctx_r13.enteredAddress); });
    ɵɵtext(5);
    ɵɵtemplate(6, DialogAddresValidationComponent_div_4_div_3_br_6_Template, 1, 0, "br", 13);
    ɵɵtext(7);
    ɵɵelement(8, "br");
    ɵɵtext(9);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵɵnextContext(2);
    ɵɵadvance(5);
    ɵɵtextInterpolate1(" ", ctx_r7.enteredAddress.request.street, " ");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r7.enteredAddress.request.street2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r7.enteredAddress.request.street2, " ");
    ɵɵadvance(2);
    ɵɵtextInterpolate3(" ", ctx_r7.enteredAddress.request.city, " ", ctx_r7.enteredAddress.request.state, " ", ctx_r7.enteredAddress.request.zipcode, " ");
} }
function DialogAddresValidationComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 8);
    ɵɵtemplate(1, DialogAddresValidationComponent_div_4_div_1_Template, 10, 6, "div", 9);
    ɵɵtemplate(2, DialogAddresValidationComponent_div_4_div_2_Template, 10, 6, "div", 4);
    ɵɵtemplate(3, DialogAddresValidationComponent_div_4_div_3_Template, 10, 6, "div", 4);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.show.suggestedAddress);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.show.suggestedAddress && ctx_r0.continueOnlyWithValidAddress);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.show.suggestedAddress && ctx_r0.show.enteredAddress);
} }
function DialogAddresValidationComponent_div_5_br_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "br");
} }
function DialogAddresValidationComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 14);
    ɵɵelement(1, "ts-spacer", 5);
    ɵɵelementStart(2, "strong");
    ɵɵi18n(3, 19);
    ɵɵelementEnd();
    ɵɵelement(4, "br");
    ɵɵelementStart(5, "p", 16);
    ɵɵtext(6);
    ɵɵtemplate(7, DialogAddresValidationComponent_div_5_br_7_Template, 1, 0, "br", 13);
    ɵɵtext(8);
    ɵɵelement(9, "br");
    ɵɵtext(10);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(6);
    ɵɵtextInterpolate1(" ", ctx_r1.enteredAddress.request.street, " ");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.enteredAddress.request.street2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r1.enteredAddress.request.street2, " ");
    ɵɵadvance(2);
    ɵɵtextInterpolate3(" ", ctx_r1.enteredAddress.request.city, " ", ctx_r1.enteredAddress.request.state, " ", ctx_r1.enteredAddress.request.zipcode, " ");
} }
function DialogAddresValidationComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 14);
    ɵɵelementStart(1, "mat-form-field");
    ɵɵelementStart(2, "input", 20);
    ɵɵlistener("ngModelChange", function DialogAddresValidationComponent_div_6_Template_input_ngModelChange_2_listener($event) { ɵɵrestoreView(_r17); const ctx_r16 = ɵɵnextContext(); return ctx_r16.secondaryNbr = $event; });
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(3, "button", 21);
    ɵɵi18n(4, 22);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("ngModel", ctx_r2.secondaryNbr);
    ɵɵadvance(1);
    ɵɵproperty("disabled", !ctx_r2.secondaryNbr)("mat-dialog-close", ctx_r2.secondaryNbr);
} }
function DialogAddresValidationComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 23);
    ɵɵlistener("click", function DialogAddresValidationComponent_button_8_Template_button_click_0_listener() { ɵɵrestoreView(_r19); const ctx_r18 = ɵɵnextContext(); return ctx_r18.dialogRef.close(false); });
    ɵɵi18n(1, 24);
    ɵɵelementEnd();
} }
function DialogAddresValidationComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 25);
    ɵɵelementStart(1, "button", 26);
    ɵɵlistener("click", function DialogAddresValidationComponent_div_9_Template_button_click_1_listener() { ɵɵrestoreView(_r21); const ctx_r20 = ɵɵnextContext(); return ctx_r20.dialogRef.close(false); });
    ɵɵi18n(2, 27);
    ɵɵelementEnd();
    ɵɵelementStart(3, "button", 28);
    ɵɵlistener("click", function DialogAddresValidationComponent_div_9_Template_button_click_3_listener() { ɵɵrestoreView(_r21); const ctx_r22 = ɵɵnextContext(); return ctx_r22.dialogRef.close(true); });
    ɵɵi18n(4, 29);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
class DialogAddresValidationComponent {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
        this.show = {
            suggestedAddress: true,
            enteredAddress: true
        };
        this.correctedAddressValues = {};
    }
    ngOnInit() {
        this.correctedAddressValues = this.correctedAddress ? this.correctedAddress : this.correctedInternationalAddress;
        if (this.correctedAddress) {
            this.correctedAddressValues.delivery_line_1 = this.correctedAddress.delivery_line_1 ? this.correctedAddress.delivery_line_1 : '';
            this.correctedAddressValues.delivery_line_2 = this.correctedAddress.delivery_line_2;
        }
        else if (this.correctedInternationalAddress) {
            this.correctedAddressValues.address1 = this.correctedInternationalAddress.address1 ? this.correctedInternationalAddress.address1 : '';
        }
    }
    selectAddress(chosenAddress) {
        this.dialogRef.close(chosenAddress);
    }
    isNullorBlank(text) {
        if (typeof text !== 'undefined' && text !== ' ' && text) {
            return false;
        }
        return true;
    }
}
DialogAddresValidationComponent.ɵfac = function DialogAddresValidationComponent_Factory(t) { return new (t || DialogAddresValidationComponent)(ɵɵdirectiveInject(MatDialogRef)); };
DialogAddresValidationComponent.ɵcmp = ɵɵdefineComponent({ type: DialogAddresValidationComponent, selectors: [["ts-dialog-addres-validation"]], decls: 10, vars: 7, consts: function () { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_adv_address_validation_message$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS_1 = goog.getMsg("{$interpolation}", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_0 = MSG_EXTERNAL_adv_address_validation_message$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS_1;
    }
    else {
        i18n_0 = $localize `:@@adv-address-validation-message␟6996776108b0dc176a2ea0ea9999aaf8ffcba080␟5788796435152802452:${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
    } let i18n_2; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_adv_instructional_text$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS_3 = goog.getMsg("{$interpolation}", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_2 = MSG_EXTERNAL_adv_instructional_text$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS_3;
    }
    else {
        i18n_2 = $localize `:@@adv-instructional-text␟87221351339796b2bff07c2b479822f327ad5c8a␟1125361748115977337:${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
    } let i18n_4; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_adv_suggested_address_title$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS___5 = goog.getMsg("Suggested Address");
        i18n_4 = MSG_EXTERNAL_adv_suggested_address_title$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS___5;
    }
    else {
        i18n_4 = $localize `:@@adv-suggested-address-title␟d1f2a5ffbea91ce5abd08c02032560c5d6cfd6b7␟3297814882498163758:Suggested Address`;
    } let i18n_6; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_adv_continue_only_valid_address_title$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS___7 = goog.getMsg("Entered Address");
        i18n_6 = MSG_EXTERNAL_adv_continue_only_valid_address_title$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS___7;
    }
    else {
        i18n_6 = $localize `:@@adv-continue-only-valid-address-title␟77bd60ed4ff1f6410579c6d7b9c6cbf782d2783f␟7604840241152764510:Entered Address`;
    } let i18n_8; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_adv_suggested_entered_address_title$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS___9 = goog.getMsg("Entered Address");
        i18n_8 = MSG_EXTERNAL_adv_suggested_entered_address_title$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS___9;
    }
    else {
        i18n_8 = $localize `:@@adv-suggested-entered-address-title␟77bd60ed4ff1f6410579c6d7b9c6cbf782d2783f␟7604840241152764510:Entered Address`;
    } let i18n_10; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_adv_entered_address_title$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS__11 = goog.getMsg("Entered Address");
        i18n_10 = MSG_EXTERNAL_adv_entered_address_title$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS__11;
    }
    else {
        i18n_10 = $localize `:@@adv-entered-address-title␟77bd60ed4ff1f6410579c6d7b9c6cbf782d2783f␟7604840241152764510:Entered Address`;
    } let i18n_12; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_adv_address_validation_submit_btn$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS__13 = goog.getMsg("Submit");
        i18n_12 = MSG_EXTERNAL_adv_address_validation_submit_btn$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS__13;
    }
    else {
        i18n_12 = $localize `:@@adv-address-validation-submit-btn␟71c77bb8cecdf11ec3eead24dd1ba506573fa9cd␟935187492052582731:Submit`;
    } let i18n_14; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_adv_address_validation_change_suggested_btn$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS__15 = goog.getMsg("Edit Address");
        i18n_14 = MSG_EXTERNAL_adv_address_validation_change_suggested_btn$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS__15;
    }
    else {
        i18n_14 = $localize `:@@adv-address-validation-change-suggested-btn␟09f19a1d7e6de05e08a73d9910ec74a45f9a611e␟1470121978970986760:Edit Address`;
    } let i18n_16; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_adv_address_validation_edit_address$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS__17 = goog.getMsg("Edit Address");
        i18n_16 = MSG_EXTERNAL_adv_address_validation_edit_address$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS__17;
    }
    else {
        i18n_16 = $localize `:@@adv-address-validation-edit-address␟09f19a1d7e6de05e08a73d9910ec74a45f9a611e␟1470121978970986760:Edit Address`;
    } let i18n_18; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_adv_address_validation_use_entered_btn$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS__19 = goog.getMsg("Use Entered Address");
        i18n_18 = MSG_EXTERNAL_adv_address_validation_use_entered_btn$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_DIALOG_ADDRES_VALIDATION_DIALOG_ADDRES_VALIDATION_COMPONENT_TS__19;
    }
    else {
        i18n_18 = $localize `:@@adv-address-validation-use-entered-btn␟468fd484681062d4cd19f0b1ff31b630ead2bc41␟559675426555320463:Use Entered Address`;
    } return [[1, "break-word"], i18n_0, i18n_2, ["class", "row", 4, "ngIf"], ["class", "col-6", 4, "ngIf"], ["size", "sm"], ["color", "primary", "id", "adv-address-validation-change-suggested-btn", "mat-stroked-button", "", "color", "primary", "class", "nsc-button", "type", "button", 3, "click", 4, "ngIf"], ["class", "mat-dialog-actions", 4, "ngIf"], [1, "row"], ["class", "addressMargin", 4, "ngIf"], [1, "addressMargin"], i18n_4, ["id", "adv-suggested-address-option", "mat-stroked-button", "", "color", "primary", "type", "button", 1, "nsc-button", "addressButton", 3, "click"], [4, "ngIf"], [1, "col-6"], i18n_6, [1, "m-sm"], i18n_8, ["id", "adv-suggested-entered-address-option", "mat-stroked-button", "", "color", "primary", "type", "button", 1, "nsc-button", "addressButton", 3, "click"], i18n_10, ["id", "adv-address-validation-change-apt", "matInput", "", "placeholder", "Correct your Apt/Suite Number", 3, "ngModel", "ngModelChange"], ["id", "adv-address-validation-submit-btn", "mat-stroked-button", "", "color", "primary", "type", "button", "cdkFocusInitial", "", 1, "nsc-button", 3, "disabled", "mat-dialog-close"], i18n_12, ["color", "primary", "id", "adv-address-validation-change-suggested-btn", "mat-stroked-button", "", "color", "primary", "type", "button", 1, "nsc-button", 3, "click"], i18n_14, [1, "mat-dialog-actions"], ["mat-stroked-button", "", "color", "primary", "id", "adv-address-validation-edit-address-btn", "type", "button", 1, "nsc-button", 3, "click"], i18n_16, ["mat-stroked-button", "", "color", "primary", "id", "adv-address-validation-use-entered-btn", "type", "button", 1, "nsc-button", 3, "click"], i18n_18]; }, template: function DialogAddresValidationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "p", 0);
        ɵɵi18n(1, 1);
        ɵɵelementEnd();
        ɵɵelementStart(2, "p", 0);
        ɵɵi18n(3, 2);
        ɵɵelementEnd();
        ɵɵtemplate(4, DialogAddresValidationComponent_div_4_Template, 4, 3, "div", 3);
        ɵɵtemplate(5, DialogAddresValidationComponent_div_5_Template, 11, 6, "div", 4);
        ɵɵtemplate(6, DialogAddresValidationComponent_div_6_Template, 5, 3, "div", 4);
        ɵɵelement(7, "ts-spacer", 5);
        ɵɵtemplate(8, DialogAddresValidationComponent_button_8_Template, 2, 0, "button", 6);
        ɵɵtemplate(9, DialogAddresValidationComponent_div_9_Template, 5, 0, "div", 7);
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵi18nExp(ctx.addressValidationMessage);
        ɵɵi18nApply(1);
        ɵɵadvance(2);
        ɵɵi18nExp(ctx.instructionalText);
        ɵɵi18nApply(3);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.addressCorrected);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.addressCorrected && ctx.show.enteredAddress && !ctx.missingSecondary);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.missingSecondary);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.show.suggestedAddress && ctx.continueOnlyWithValidAddress);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.addressCorrected);
    } }, directives: [NgIf, SpacerComponent, MatButton, MatFormField, MatInput, DefaultValueAccessor, NgControlStatus, NgModel, MatDialogClose], styles: [".education-solutions-theme[_ngcontent-%COMP%]{--brand-color-1:#437c2b;--brand-color-2:#273f21;--brand-color-3:#6db944;--brand-color-4:#599a38;--brand-color-5:#e2f1da;--brand-color-6:rgba(109,185,68,0.2);--brand-color-7:#f3f9f0;--brand-color-8:rgba(109,185,68,0.08)}.addressDisplay[_ngcontent-%COMP%]{display:flex;flex-direction:column}@media (min-width:768px){.addressDisplay[_ngcontent-%COMP%]{flex-direction:row}}.m-sm[_ngcontent-%COMP%]{margin-left:0}.break-word[_ngcontent-%COMP%]{word-break:break-word;width:430px}p[_ngcontent-%COMP%]{margin:5px}.addressMargin[_ngcontent-%COMP%]{margin-left:20px}.h3[_ngcontent-%COMP%]{margin-bottom:10px}.center[_ngcontent-%COMP%]{text-align:center;margin:5px;border:1px solid #444}.addressButton[_ngcontent-%COMP%]{line-height:22px;padding:5px;text-align:left}strong[_ngcontent-%COMP%]{font-weight:600;font-style:normal;color:#000}p[_ngcontent-%COMP%]   .upper[_ngcontent-%COMP%]{margin-right:5px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(DialogAddresValidationComponent, [{
        type: Component,
        args: [{
                selector: 'ts-dialog-addres-validation',
                templateUrl: './dialog-addres-validation.component.html',
                styleUrls: ['./dialog-addres-validation.component.scss']
            }]
    }], function () { return [{ type: MatDialogRef }]; }, null); })();

class VerifyAddressService {
    constructor(http) {
        this.http = http;
        this.verifyUSURL = 'https://us-street.api.smartystreets.com/street-address?';
        this.verifyINTURL = 'https://international-street.api.smartystreets.com/verify?';
    }
    setAddressValidationKey(addressKey) {
        this.websiteKey = addressKey;
    }
    verifyInternationalAddress(addressToBeVerified) {
        const url = `${this.verifyINTURL}auth-id=${this.websiteKey}&${this.serialize(addressToBeVerified)}`;
        const usAddressUrl = url + '&geocode=true';
        return this.http.get(usAddressUrl).pipe(tap(json => json));
    }
    verifyAddress(addressToBeVerified) {
        const url = `${this.verifyUSURL}auth-id=${this.websiteKey}&${this.serialize(addressToBeVerified)}`;
        const usAddressUrl = url + '&candidates=2&geocode=true&match=invalid';
        // const addressQry = 'https://us-street.api.smartystreets.com/street-address?auth-id=31008886784763106&city=Herndon&state=VA&street=2300%20Dulles%20Corner%20Ln&country=US&candidates=2&geocode=true&match=strict';
        return this.http.get(usAddressUrl).pipe(tap(json => json));
    }
    serialize(obj, prefix) {
        const str = [];
        let p;
        for (p in obj) {
            if (obj.hasOwnProperty(p)) {
                const k = prefix ? prefix + '[' + p + ']' : p;
                const v = obj[p];
                if (v) {
                    str.push(v !== null && typeof v === 'object' ? this.serialize(v, k) : k + '=' + encodeURIComponent(v));
                }
            }
        }
        return str.join('&');
    }
}
VerifyAddressService.ɵfac = function VerifyAddressService_Factory(t) { return new (t || VerifyAddressService)(ɵɵinject(HttpClient)); };
VerifyAddressService.ɵprov = ɵɵdefineInjectable({ token: VerifyAddressService, factory: VerifyAddressService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(VerifyAddressService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: HttpClient }]; }, null); })();

class ValidationMessage {
    get(formField, label) {
        // if no errors, do nothing;
        // if errors, check properties to determine which message to show;
        // only a single message is displayed at a time, so the order of the IF statements is important;
        if (isEmpty(formField.errors) === false) {
            const errors = formField.errors;
            let message = `${label} is required`; // default error message;
            if (errors.casId ||
                errors.creditCardNumber ||
                errors.dateCompare ||
                errors.dateCreditCard ||
                errors.dateOfBirth ||
                errors.email ||
                errors.invalid ||
                errors.max ||
                errors.min ||
                errors.minlength ||
                errors.pattern ||
                errors.studentIdPrimary) {
                message = `Invalid ${label}`;
                if (errors.minlength && errors.studentIdPrimary) {
                    message = `Required length is ${errors.minlength.requiredLength}`;
                }
            }
            if (errors.dateOutOfRange) {
                message = 'Invalid Date Range';
            }
            if (errors.schoolAutocomplete) {
                message = 'There is no match for the school entered';
            }
            // will always win out due to being run after all previous form validation;
            if (errors.match) {
                message = `This does not match ${label.replace('Confirm', '')}`;
            }
            return message;
        }
    }
}
ValidationMessage.ɵfac = function ValidationMessage_Factory(t) { return new (t || ValidationMessage)(); };
ValidationMessage.ɵprov = ɵɵdefineInjectable({ token: ValidationMessage, factory: ValidationMessage.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(ValidationMessage, [{
        type: Injectable
    }], null, null); })();

const _c0$1 = ["itemFilterInput"];
const _c1$1 = ["optionList"];
function FormFieldAddressAutocompleteComponent_mat_card_3_mat_option_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "mat-option", 8);
    ɵɵlistener("click", function FormFieldAddressAutocompleteComponent_mat_card_3_mat_option_2_Template_mat_option_click_0_listener() { ɵɵrestoreView(_r9); const option_r6 = ctx.$implicit; const ctx_r8 = ɵɵnextContext(2); return !option_r6.disabled && ctx_r8.selectOption(option_r6); })("mouseenter", function FormFieldAddressAutocompleteComponent_mat_card_3_mat_option_2_Template_mat_option_mouseenter_0_listener($event) { ɵɵrestoreView(_r9); const i_r7 = ctx.index; const ctx_r10 = ɵɵnextContext(2); return ctx_r10.optionHoverHandler($event, i_r7); });
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const option_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵproperty("disabled", option_r6.disabled)("ngClass", ctx_r5.optionClass(i_r7))("value", option_r6.text);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", option_r6.text, " ");
} }
function FormFieldAddressAutocompleteComponent_mat_card_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-card", null, 6);
    ɵɵtemplate(2, FormFieldAddressAutocompleteComponent_mat_card_3_mat_option_2_Template, 2, 4, "mat-option", 7);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", ctx_r1.values.autocomplete);
} }
function FormFieldAddressAutocompleteComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵi18nStart(0, 4, 1);
    ɵɵelement(1, "span", 9);
    ɵɵi18nEnd();
} }
function FormFieldAddressAutocompleteComponent_mat_error_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-error");
    ɵɵi18n(1, 10);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵattribute("aria-label", ctx_r3.content.errorMessage);
    ɵɵadvance(1);
    ɵɵi18nExp(ctx_r3.setErrorMessage(ctx_r3.group.controls[ctx_r3.controlName], ctx_r3.placeholder));
    ɵɵi18nApply(1);
} }
class FormFieldAddressAutocompleteComponent {
    constructor(sharedCommonValues, verifyUsService, dialog, validationMessage) {
        this.sharedCommonValues = sharedCommonValues;
        this.verifyUsService = verifyUsService;
        this.dialog = dialog;
        this.validationMessage = validationMessage;
        this.required = true;
        this.loading = false;
        this.searchType = this.sharedCommonValues.autocomplete.searchType.startsWithSearch;
        this.minCharactersToTrigger = 5;
        this.continueOnlyWithValidAddress = false;
        this.isExpressSecurePrint = false;
        this.validateInternationAddressKey = true;
        this.emitFocusOnValidAddress = new EventEmitter();
        this.emitInternationalPremisePartialAddress = new EventEmitter();
        this.focusTimeoutDelay = 250;
        this.highlightedItem = -1;
        this.content = {
            hint: '',
            errorMessage: ''
        };
        this.show = {
            autocomplete: false,
            addressValidationDialogue: false
        };
        this.values = {
            autocomplete: [],
            addressIsValid: false,
            userUsedHisAddress: false,
            addressVerificationTriggered: false,
            invalidAddressErrorMessage: '',
            country: null,
            verificationServiceUnavailable: false,
            isPremisePartialAddress: false
        };
        this.addressValidationRequest = {
            request: {
                city: null,
                state: null,
                zipcode: null,
                street: null,
                street2: null,
                country: null
            }
        };
        this.missingSecondary = false;
        this.addressCorrected = false;
        this.enteredSecondaryNbr = null;
        this.unsubscribe$ = new Subject();
    }
    ngOnInit() {
        this.configureAutocomplete();
        this.setHint(this.hint, this.required);
    }
    ngOnChanges(changes) {
        const newHint = changes.hint ? changes.hint.currentValue : this.hint;
        const newRequired = changes.required ? changes.required.currentValue : this.required;
        this.setHint(newHint, newRequired);
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    configureAutocomplete() {
        fromEvent(this.itemFilterInput.nativeElement, 'keyup')
            .pipe(distinctUntilChanged())
            .subscribe((e) => {
            this.keyUpHandler(e);
        });
    }
    setAddressWebsiteKey(authKey) {
        this.verifyUsService.setAddressValidationKey(authKey);
    }
    setErrorMessage(controlName, placeholder) {
        const test = this.group.controls[controlName];
        this.content.errorMessage = this.validationMessage.get(controlName, placeholder);
        return (this.content.hint + this.content.errorMessage);
    }
    showAddressOptions() {
        // I removed 'debounce' from the Event Observable and I am replicating it's behavior
        // with this inputTimeout timer object
        window.clearTimeout(this.inputTimeout);
        const value = this.itemFilterInput.nativeElement.value;
        this.highlightedItem = -1;
        if (value && value.length >= this.minCharactersToTrigger) {
            if (this.options) {
                this.values.autocomplete = this.options['suggestions'];
                this.show.autocomplete = true;
            }
        } // if the form is less than X characters, show nothing - not even an error message;
        else {
            this.values.autocomplete = [];
        }
    }
    hideOptions() {
        this.show.autocomplete = false;
        this.highlightedItem = -1;
    }
    // whenever an option of the form field is focused, clear any existing timeout, and show the autocomplete options;
    // so if the form field already has content in it on focus, options are shown;
    onFocus() {
        window.clearTimeout(this.focusTimeout);
        this.showAddressOptions();
    }
    // on leaving the input or option, start a timeout to hide the options;
    // we dont want to immediately hide the options because the user may be transitioning from the input to an option;
    // give the app time to manage that change in focus to options aren't hidden immediately on blur;
    onBlur() {
        this.focusTimeout = window.setTimeout(() => this.hideOptions(), this.focusTimeoutDelay);
    }
    // on select of an option, set the input value and hide the options (since we no longer need them);
    // use the blur event to hide so there is a slight delay (so it is't jarring to the user);
    selectOption(item) {
        if (item) {
            this.group.controls['addressLine1'].setValue(item.street_line);
            this.group.controls['city'].setValue(item.city);
            this.group.controls['country'].setValue('US', { emitEvent: false });
            this.group.controls['state'].setValue(item.state);
            this.verifyEnteredAddress();
            this.onBlur();
        }
    }
    setHint(hint, required) {
        // if a field isn't required and it's optional, we need to combine the `hint` values;
        this.content.hint = `${hint || ''} ${required ? '' : '(Optional)'}`;
    }
    // hovering on an option needs to overwrite whatever item was selected with the arrow keys
    optionHoverHandler(e, i) {
        this.highlightedItem = i;
    }
    // sets the highlighted state for options
    optionClass(i) {
        if (i === this.highlightedItem) {
            return 'mat-selected';
        }
        return '';
    }
    // These two methods control scrolling. To make the scrolling work as expected, it gets a bit more
    // complicated than expected.
    scrollUpToOption(i) {
        const itemHeight = this.optionList.nativeElement.firstElementChild.offsetHeight;
        const oldScroll = this.optionList.nativeElement.scrollTop;
        const newScroll = i * itemHeight;
        this.optionList.nativeElement.scrollTop = oldScroll > newScroll ? newScroll : oldScroll;
    }
    scrollDownToOption(i) {
        const maxHeight = this.optionList.nativeElement.offsetHeight;
        const itemHeight = this.optionList.nativeElement.firstElementChild.offsetHeight;
        const oldScroll = this.optionList.nativeElement.scrollTop;
        const newScroll = (i - Math.floor(maxHeight / itemHeight) + 1) * itemHeight;
        this.optionList.nativeElement.scrollTop = oldScroll < newScroll ? newScroll : oldScroll;
    }
    // catch keyup events from the input field
    keyUpHandler(e) {
        if (this.show.autocomplete && this.values.autocomplete && this.values.autocomplete.length >= 1) {
            if (e.code === 'ArrowDown' || e.key === 'Down') {
                if (this.highlightedItem < this.values.autocomplete.length - 1) {
                    this.highlightedItem++;
                    if (this.highlightedItem > 4) {
                        setTimeout(() => {
                            this.scrollDownToOption(this.highlightedItem);
                        }, 200);
                        // window.setTimeout(this.scrollDownToOption(this.highlightedItem), 200);
                    }
                }
            }
            else if (e.code === 'ArrowUp' || e.key === 'Up') {
                if (this.highlightedItem > 0) {
                    this.highlightedItem--;
                    if (this.highlightedItem < this.values.autocomplete.length - 5) {
                        setTimeout(() => {
                            this.scrollUpToOption(this.highlightedItem);
                        }, 200);
                        // window.setTimeout(this.scrollUpToOption(this.highlightedItem), 200);
                    }
                }
            }
            else if (e.code === 'Enter' || e.key === 'Enter') {
                this.selectOption(this.values.autocomplete[this.highlightedItem]);
            }
            else {
                this.inputTimeout = window.setTimeout(() => this.showAddressOptions(), this.inputTimeoutDelay);
            }
        }
        else {
            this.inputTimeout = window.setTimeout(() => this.showAddressOptions(), this.inputTimeoutDelay);
        }
    }
    verifyEnteredAddress() {
        this.initAddressValidationRequest();
        this.show.addressValidationDialogue = true;
        this.values.userUsedHisAddress = false;
        this.values.addressIsValid = false;
        this.missingSecondary = false;
        this.addressCorrected = false;
        this.values.addressVerificationTriggered = true;
        if (this.addressValidationRequest.request.country === this.sharedCommonValues.api.us) {
            this.isThereEnoughInput();
            this.verifyUsService.verifyAddress(this.addressValidationRequest.request)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((response) => {
                this.usAddressValidationResponse = response;
                if (this.usAddressValidationResponse) {
                    this.verifyIfAddressIsValid(this.usAddressValidationResponse);
                }
            }, (error) => {
                this.values.verificationServiceUnavailable = true;
            });
        }
        else {
            // international address verification
            if (this.addressValidationRequest.request.country === this.sharedCommonValues.api.ca && (this.validateInternationAddressKey || this.validateInternationAddressKey === null)) {
                this.isThereEnoughInput();
                const addressToBeVerified = {};
                addressToBeVerified.country = this.addressValidationRequest.request.country;
                addressToBeVerified.address1 = this.addressValidationRequest.request.street;
                addressToBeVerified.address2 = this.addressValidationRequest.request.street2;
                addressToBeVerified.locality = this.addressValidationRequest.request.city;
                addressToBeVerified.administrative_area = this.addressValidationRequest.request.state;
                addressToBeVerified.postal_code = this.addressValidationRequest.request.zipcode;
                this.verifyUsService.verifyInternationalAddress(addressToBeVerified)
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((response) => {
                    this.intAddressValidationResponse = response;
                    if (this.intAddressValidationResponse) {
                        this.verifyIfInternationalAddressIsValid(this.intAddressValidationResponse);
                    }
                }, (error) => {
                    this.values.verificationServiceUnavailable = true;
                });
            }
            else {
                return;
            }
        }
        return;
    }
    verifyIfInternationalAddressIsValid(intAddressValidationResponse) {
        this.values.isPremisePartialAddress = false;
        this.emitInternationalPremisePartialAddress.next(false);
        const analysisAddress = intAddressValidationResponse[0].analysis;
        if (intAddressValidationResponse.length > 1) {
            if (analysisAddress.address_precision === 'Premise') {
                this.values.isPremisePartialAddress = true;
            }
            this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.addressAmbigousInternational);
        }
        else {
            // single match
            if (analysisAddress.verification_status === 'Verified' && (analysisAddress.address_precision === 'DeliveryPoint' || analysisAddress.address_precision === 'Premise') && analysisAddress.max_address_precision === 'DeliveryPoint') {
                this.validateInternationalAddress2(this.addressValidationRequest, intAddressValidationResponse[0]);
                // address is valid
                // // check if address has been formatted or modified from entered address
                if (this.addressUpdatedFromOriginal(this.addressValidationRequest, intAddressValidationResponse[0])) {
                    //   // address updated from original
                    this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.newInternationalAddressSuggested);
                    return;
                }
                this.setAddressValuesFromResponse(this.intAddressValidationResponse[0], true);
                this.values.addressIsValid = true;
                this.changeFocus();
                return;
            }
            else {
                // if invalid address
                this.values.addressIsValid = false;
                const isAnyAddressPrecision = this.getAllAddressPrecision(analysisAddress.address_precision);
                const isPartialAddress = analysisAddress.verification_status === 'Partial';
                const isVerifiedAddress = analysisAddress.verification_status === 'Verified';
                const isAmbiguousAddress = analysisAddress.verification_status === 'Ambiguous';
                const isPremiseAddressPrecision = analysisAddress.address_precision === 'Premise';
                // check premise/partial address for SP and NONSP
                if (isPartialAddress && isPremiseAddressPrecision) {
                    this.values.isPremisePartialAddress = true;
                    this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.secondaryAddress);
                    return;
                }
                // if it's express and security print order
                if (this.isExpressSecurePrint) {
                    if ((isPartialAddress || isVerifiedAddress || isAmbiguousAddress) && ((analysisAddress.address_precision === 'Thoroughfare') || (analysisAddress.address_precision === 'Locality') || (analysisAddress.address_precision === 'AdministrativeArea'))) {
                        this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.internationalCityNotFound);
                        return;
                    }
                }
                else {
                    // checks if it's not express order
                    if ((isPartialAddress || analysisAddress.verification_status === 'None') && ((analysisAddress.address_precision === 'Locality') || (analysisAddress.address_precision === 'AdministrativeArea') || (analysisAddress.address_precision === 'None'))) {
                        this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.internationalCityNotFound);
                        return;
                    }
                    else if ((isPartialAddress) && (analysisAddress.address_precision === 'Thoroughfare')) {
                        this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.internationalMissingStreetNumber);
                        return;
                    }
                    else if ((isVerifiedAddress) && (analysisAddress.address_precision === 'Thoroughfare')) {
                        this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.internationalMissingStreetNumber);
                        return;
                    }
                    else if ((isVerifiedAddress) && ((analysisAddress.address_precision === 'Locality') || (analysisAddress.address_precision === 'AdministrativeArea'))) {
                        this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.internationalCityNotFound);
                        return;
                    }
                }
                // if all the conditions above failed then show generic invalid address message
                this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.addressInvalid);
                return;
            }
        }
    }
    getAllAddressPrecision(addressPrecision) {
        return addressPrecision === 'Premise' || addressPrecision === 'Locality' || addressPrecision === 'Thoroughfare' || addressPrecision === 'AdministrativeArea' || addressPrecision === 'None';
    }
    validateInternationalAddress2(addressRequest, addressResponse) {
        // if user doesn't enter the street2  and response is equals to 'cityVarSrc + stateVar + zipVarSrc' no needs to
        const cityStateZipcodeResponse = (addressResponse.components.locality + addressResponse.components.administrative_area + addressResponse.components.postal_code).toLowerCase().replace(/\s+/g, '');
        const address2 = (addressResponse.address2).toLowerCase().replace(/\s+/g, '');
        if (address2 === cityStateZipcodeResponse) {
            addressResponse.address2 = addressRequest.request.street2 === null ? addressRequest.request.street2 : '';
        }
        else {
            let concatAddressess = '';
            Object.keys(addressResponse).forEach((item, i) => {
                if (item !== 'address1') {
                    if (item.includes('address')) {
                        const addressItem = (addressResponse[item]).toLowerCase().replace(/\s+/g, '');
                        if (addressItem !== cityStateZipcodeResponse) {
                            concatAddressess += addressResponse[item] + ' ';
                        }
                    }
                }
            });
            addressResponse.address2 = concatAddressess;
        }
    }
    verifyIfAddressIsValid(usAddressValidationResponse) {
        // more than one match then address is ambigous
        if (usAddressValidationResponse.length > 1) {
            this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.addressAmbigous);
            // open dialog to choose one of the option
        }
        else {
            // single match
            if (usAddressValidationResponse[0].analysis.dpv_match_code &&
                usAddressValidationResponse[0].analysis.dpv_match_code === 'Y' &&
                (usAddressValidationResponse[0].analysis.dpv_footnotes === 'AABB' ||
                    usAddressValidationResponse[0].analysis.dpv_footnotes === 'AAF1')) {
                // address is valid
                // check if address has been formatted or modified from entered address
                if (this.addressUpdatedFromOriginal(this.addressValidationRequest, usAddressValidationResponse[0])) {
                    // address updated from original
                    this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.newAddressSuggested);
                    return;
                }
                this.setAddressValuesFromResponse(this.usAddressValidationResponse[0], false);
                this.values.addressIsValid = true;
                this.changeFocus();
            }
            else if (usAddressValidationResponse[0].analysis.dpv_match_code &&
                usAddressValidationResponse[0].analysis.dpv_match_code === 'Y' &&
                usAddressValidationResponse[0].analysis.dpv_footnotes === 'AAU1') {
                // address is valid and matched unique zip code
                // check if address has been formatted or modified from entered address
                if (this.addressUpdatedFromOriginal(this.addressValidationRequest, usAddressValidationResponse[0])) {
                    // address updated from original
                    this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.newAddressSuggested);
                    return;
                }
                // setting unique address values
                this.setAddressValuesFromResponse(this.usAddressValidationResponse[0], false);
                this.values.addressIsValid = true;
                this.changeFocus();
            }
            else {
                // address is invalid
                this.values.addressIsValid = false;
                // check why is it invalid
                // missing primary
                if (usAddressValidationResponse[0].analysis.dpv_footnotes === 'AAM3') {
                    this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.missingPrimary);
                    return;
                }
                // missing primary building number
                if (usAddressValidationResponse[0].analysis.dpv_footnotes === 'A1M1') {
                    this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.missingPrimaryBuildingNumber);
                    return;
                }
                // city not found
                if (usAddressValidationResponse[0].analysis.dpv_footnotes === 'A1' &&
                    !this.isNullorBlank(usAddressValidationResponse[0].analysis.footnotes) &&
                    (usAddressValidationResponse[0].analysis.footnotes.includes('C#') || usAddressValidationResponse[0].analysis.footnotes.includes('F#'))) {
                    this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.cityNotFound);
                    return;
                }
                // missing secondary
                if (usAddressValidationResponse[0].analysis.dpv_footnotes === 'AAN1' ||
                    usAddressValidationResponse[0].analysis.dpv_footnotes === 'AACC' ||
                    (!this.isNullorBlank(usAddressValidationResponse[0].analysis.footnotes) &&
                        usAddressValidationResponse[0].analysis.footnotes.includes('H#'))) {
                    // this.missingSecondary = true;
                    this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.secondaryAddress);
                    return;
                }
                // missing secondary PO,RR or HC
                if (usAddressValidationResponse[0].analysis.dpv_footnotes === 'AAP1' ||
                    usAddressValidationResponse[0].analysis.dpv_footnotes === 'AAP3') {
                    // this.missingSecondary = true;
                    this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.ruralAddressMissingSecondaryNumber);
                    return;
                }
                // private mailbox could not be confirmed
                if (usAddressValidationResponse[0].analysis.dpv_footnotes === 'AABBR1') {
                    this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.privateMailBox);
                    return;
                }
                if (!this.isNullorBlank(usAddressValidationResponse[0].analysis.footnotes) && usAddressValidationResponse[0].analysis.footnotes.includes('I#')) {
                    this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.addressAmbigous);
                    return;
                }
                this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.addressInvalid);
                return;
            }
        }
    }
    // use the delivery lines provided by smart streets to set the address values.
    setAddressValuesFromResponse(response, isInternationalAddress) {
        const addressValues = {};
        if (!isInternationalAddress) {
            const newResponse = response;
            addressValues.addressLine1 = newResponse.delivery_line_1;
            addressValues.addressLine2 = newResponse.delivery_line_2 ? newResponse.delivery_line_2 : '';
            addressValues.city = newResponse.components.city_name;
            addressValues.state = newResponse.components.state_abbreviation;
            if (newResponse.components.zipcode) {
                addressValues.zipcode = newResponse.components.zipcode + ((newResponse.components.plus4_code ? '-' + newResponse.components.plus4_code : ''));
            }
        }
        else {
            const newResponse = response;
            addressValues.addressLine1 = newResponse.address1;
            addressValues.addressLine2 = newResponse.address2 ? newResponse.address2 : '';
            addressValues.city = newResponse.components.locality;
            addressValues.state = newResponse.components.administrative_area;
            if (newResponse.components.postal_code) {
                addressValues.zipcode = (newResponse.components.postal_code ? newResponse.components.postal_code : '');
            }
        }
        addressValues.addressLine1 = this.formatAddress(addressValues.addressLine1);
        addressValues.addressLine2 = this.formatAddress(addressValues.addressLine2);
        this.group.controls['addressLine1'].setValue(addressValues.addressLine1);
        this.group.controls['addressLine2'].setValue(addressValues.addressLine2);
        this.group.controls['city'].setValue(addressValues.city);
        // this.group.controls['country'].setValue(this.group.controls.country.value);
        this.group.controls['state'].setValue(addressValues.state);
        if (addressValues.zipcode) {
            this.group.controls['zip'].setValue(addressValues.zipcode);
        }
    }
    // initialize the address validation request
    initAddressValidationRequest() {
        this.addressValidationRequest.request.city = this.group.controls['city'].value;
        this.addressValidationRequest.request.state = this.group.controls['state'].value;
        if (this.group.controls['zip']) {
            this.addressValidationRequest.request.zipcode = this.group.controls['zip'].value;
        }
        this.addressValidationRequest.request.street = this.group.controls['addressLine1'].value;
        if (this.group.controls['addressLine2']) {
            this.addressValidationRequest.request.street2 = this.group.controls['addressLine2'].value;
        }
        this.addressValidationRequest.request.country = this.group.controls['country'].value;
    }
    formatAddress(addressLine) {
        let formattedAddress = addressLine.trim();
        formattedAddress = formattedAddress.substring(0, 40);
        return formattedAddress;
    }
    setAddressValuesFromResponseUsingComponents(response) {
        let addressLine1 = (response.components.primary_number ? response.components.primary_number : '') + ' ' +
            (response.components.street_name ? response.components.street_name : '') + ' ' +
            (response.components.street_suffix ? response.components.street_suffix : '') + ' ' +
            (response.components.street_postdirection ? response.components.street_postdirection : '');
        let addressLine2 = (response.components.secondary_designator ? response.components.secondary_designator : '') + ' ' +
            (response.components.secondary_number ? response.components.secondary_number : '');
        addressLine1 = this.formatAddress(addressLine1);
        this.group.controls['addressLine1'].setValue(addressLine1);
        addressLine2 = this.formatAddress(addressLine2);
        this.group.controls['addressLine2'].setValue(addressLine2);
        this.group.controls['city'].setValue(response.components.city_name);
        // this.group.controls['country'].setValue('US');
        this.group.controls['state'].setValue(response.components.state_abbreviation);
        if (response.components.zipcode) {
            this.group.controls['zip'].setValue(response.components.zipcode + (response.components.plus4_code ? ('-' + response.components.plus4_code) : ''));
        }
    }
    openValidationDialog(message) {
        this.dialogRef = this.dialog.open(DialogAddresValidationComponent, {});
        this.dialogRef.componentInstance.addressValidationMessage = message;
        this.dialogRef.componentInstance.missingSecondary = this.missingSecondary;
        this.dialogRef.componentInstance.addressCorrected = this.addressCorrected;
        this.dialogRef.componentInstance.enteredAddress = this.addressValidationRequest;
        this.dialogRef.componentInstance.isAddressValid = this.values.addressIsValid;
        this.dialogRef.componentInstance.continueOnlyWithValidAddress = this.continueOnlyWithValidAddress;
        this.dialogRef.componentInstance.instructionalText = this.values.isPremisePartialAddress ? this.setInstructionalPartialPremiseText() : this.setInstructionalText();
        this.dialogRef.componentInstance.show.enteredAddress = this.setEnteredAddressDisplay();
        this.dialogRef.componentInstance.show.suggestedAddress = this.setSuggestedAddressDisplay();
        if (this.addressCorrected) {
            this.dialogRef.componentInstance.addressValidationMessage = this.dialogRef.componentInstance.instructionalText;
            this.dialogRef.componentInstance.instructionalText = null;
        }
        if (this.group.controls.country.value === this.sharedCommonValues.api.us && this.usAddressValidationResponse) {
            this.dialogRef.componentInstance.correctedAddress = this.usAddressValidationResponse[0];
        }
        else if (this.group.controls.country.value === this.sharedCommonValues.api.ca && this.intAddressValidationResponse) {
            this.dialogRef.componentInstance.correctedInternationalAddress = this.intAddressValidationResponse[0];
        }
        this.dialogRef.afterClosed().subscribe(result => {
            if (typeof result !== 'boolean' && result) {
                if (result.components && result.analysis) {
                    const isInternationalAddress = this.group.controls.country.value === this.sharedCommonValues.api.us ? false : true;
                    // user chose valid suggested address
                    this.setAddressValuesFromResponse(result, isInternationalAddress);
                    this.values.addressIsValid = true;
                    this.changeFocus();
                }
                else if (result.request) {
                    // user used his entered address
                    this.values.userUsedHisAddress = true;
                    this.changeFocus();
                }
                if (this.missingSecondary && this.dialogRef.componentInstance.secondaryNbr) {
                    this.group.controls['addressLine2'].setValue(this.dialogRef.componentInstance.secondaryNbr);
                    this.verifyEnteredAddress();
                    return;
                }
            }
            else if (result === true) {
                this.values.userUsedHisAddress = true;
                this.changeFocus();
            }
            else {
                this.values.userUsedHisAddress = false;
                this.changeFocus();
            }
            this.dialogRef = null;
        });
    }
    setSuggestedAddressDisplay() {
        return this.addressCorrected;
    }
    setEnteredAddressDisplay() {
        if (this.addressCorrected && this.continueOnlyWithValidAddress) {
            return false;
        }
        return true;
    }
    isUSCountry() {
        return this.addressValidationRequest.request.country === this.sharedCommonValues.api.us;
    }
    setInstructionalText() {
        if (this.addressCorrected) {
            if (!this.continueOnlyWithValidAddress) {
                const addressSuggestedMessage = this.isUSCountry() ? this.sharedCommonValues.addressValidationMessages.newAddressSuggested : this.sharedCommonValues.addressValidationMessages.newInternationalAddressSuggested;
                return addressSuggestedMessage;
            }
            else {
                const invalidAddressSuggestedMessageInfo = this.isUSCountry() ? this.sharedCommonValues.addressValidationMessages.addressSuggestedAndCannnotContinue : this.sharedCommonValues.addressValidationMessages.internationalAddressSuggestedAndCannnotContinue;
                return invalidAddressSuggestedMessageInfo;
            }
        }
        else if (!this.values.addressIsValid) {
            if (this.continueOnlyWithValidAddress) {
                const invalidAddressMessageInfo = this.isUSCountry() ? this.sharedCommonValues.addressValidationMessages.invalidAddressAndCannotContinue : this.sharedCommonValues.addressValidationMessages.invalidInternationalAddressAndCannotContinue;
                return invalidAddressMessageInfo;
            }
            else {
                return this.isUSCountry() ? this.sharedCommonValues.addressValidationMessages.invalidAddressMessage : this.sharedCommonValues.addressValidationMessages.invalidAddressMessageInternational;
            }
        }
        return null;
    }
    setInstructionalPartialPremiseText() {
        if (this.values.isPremisePartialAddress) {
            this.emitInternationalPremisePartialAddress.next(true);
            return this.sharedCommonValues.addressValidationMessages.invalidAddressMessageInternational;
        }
        return;
    }
    changeFocus() {
        if (this.values.addressIsValid || this.values.userUsedHisAddress) {
            this.emitFocusOnValidAddress.next(true);
        }
    }
    // this method uses the footnotes to check if address has been updated from original
    addressUpdatedFromOriginalUsingFootnotes(enteredAddress, validationResponse) {
        if (!this.isNullorBlank(validationResponse.analysis.footnotes) &&
            (validationResponse.analysis.footnotes.includes('A#') ||
                validationResponse.analysis.footnotes.includes('B#') ||
                validationResponse.analysis.footnotes.includes('G#') ||
                validationResponse.analysis.footnotes.includes('K#') ||
                validationResponse.analysis.footnotes.includes('L#') ||
                validationResponse.analysis.footnotes.includes('M#') ||
                validationResponse.analysis.footnotes.includes('N#') ||
                validationResponse.analysis.footnotes.includes('P#') ||
                validationResponse.analysis.footnotes.includes('U#') ||
                validationResponse.analysis.footnotes.includes('V#'))) {
            this.addressCorrected = true;
            return true;
        }
        return false;
    }
    // this method compares address returned by smarty streets with what user has entered to determine if address has been modified.
    addressUpdatedFromOriginal(enteredAddress, validationResponse) {
        const zipVarSrc = (enteredAddress.request.zipcode ? enteredAddress.request.zipcode : '').toLowerCase().replace(/\s+/g, '');
        const streetVarSrc = enteredAddress.request.street.toLowerCase().replace(/\s+/g, '');
        const secondaryVarSrc = (enteredAddress.request.street2 ? enteredAddress.request.street2 : '').toLowerCase().replace(/\s+/g, '');
        const cityVarSrc = enteredAddress.request.city.toLowerCase().replace(/\s+/g, '');
        const stateVar = enteredAddress.request.state.toLowerCase().replace(/\s+/g, '');
        const newValidationResponse = {};
        if (this.group.controls.country.value === this.sharedCommonValues.api.us) {
            const newAddressResponse = validationResponse;
            newValidationResponse.zipVarTgt = (newAddressResponse.components.zipcode + (newAddressResponse.components.plus4_code ? ('-' + newAddressResponse.components.plus4_code) : '')).toLowerCase().replace(/\s+/g, '');
            newValidationResponse.streetVarTgt = (newAddressResponse.delivery_line_1 ? newAddressResponse.delivery_line_1 : '').toLowerCase().replace(/\s+/g, '');
            newValidationResponse.secondaryVarTgt = (newAddressResponse.delivery_line_2 ? newAddressResponse.delivery_line_2 : '').toLowerCase().replace(/\s+/g, '');
            newValidationResponse.cityVarTgt = newAddressResponse.components.city_name.toLowerCase().replace(/\s+/g, '');
            newValidationResponse.stateTgt = newAddressResponse.components.state_abbreviation.toLowerCase().replace(/\s+/g, '');
        }
        else if (this.group.controls.country.value === this.sharedCommonValues.api.ca) {
            const newAddressResponse = validationResponse;
            newValidationResponse.zipVarTgt = (newAddressResponse.components.postal_code).toLowerCase().replace(/\s+/g, '');
            newValidationResponse.streetVarTgt = (newAddressResponse.address1 ? newAddressResponse.address1 : '').toLowerCase().replace(/\s+/g, '');
            newValidationResponse.secondaryVarTgt = (newAddressResponse.address2 ? newAddressResponse.address2 : '').toLowerCase().replace(/\s+/g, '');
            newValidationResponse.cityVarTgt = newAddressResponse.components.locality.toLowerCase().replace(/\s+/g, '');
            newValidationResponse.stateTgt = newAddressResponse.components.administrative_area.toLowerCase().replace(/\s+/g, '');
        }
        const zipVarTgt = newValidationResponse.zipVarTgt;
        const streetVarTgt = newValidationResponse.streetVarTgt;
        const secondaryVarTgt = newValidationResponse.secondaryVarTgt;
        const cityVarTgt = newValidationResponse.cityVarTgt;
        const stateTgt = newValidationResponse.stateTgt;
        if (zipVarSrc !== zipVarTgt ||
            streetVarSrc !== streetVarTgt ||
            secondaryVarSrc !== secondaryVarTgt ||
            cityVarSrc !== cityVarTgt ||
            stateVar !== stateTgt) {
            this.addressCorrected = true;
            return true;
        }
        return false;
    }
    isThereEnoughInput() {
        if (!this.addressValidationRequest.request.street ||
            !this.addressValidationRequest.request.city ||
            !this.addressValidationRequest.request.state) {
            this.openValidationDialog(this.sharedCommonValues.addressValidationMessages.notEnoughInput);
        }
    }
    isNullorBlank(text) {
        if (typeof text !== 'undefined' && text !== ' ' && text) {
            return false;
        }
        return true;
    }
}
FormFieldAddressAutocompleteComponent.ɵfac = function FormFieldAddressAutocompleteComponent_Factory(t) { return new (t || FormFieldAddressAutocompleteComponent)(ɵɵdirectiveInject(SharedCommonValues), ɵɵdirectiveInject(VerifyAddressService), ɵɵdirectiveInject(MatDialog), ɵɵdirectiveInject(ValidationMessage)); };
FormFieldAddressAutocompleteComponent.ɵcmp = ɵɵdefineComponent({ type: FormFieldAddressAutocompleteComponent, selectors: [["ts-form-field-address-autocomplete"]], viewQuery: function FormFieldAddressAutocompleteComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$1, 3);
        ɵɵviewQuery(_c1$1, 3, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.itemFilterInput = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.optionList = _t.first);
    } }, inputs: { controlName: "controlName", group: "group", hint: "hint", required: "required", idx: "idx", notInList: "notInList", options: "options", placeholder: "placeholder", loading: "loading", searchType: "searchType", minCharactersToTrigger: "minCharactersToTrigger", continueOnlyWithValidAddress: "continueOnlyWithValidAddress", maxlength: "maxlength", isExpressSecurePrint: "isExpressSecurePrint", validateInternationAddressKey: "validateInternationAddressKey" }, outputs: { emitFocusOnValidAddress: "emitFocusOnValidAddress", emitInternationalPremisePartialAddress: "emitInternationalPremisePartialAddress" }, features: [ɵɵNgOnChangesFeature], decls: 8, vars: 10, consts: function () { let i18n_2; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc  Display any instructional txt for the field
         * @meaning Hint
         */
        const MSG_EXTERNAL___controlName___hint$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_FORM_FIELD_ADDRESS_AUTOCOMPLETE_FORM_FIELD_ADDRESS_AUTOCOMPLETE_COMPONENT_TS__3 = goog.getMsg("{$interpolation} {$startTagSpan}required{$closeTagSpan}", { "interpolation": "\uFFFD0\uFFFD", "startTagSpan": "\uFFFD*6:1\uFFFD\uFFFD#1:1\uFFFD", "closeTagSpan": "\uFFFD/#1:1\uFFFD\uFFFD/*6:1\uFFFD" });
        i18n_2 = MSG_EXTERNAL___controlName___hint$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_FORM_FIELD_ADDRESS_AUTOCOMPLETE_FORM_FIELD_ADDRESS_AUTOCOMPLETE_COMPONENT_TS__3;
    }
    else {
        i18n_2 = $localize `:Hint| Display any instructional txt for the field@@{{controlName}}-hint␟a31ba24a9c9bcb173c7d736042c6e4ea775b0225␟3661485036709785900:${"\uFFFD0\uFFFD"}:INTERPOLATION: ${"\uFFFD*6:1\uFFFD\uFFFD#1:1\uFFFD"}:START_TAG_SPAN:required${"\uFFFD/#1:1\uFFFD\uFFFD/*6:1\uFFFD"}:CLOSE_TAG_SPAN:`;
    } let i18n_4; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc  Display any error ocurred for the field
         * @meaning Error
         */
        const MSG_EXTERNAL___controlName___error$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_FORM_FIELD_ADDRESS_AUTOCOMPLETE_FORM_FIELD_ADDRESS_AUTOCOMPLETE_COMPONENT_TS__5 = goog.getMsg("{$interpolation}", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_4 = MSG_EXTERNAL___controlName___error$$LIB_COMPONENTS_FORM_FIELD_ADDRESS_AUTOCOMPLETE_FORM_FIELD_ADDRESS_AUTOCOMPLETE_FORM_FIELD_ADDRESS_AUTOCOMPLETE_COMPONENT_TS__5;
    }
    else {
        i18n_4 = $localize `:Error| Display any error ocurred for the field@@{{controlName}}-error␟6074c2c5ce7fbeecd76fa923a50efdc5d954058f␟6963966861158196265:${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
    } return [["appearance", "outline", 1, "nsc-ts-address-auto-complete", "nsc-ts-form-field", 3, "ngClass", "formGroup"], ["matInput", "", "autocomplete", "off", "type", "search", 3, "id", "maxlength", "formControlName", "placeholder", "blur", "focus"], ["itemFilterInput", ""], [4, "ngIf"], i18n_2, ["class", "mat_hit_hidden", 4, "ngIf"], ["optionList", ""], [3, "disabled", "ngClass", "value", "click", "mouseenter", 4, "ngFor", "ngForOf"], [3, "disabled", "ngClass", "value", "click", "mouseenter"], [1, "mat_hit_hidden"], i18n_4]; }, template: function FormFieldAddressAutocompleteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-form-field", 0);
        ɵɵelementStart(1, "input", 1, 2);
        ɵɵlistener("blur", function FormFieldAddressAutocompleteComponent_Template_input_blur_1_listener() { return ctx.onBlur(); })("focus", function FormFieldAddressAutocompleteComponent_Template_input_focus_1_listener() { return ctx.onFocus(); });
        ɵɵelementEnd();
        ɵɵtemplate(3, FormFieldAddressAutocompleteComponent_mat_card_3_Template, 3, 1, "mat-card", 3);
        ɵɵelementStart(4, "mat-hint");
        ɵɵi18nStart(5, 4);
        ɵɵtemplate(6, FormFieldAddressAutocompleteComponent_span_6_Template, 2, 0, "span", 5);
        ɵɵi18nEnd();
        ɵɵelementEnd();
        ɵɵtemplate(7, FormFieldAddressAutocompleteComponent_mat_error_7_Template, 2, 2, "mat-error", 3);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngClass", ctx.loading ? "nsc-ts-address-auto-complete" : "")("formGroup", ctx.group);
        ɵɵadvance(1);
        ɵɵpropertyInterpolate1("id", "", ctx.controlName, "-field");
        ɵɵpropertyInterpolate("maxlength", ctx.maxlength);
        ɵɵpropertyInterpolate("formControlName", ctx.controlName);
        ɵɵpropertyInterpolate("placeholder", ctx.placeholder);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.show.autocomplete);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.required);
        ɵɵi18nExp(ctx.content.hint);
        ɵɵi18nApply(5);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.group.controls[ctx.controlName].invalid);
    } }, directives: [MatFormField, NgClass, NgControlStatusGroup, FormGroupDirective, MatInput, DefaultValueAccessor, MaxLengthValidator, NgControlStatus, FormControlName, NgIf, MatHint, MatCard, NgForOf, MatOption, MatError], styles: [".nsc-ts-address-auto-complete[_ngcontent-%COMP%]{position:relative}.nsc-ts-address-auto-complete[_ngcontent-%COMP%]   .mat-card[_ngcontent-%COMP%]{position:absolute;top:100%;width:100%;padding:0;z-index:1;max-height:256px;overflow:auto;-webkit-overflow-scrolling:touch}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(FormFieldAddressAutocompleteComponent, [{
        type: Component,
        args: [{
                selector: 'ts-form-field-address-autocomplete',
                templateUrl: './form-field-address-autocomplete.component.html',
                styleUrls: ['./form-field-address-autocomplete.component.scss']
            }]
    }], function () { return [{ type: SharedCommonValues }, { type: VerifyAddressService }, { type: MatDialog }, { type: ValidationMessage }]; }, { controlName: [{
            type: Input
        }], group: [{
            type: Input
        }], hint: [{
            type: Input
        }], required: [{
            type: Input
        }], idx: [{
            type: Input
        }], notInList: [{
            type: Input
        }], options: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], loading: [{
            type: Input
        }], searchType: [{
            type: Input
        }], minCharactersToTrigger: [{
            type: Input
        }], continueOnlyWithValidAddress: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], isExpressSecurePrint: [{
            type: Input
        }], validateInternationAddressKey: [{
            type: Input
        }], itemFilterInput: [{
            type: ViewChild,
            args: ['itemFilterInput', { static: true }]
        }], optionList: [{
            type: ViewChild,
            args: ['optionList', { read: ElementRef, static: true }]
        }], emitFocusOnValidAddress: [{
            type: Output
        }], emitInternationalPremisePartialAddress: [{
            type: Output
        }] }); })();

class FormFieldAddressAutocompleteModule {
}
FormFieldAddressAutocompleteModule.ɵfac = function FormFieldAddressAutocompleteModule_Factory(t) { return new (t || FormFieldAddressAutocompleteModule)(); };
FormFieldAddressAutocompleteModule.ɵmod = ɵɵdefineNgModule({ type: FormFieldAddressAutocompleteModule });
FormFieldAddressAutocompleteModule.ɵinj = ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            MaterialModule,
            ReactiveFormsModule,
            SpacerModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(FormFieldAddressAutocompleteModule, { declarations: [FormFieldAddressAutocompleteComponent,
        DialogAddresValidationComponent], imports: [CommonModule,
        FormsModule,
        MaterialModule,
        ReactiveFormsModule,
        SpacerModule], exports: [FormFieldAddressAutocompleteComponent, DialogAddresValidationComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(FormFieldAddressAutocompleteModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    FormFieldAddressAutocompleteComponent,
                    DialogAddresValidationComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    MaterialModule,
                    ReactiveFormsModule,
                    SpacerModule
                ],
                exports: [FormFieldAddressAutocompleteComponent, DialogAddresValidationComponent]
            }]
    }], null, null); })();

const _c0$2 = ["*"];
class CardContentComponent {
    constructor() { }
    ngOnInit() {
    }
}
CardContentComponent.ɵfac = function CardContentComponent_Factory(t) { return new (t || CardContentComponent)(); };
CardContentComponent.ɵcmp = ɵɵdefineComponent({ type: CardContentComponent, selectors: [["ts-card-content"]], inputs: { class: "class" }, ngContentSelectors: _c0$2, decls: 2, vars: 3, template: function CardContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "mat-card-content");
        ɵɵprojection(1);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵclassMapInterpolate1("nsc-ts-card-content ", ctx.class, "");
    } }, directives: [MatCardContent], styles: [".nsc-ts-card-content[_ngcontent-%COMP%]{margin-bottom:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(CardContentComponent, [{
        type: Component,
        args: [{
                selector: 'ts-card-content',
                templateUrl: './card-content.component.html',
                styleUrls: ['./card-content.component.scss']
            }]
    }], function () { return []; }, { class: [{
            type: Input
        }] }); })();

const _c0$3 = ["*"];
class CardComponent {
    constructor() {
        this.topBorder = false;
    }
    ngOnInit() {
    }
}
CardComponent.ɵfac = function CardComponent_Factory(t) { return new (t || CardComponent)(); };
CardComponent.ɵcmp = ɵɵdefineComponent({ type: CardComponent, selectors: [["ts-card"]], inputs: { topBorder: "topBorder", error: "error" }, ngContentSelectors: _c0$3, decls: 2, vars: 4, consts: [[1, "nsc-ts-card"]], template: function CardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "mat-card", 0);
        ɵɵprojection(1);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵclassProp("mat-card-top", ctx.topBorder)("nsc-ts-card--error", ctx.error);
    } }, directives: [MatCard], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(CardComponent, [{
        type: Component,
        args: [{
                selector: 'ts-card',
                templateUrl: './card.component.html',
                styleUrls: ['./card.component.scss']
            }]
    }], function () { return []; }, { topBorder: [{
            type: Input
        }], error: [{
            type: Input
        }] }); })();

function CardTitleComponent_h3_2_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵi18nStart(0, 2, 1);
    ɵɵelement(1, "mat-icon", 5);
    ɵɵi18nEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("svgIcon", ctx_r2.icon);
} }
function CardTitleComponent_h3_2_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵi18nStart(0, 2, 2);
    ɵɵelement(1, "span", 6);
    ɵɵi18nEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵi18nExp(ctx_r3.note);
    ɵɵi18nApply(0);
} }
function CardTitleComponent_h3_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h3");
    ɵɵi18nStart(1, 2);
    ɵɵtemplate(2, CardTitleComponent_h3_2_mat_icon_2_Template, 2, 1, "mat-icon", 3);
    ɵɵtemplate(3, CardTitleComponent_h3_2_span_3_Template, 2, 1, "span", 4);
    ɵɵi18nEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵattribute("aria-label", ctx_r0.title);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r0.icon);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.note);
    ɵɵi18nExp(ctx_r0.title);
    ɵɵi18nApply(1);
} }
function CardTitleComponent_ng_content_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵprojection(0, 0, ["*ngIf", "isCustomTitle"]);
} }
const _c2 = ["*"];
class CardTitleComponent {
    constructor() {
        this.isCustomTitle = false;
    }
    ngOnInit() {
    }
}
CardTitleComponent.ɵfac = function CardTitleComponent_Factory(t) { return new (t || CardTitleComponent)(); };
CardTitleComponent.ɵcmp = ɵɵdefineComponent({ type: CardTitleComponent, selectors: [["ts-card-title"]], inputs: { error: "error", icon: "icon", note: "note", title: "title", shoppingCartCount: "shoppingCartCount", isCustomTitle: "isCustomTitle", id: "id" }, ngContentSelectors: _c2, decls: 4, vars: 4, consts: function () { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc  Contains a card title description
         * @meaning card title
         */
        const MSG_EXTERNAL___id__$$LIB_COMPONENTS_CARDS_CARD_TITLE_CARD_TITLE_COMPONENT_TS___1 = goog.getMsg("{$startTagMatIcon}{$closeTagMatIcon} {$interpolation} {$startTagSpan}{$interpolation_1}{$closeTagSpan}", { "startTagMatIcon": "\uFFFD*2:1\uFFFD\uFFFD#1:1\uFFFD", "closeTagMatIcon": "\uFFFD/#1:1\uFFFD\uFFFD/*2:1\uFFFD", "interpolation": "\uFFFD0\uFFFD", "startTagSpan": "\uFFFD*3:2\uFFFD\uFFFD#1:2\uFFFD", "closeTagSpan": "\uFFFD/#1:2\uFFFD\uFFFD/*3:2\uFFFD", "interpolation_1": "\uFFFD0:2\uFFFD" });
        i18n_0 = MSG_EXTERNAL___id__$$LIB_COMPONENTS_CARDS_CARD_TITLE_CARD_TITLE_COMPONENT_TS___1;
    }
    else {
        i18n_0 = $localize `:card title| Contains a card title description@@{{id}}␟1430329e036c80a03ffd44a7151371c192488f8e␟7919958852233792609:${"\uFFFD*2:1\uFFFD\uFFFD#1:1\uFFFD"}:START_TAG_MAT_ICON:${"\uFFFD/#1:1\uFFFD\uFFFD/*2:1\uFFFD"}:CLOSE_TAG_MAT_ICON: ${"\uFFFD0\uFFFD"}:INTERPOLATION: ${"\uFFFD*3:2\uFFFD\uFFFD#1:2\uFFFD"}:START_TAG_SPAN:${"\uFFFD0:2\uFFFD"}:INTERPOLATION_1:${"\uFFFD/#1:2\uFFFD\uFFFD/*3:2\uFFFD"}:CLOSE_TAG_SPAN:`;
    } return [[1, ""], [4, "ngIf"], i18n_0, ["class", "nsc-ts-svgIcon nsc-ts-svgIcon__info", 3, "svgIcon", 4, "ngIf"], ["class", "nsc-ts-card-title__note mat-caption", 4, "ngIf"], [1, "nsc-ts-svgIcon", "nsc-ts-svgIcon__info", 3, "svgIcon"], [1, "nsc-ts-card-title__note", "mat-caption"]]; }, template: function CardTitleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "mat-card-header");
        ɵɵelementStart(1, "mat-card-title", 0);
        ɵɵtemplate(2, CardTitleComponent_h3_2_Template, 4, 4, "h3", 1);
        ɵɵtemplate(3, CardTitleComponent_ng_content_3_Template, 1, 0, "ng-content", 1);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵclassProp("nsc-ts-card-title--error", ctx.error);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.isCustomTitle);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.isCustomTitle);
    } }, directives: [MatCardHeader, MatCardTitle, NgIf, MatIcon], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(CardTitleComponent, [{
        type: Component,
        args: [{
                selector: 'ts-card-title',
                templateUrl: './card-title.component.html',
                styleUrls: ['./card-title.component.scss']
            }]
    }], function () { return []; }, { error: [{
            type: Input
        }], icon: [{
            type: Input
        }], note: [{
            type: Input
        }], title: [{
            type: Input
        }], shoppingCartCount: [{
            type: Input
        }], isCustomTitle: [{
            type: Input
        }], id: [{
            type: Input
        }] }); })();

class CardsModule {
}
CardsModule.ɵfac = function CardsModule_Factory(t) { return new (t || CardsModule)(); };
CardsModule.ɵmod = ɵɵdefineNgModule({ type: CardsModule });
CardsModule.ɵinj = ɵɵdefineInjector({ imports: [[
            CommonModule,
            MaterialModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(CardsModule, { declarations: [CardComponent, CardTitleComponent, CardContentComponent], imports: [CommonModule,
        MaterialModule], exports: [CardComponent, CardTitleComponent, CardContentComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(CardsModule, [{
        type: NgModule,
        args: [{
                declarations: [CardComponent, CardTitleComponent, CardContentComponent],
                imports: [
                    CommonModule,
                    MaterialModule
                ],
                exports: [CardComponent, CardTitleComponent, CardContentComponent]
            }]
    }], null, null); })();

function BreadcrumbsComponent_li_1_a_1__svg_svg_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵi18nStart(0, 6, 1);
    ɵɵnamespaceSVG();
    ɵɵelementStart(1, "svg", 8);
    ɵɵelement(2, "title", 9);
    ɵɵelement(3, "path", 10);
    ɵɵelement(4, "path", 11);
    ɵɵelement(5, "path", 12);
    ɵɵelement(6, "path", 13);
    ɵɵelementEnd();
    ɵɵi18nEnd();
} }
const _c2$1 = function (a0) { return { "active": a0 }; };
function BreadcrumbsComponent_li_1_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", 5);
    ɵɵlistener("click", function BreadcrumbsComponent_li_1_a_1_Template_a_click_0_listener($event) { ɵɵrestoreView(_r10); const ctx_r9 = ɵɵnextContext(); const item_r1 = ctx_r9.$implicit; const $index_r2 = ctx_r9.index; const ctx_r8 = ɵɵnextContext(); return ctx_r8.redirectToPage($event, item_r1.pathDestination, $index_r2); });
    ɵɵi18nStart(1, 6);
    ɵɵtemplate(2, BreadcrumbsComponent_li_1_a_1__svg_svg_2_Template, 7, 0, "svg", 7);
    ɵɵi18nEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵɵnextContext();
    const $index_r2 = ctx_r11.index;
    const item_r1 = ctx_r11.$implicit;
    const $last_r3 = ctx_r11.last;
    const $first_r4 = ctx_r11.first;
    ɵɵpropertyInterpolate1("id", "menu-option-", $index_r2, "");
    ɵɵpropertyInterpolate("href", item_r1.pathDestination, ɵɵsanitizeUrl);
    ɵɵproperty("ngClass", ɵɵpureFunction1(6, _c2$1, $last_r3));
    ɵɵattribute("aria-label", item_r1.name);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", $first_r4);
    ɵɵi18nExp(item_r1.name);
    ɵɵi18nApply(1);
} }
function BreadcrumbsComponent_li_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 14);
    ɵɵi18n(1, 15);
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵɵnextContext().$implicit;
    ɵɵattribute("aria-label", item_r1.name);
    ɵɵadvance(1);
    ɵɵi18nExp(item_r1.name);
    ɵɵi18nApply(1);
} }
function BreadcrumbsComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "li", 2);
    ɵɵtemplate(1, BreadcrumbsComponent_li_1_a_1_Template, 3, 8, "a", 3);
    ɵɵtemplate(2, BreadcrumbsComponent_li_1_span_2_Template, 2, 2, "span", 4);
    ɵɵelementEnd();
} if (rf & 2) {
    const $last_r3 = ctx.last;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !$last_r3);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", $last_r3);
} }
class BreadcrumbsComponent {
    constructor() {
        this.emitRedirectToPage = new EventEmitter();
    }
    ngOnInit() {
    }
    redirectToPage(event, url, index) {
        event.preventDefault();
        const json = { url, index };
        this.emitRedirectToPage.emit(json);
    }
}
BreadcrumbsComponent.ɵfac = function BreadcrumbsComponent_Factory(t) { return new (t || BreadcrumbsComponent)(); };
BreadcrumbsComponent.ɵcmp = ɵɵdefineComponent({ type: BreadcrumbsComponent, selectors: [["ts-breadcrumbs"]], inputs: { menuItems: "menuItems" }, outputs: { emitRedirectToPage: "emitRedirectToPage" }, decls: 2, vars: 1, consts: function () { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc  breadcrumbs option
         * @meaning breadcrumb option
         */
        const MSG_EXTERNAL___item_name___option___index__$$LIB_COMPONENTS_BREADCRUMBS_BREADCRUMBS_COMPONENT_TS____1 = goog.getMsg("{$startTagSvgSvg}{$startTagSvgTitle}home{$closeTagSvgTitle}{$startTagSvgPath}{$closeTagSvgPath}{$startTagSvgPath_1}{$closeTagSvgPath}{$startTagSvgPath_2}{$closeTagSvgPath}{$startTagSvgPath_3}{$closeTagSvgPath}{$closeTagSvgSvg} {$interpolation} ", { "startTagSvgSvg": "\uFFFD*2:1\uFFFD\uFFFD#1:1\uFFFD", "closeTagSvgSvg": "\uFFFD/#1:1\uFFFD\uFFFD/*2:1\uFFFD", "interpolation": "\uFFFD0\uFFFD", "startTagSvgTitle": "\uFFFD#2:1\uFFFD", "closeTagSvgTitle": "\uFFFD/#2:1\uFFFD", "startTagSvgPath": "\uFFFD#3:1\uFFFD", "closeTagSvgPath": "[\uFFFD/#3:1\uFFFD|\uFFFD/#4:1\uFFFD|\uFFFD/#5:1\uFFFD|\uFFFD/#6:1\uFFFD]", "startTagSvgPath_1": "\uFFFD#4:1\uFFFD", "startTagSvgPath_2": "\uFFFD#5:1\uFFFD", "startTagSvgPath_3": "\uFFFD#6:1\uFFFD" });
        i18n_0 = MSG_EXTERNAL___item_name___option___index__$$LIB_COMPONENTS_BREADCRUMBS_BREADCRUMBS_COMPONENT_TS____1;
    }
    else {
        i18n_0 = $localize `:breadcrumb option| breadcrumbs option@@{{item.name}}-option-{{index}}␟85606e4f78d1f394c0a43c2e38c950e7d72fd667␟7991854906676510862:${"\uFFFD*2:1\uFFFD\uFFFD#1:1\uFFFD"}:START_TAG__SVG_SVG:${"\uFFFD#2:1\uFFFD"}:START_TAG__SVG_TITLE:home${"\uFFFD/#2:1\uFFFD"}:CLOSE_TAG__SVG_TITLE:${"\uFFFD#3:1\uFFFD"}:START_TAG__SVG_PATH:${"[\uFFFD/#3:1\uFFFD|\uFFFD/#4:1\uFFFD|\uFFFD/#5:1\uFFFD|\uFFFD/#6:1\uFFFD]"}:CLOSE_TAG__SVG_PATH:${"\uFFFD#4:1\uFFFD"}:START_TAG__SVG_PATH_1:${"[\uFFFD/#3:1\uFFFD|\uFFFD/#4:1\uFFFD|\uFFFD/#5:1\uFFFD|\uFFFD/#6:1\uFFFD]"}:CLOSE_TAG__SVG_PATH:${"\uFFFD#5:1\uFFFD"}:START_TAG__SVG_PATH_2:${"[\uFFFD/#3:1\uFFFD|\uFFFD/#4:1\uFFFD|\uFFFD/#5:1\uFFFD|\uFFFD/#6:1\uFFFD]"}:CLOSE_TAG__SVG_PATH:${"\uFFFD#6:1\uFFFD"}:START_TAG__SVG_PATH_3:${"[\uFFFD/#3:1\uFFFD|\uFFFD/#4:1\uFFFD|\uFFFD/#5:1\uFFFD|\uFFFD/#6:1\uFFFD]"}:CLOSE_TAG__SVG_PATH:${"\uFFFD/#1:1\uFFFD\uFFFD/*2:1\uFFFD"}:CLOSE_TAG__SVG_SVG: ${"\uFFFD0\uFFFD"}:INTERPOLATION: `;
    } i18n_0 = ɵɵi18nPostprocess(i18n_0); let i18n_3; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Display last option from breadcrumb
         * @meaning last option
         */
        const MSG_EXTERNAL___item_name___option___index__$$LIB_COMPONENTS_BREADCRUMBS_BREADCRUMBS_COMPONENT_TS___4 = goog.getMsg("{$interpolation}", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_3 = MSG_EXTERNAL___item_name___option___index__$$LIB_COMPONENTS_BREADCRUMBS_BREADCRUMBS_COMPONENT_TS___4;
    }
    else {
        i18n_3 = $localize `:last option|Display last option from breadcrumb@@{{item.name}}-option-{{index}}␟f1baccb0b0c9491ac81ed62faaffe4501cfae554␟2761929873384379441:${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
    } return [[1, "nsc-ts-breadcrumbs", "mat-body-2"], ["class", "nsc-ts-breadcrumbs__item", 4, "ngFor", "ngForOf"], [1, "nsc-ts-breadcrumbs__item"], ["mat-button", "", "class", "nsc-ts-breadcrumbs__link", 3, "id", "ngClass", "href", "click", 4, "ngIf"], ["class", "nsc-ts-breadcrumbs__items--active", 4, "ngIf"], ["mat-button", "", 1, "nsc-ts-breadcrumbs__link", 3, "id", "ngClass", "href", "click"], i18n_0, ["role", "img", "aria-labelledby", "home", "class", "home_icon", "width", "16", "height", "15", "viewBox", "0 0 16 15", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 4, "ngIf"], ["role", "img", "aria-labelledby", "home", "width", "16", "height", "15", "viewBox", "0 0 16 15", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "home_icon"], ["id", "home"], ["d", "M1.14551 7.95152L7.43551 1.65619C7.62377 1.46922 7.87862 1.36473 8.14395 1.36573C8.40927 1.36673 8.66333 1.47314 8.85017 1.66152L15.1455 7.95152", "stroke", "#297AA6", "stroke-width", "1.125", "stroke-linecap", "round", "stroke-linejoin", "round"], ["d", "M13.1455 5.95353V13.9515H3.14551V5.9502", "stroke", "#297AA6", "stroke-width", "1.125", "stroke-linecap", "round", "stroke-linejoin", "round"], ["d", "M10.1455 13.9515V10.9515C10.1455 9.84697 9.25008 8.95154 8.14551 8.95154C7.04094 8.95154 6.14551 9.84697 6.14551 10.9515V13.9515", "stroke", "#297AA6", "stroke-width", "1.125", "stroke-linecap", "round", "stroke-linejoin", "round"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M8.14551 6.95154C8.83586 6.95154 9.39551 6.39189 9.39551 5.70154C9.39551 5.01118 8.83586 4.45154 8.14551 4.45154C7.45515 4.45154 6.89551 5.01118 6.89551 5.70154C6.89551 6.39189 7.45515 6.95154 8.14551 6.95154Z", "stroke", "#297AA6", "stroke-width", "1.125", "stroke-linecap", "round", "stroke-linejoin", "round"], [1, "nsc-ts-breadcrumbs__items--active"], i18n_3]; }, template: function BreadcrumbsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "ul", 0);
        ɵɵtemplate(1, BreadcrumbsComponent_li_1_Template, 3, 2, "li", 1);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.menuItems);
    } }, directives: [NgForOf, NgIf, NgClass], styles: [".education-solutions-theme[_ngcontent-%COMP%]{--brand-color-1:#437c2b;--brand-color-2:#273f21;--brand-color-3:#6db944;--brand-color-4:#599a38;--brand-color-5:#e2f1da;--brand-color-6:rgba(109,185,68,0.2);--brand-color-7:#f3f9f0;--brand-color-8:rgba(109,185,68,0.08)}.nsc-ts-breadcrumbs[_ngcontent-%COMP%]{padding-left:1rem;margin-top:1rem;margin-bottom:1rem}.nsc-ts-breadcrumbs[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:inline-flex;line-height:10.5px;margin:5px 10px 5px -10px;padding:0 14px;position:relative}.nsc-ts-breadcrumbs[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:first-child{padding:7px 15px 7px 10px;border-left:1px solid rgba(68,68,68,.15)}.nsc-ts-breadcrumbs[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:first-child   .home_icon[_ngcontent-%COMP%]{margin-top:-2.5px;margin-right:.25rem}.nsc-ts-breadcrumbs[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:first-child:before{content:\"\";border-top:1px solid rgba(0,165,242,.2)}.nsc-ts-breadcrumbs[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:first-child:after{border-bottom:1px solid rgba(0,165,242,.2)}.nsc-ts-breadcrumbs[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:first-child:after, .nsc-ts-breadcrumbs[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:first-child:before{left:5px;border-right:1px solid rgba(0,165,242,.2)}.nsc-ts-breadcrumbs[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:after, .nsc-ts-breadcrumbs[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:before{border-right:2px solid rgba(68,68,68,.15);content:\"\";display:block;height:50%;position:absolute;left:0;right:0;top:0;z-index:-1;transform:skewX(45deg)}.nsc-ts-breadcrumbs[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:after{bottom:0;top:auto;transform:skewX(-45deg)}.nsc-ts-breadcrumbs[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-of-type:after, .nsc-ts-breadcrumbs[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-of-type:before{display:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(BreadcrumbsComponent, [{
        type: Component,
        args: [{
                selector: 'ts-breadcrumbs',
                templateUrl: './breadcrumbs.component.html',
                styleUrls: ['./breadcrumbs.component.scss']
            }]
    }], function () { return []; }, { menuItems: [{
            type: Input
        }], emitRedirectToPage: [{
            type: Output
        }] }); })();

class BreadcrumbsModule {
}
BreadcrumbsModule.ɵfac = function BreadcrumbsModule_Factory(t) { return new (t || BreadcrumbsModule)(); };
BreadcrumbsModule.ɵmod = ɵɵdefineNgModule({ type: BreadcrumbsModule });
BreadcrumbsModule.ɵinj = ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(BreadcrumbsModule, { declarations: [BreadcrumbsComponent], imports: [CommonModule], exports: [BreadcrumbsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(BreadcrumbsModule, [{
        type: NgModule,
        args: [{
                declarations: [BreadcrumbsComponent],
                imports: [
                    CommonModule
                ],
                exports: [BreadcrumbsComponent]
            }]
    }], null, null); })();

class TimeoutService {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
        this.showWarning = new EventEmitter(); // used by the dialog-timeout component to know when to show the dialog;
        this.durationWarning = 13 * 60 * 1000; // minutes * seconds * milliseconds;
        this.deactiveWarning = new EventEmitter();
    }
    // called by the timeout dialog;
    // the timeout dialog controls when so the UI matches when the session ends;
    // don't want the timer in the dialog to hit zero and then not end the session;
    endSession() {
        this.dialogRef.closeAll();
        this.deactiveWarning.emit(true);
    }
    startWarningCountdown() {
        // clear out any existing timeout;
        window.clearTimeout(this.timeout);
        // start the countdown till the warning dialog is shown;
        this.timeout = window.setTimeout(() => {
            this.showWarning.emit(true);
        }, this.durationWarning);
    }
}
TimeoutService.ɵfac = function TimeoutService_Factory(t) { return new (t || TimeoutService)(ɵɵinject(MatDialog)); };
TimeoutService.ɵprov = ɵɵdefineInjectable({ token: TimeoutService, factory: TimeoutService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(TimeoutService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: MatDialog }]; }, null); })();

function DialogBoxComponent_h4_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h4", 8);
    ɵɵi18n(1, 9);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵi18nExp(ctx_r0.data.title);
    ɵɵi18nApply(1);
} }
function DialogBoxComponent_ts_spacer_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "ts-spacer");
} }
function DialogBoxComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 10);
    ɵɵlistener("click", function DialogBoxComponent_button_7_Template_button_click_0_listener() { ɵɵrestoreView(_r4); const ctx_r3 = ɵɵnextContext(); return ctx_r3.dialogRef.close(false); });
    ɵɵi18n(1, 11);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵi18nExp(ctx_r2.btnNoName);
    ɵɵi18nApply(1);
} }
// import { DialogBoxService} from '../../services/dialog-box/dialog-box.service';
class DialogBoxComponent {
    constructor(data, 
    // private dialogBoxService: DialogBoxService
    dialogRef, timeoutService) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.timeoutService = timeoutService;
        this.isConfirmDialog = false;
        this.btnYesName = 'OK';
        this.btnNoName = 'Cancel';
    }
    ngOnInit() {
        this.data.btnYesName = this.data.btnYesName ? this.data.btnYesName : this.btnYesName;
        this.data.btnNoName = this.data.btnNoName ? this.data.btnNoName : this.btnNoName;
    }
    close(val) {
        this.timeoutService.startWarningCountdown();
        this.dialogRef.close();
    }
}
DialogBoxComponent.ɵfac = function DialogBoxComponent_Factory(t) { return new (t || DialogBoxComponent)(ɵɵdirectiveInject(MAT_DIALOG_DATA), ɵɵdirectiveInject(MatDialogRef), ɵɵdirectiveInject(TimeoutService)); };
DialogBoxComponent.ɵcmp = ɵɵdefineComponent({ type: DialogBoxComponent, selectors: [["ts-dialog-box"]], inputs: { isConfirmDialog: "isConfirmDialog" }, decls: 8, vars: 5, consts: function () { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_dialog_yes_btn$$LIB_COMPONENTS_DIALOG_BOX_DIALOG_BOX_COMPONENT_TS_1 = goog.getMsg(" {$interpolation} ", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_0 = MSG_EXTERNAL_dialog_yes_btn$$LIB_COMPONENTS_DIALOG_BOX_DIALOG_BOX_COMPONENT_TS_1;
    }
    else {
        i18n_0 = $localize `:@@dialog-yes-btn␟bb1d57415f387895de7ddaf06be1802ca4cddec5␟8851395719683468456: ${"\uFFFD0\uFFFD"}:INTERPOLATION: `;
    } let i18n_2; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc  Contains the dialog details
         * @meaning Dialog box title
         */
        const MSG_EXTERNAL_dialog_title$$LIB_COMPONENTS_DIALOG_BOX_DIALOG_BOX_COMPONENT_TS__3 = goog.getMsg(" {$interpolation}\n", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_2 = MSG_EXTERNAL_dialog_title$$LIB_COMPONENTS_DIALOG_BOX_DIALOG_BOX_COMPONENT_TS__3;
    }
    else {
        i18n_2 = $localize `:Dialog box title | Contains the dialog details@@dialog-title␟a87449b4304ead703dfee80997023b528661bea3␟7079848077970395090: ${"\uFFFD0\uFFFD"}:INTERPOLATION:
`;
    } let i18n_4; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_dialog_no_btn$$LIB_COMPONENTS_DIALOG_BOX_DIALOG_BOX_COMPONENT_TS__5 = goog.getMsg(" {$interpolation}", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_4 = MSG_EXTERNAL_dialog_no_btn$$LIB_COMPONENTS_DIALOG_BOX_DIALOG_BOX_COMPONENT_TS__5;
    }
    else {
        i18n_4 = $localize `:@@dialog-no-btn␟de4f57d29567c15a27d4fdaf8f749a25c81c394a␟8161401011307691000: ${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
    } return [["class", "nsc-ts-box--title", "mat-dialog-title", "", 4, "ngIf"], ["tabindex", "0", 1, "mat-typography"], [3, "innerHTML"], ["align", "end"], ["mat-raised-button", "", "color", "primary", "type", "button", "id", "dialog-yes-btn", "cdkFocusInitial", "", 3, "click"], i18n_0, [4, "ngIf"], ["mat-stroked-button", "", "color", "primary", "mat-dialog-close", "", "type", "button", "id", "dialog-no-btn", 3, "click", 4, "ngIf"], ["mat-dialog-title", "", 1, "nsc-ts-box--title"], i18n_2, ["mat-stroked-button", "", "color", "primary", "mat-dialog-close", "", "type", "button", "id", "dialog-no-btn", 3, "click"], i18n_4]; }, template: function DialogBoxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, DialogBoxComponent_h4_0_Template, 2, 1, "h4", 0);
        ɵɵelementStart(1, "mat-dialog-content", 1);
        ɵɵelement(2, "div", 2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "mat-dialog-actions", 3);
        ɵɵelementStart(4, "button", 4);
        ɵɵlistener("click", function DialogBoxComponent_Template_button_click_4_listener() { return ctx.dialogRef.close(true); });
        ɵɵi18n(5, 5);
        ɵɵelementEnd();
        ɵɵtemplate(6, DialogBoxComponent_ts_spacer_6_Template, 1, 0, "ts-spacer", 6);
        ɵɵtemplate(7, DialogBoxComponent_button_7_Template, 2, 1, "button", 7);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.data.title);
        ɵɵadvance(2);
        ɵɵproperty("innerHTML", ctx.data.body, ɵɵsanitizeHtml);
        ɵɵadvance(3);
        ɵɵi18nExp(ctx.btnYesName);
        ɵɵi18nApply(5);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.isConfirmDialog);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.isConfirmDialog);
    } }, directives: [NgIf, MatDialogContent, MatDialogActions, MatButton, MatDialogTitle, SpacerComponent, MatDialogClose], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(DialogBoxComponent, [{
        type: Component,
        args: [{
                selector: 'ts-dialog-box',
                templateUrl: './dialog-box.component.html',
                styleUrls: ['./dialog-box.component.scss']
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: MatDialogRef }, { type: TimeoutService }]; }, { isConfirmDialog: [{
            type: Input
        }] }); })();

function FormFieldInputComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 6);
    ɵɵlistener("click", function FormFieldInputComponent_div_4_Template_div_click_0_listener() { ɵɵrestoreView(_r4); const ctx_r3 = ɵɵnextContext(); return ctx_r3.openDialog(); })("keyup.enter", function FormFieldInputComponent_div_4_Template_div_keyup_enter_0_listener() { ɵɵrestoreView(_r4); const ctx_r5 = ɵɵnextContext(); return ctx_r5.openDialog(); })("keyup.space", function FormFieldInputComponent_div_4_Template_div_keyup_space_0_listener() { ɵɵrestoreView(_r4); const ctx_r6 = ɵɵnextContext(); return ctx_r6.openDialog(); });
    ɵɵelement(1, "mat-icon", 7);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵpropertyInterpolate1("id", "toggle-", ctx_r0.controlName, "-help-icon");
} }
function FormFieldInputComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵi18nStart(0, 3, 1);
    ɵɵelement(1, "span", 8);
    ɵɵi18nEnd();
} }
function FormFieldInputComponent_mat_error_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-error", 9);
    ɵɵi18n(1, 10);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵi18nExp(ctx_r2.setErrorMessage(ctx_r2.group.controls[ctx_r2.controlName], ctx_r2.placeholder));
    ɵɵi18nApply(1);
} }
const _c4 = function (a0) { return { mask: a0, guide: false, keepCharPositions: true, modelClean: true }; };
class FormFieldInputComponent {
    constructor(validationMessage, dialog) {
        this.validationMessage = validationMessage;
        this.dialog = dialog;
        this.autocomplete = 'off';
        this.mask = false;
        this.required = true;
        this.type = 'text';
        this.readonly = false;
        this.value = null;
        this.content = {
            hint: '',
            errorMessage: ''
        };
    }
    ngOnInit() {
        this.setHint(this.hint, this.required);
        this.setErrorMessage(this.group.controls[this.controlName], this.placeholder);
    }
    ngOnChanges(changes) {
        const newHint = changes.hint ? changes.hint.currentValue : this.hint;
        const newRequired = changes.required ? changes.required.currentValue : this.required;
        this.setHint(newHint, newRequired);
    }
    setHint(hint, required) {
        // if a field isn't required and it's optional, we need to combine the `hint` values;
        this.content.hint = `${hint || ''} ${required ? '' : '(Optional) '}`;
    }
    setErrorMessage(controlName, placeholder) {
        this.content.errorMessage = this.validationMessage.get(controlName, placeholder);
        return (this.content.hint + this.content.errorMessage);
    }
    openDialog() {
        const dialogRef = this.dialog.open(DialogBoxComponent, {
            width: this.help.length > 300 ? '480px' : '310px',
            autoFocus: false,
            data: {
                body: this.help
            }
        });
    }
}
FormFieldInputComponent.ɵfac = function FormFieldInputComponent_Factory(t) { return new (t || FormFieldInputComponent)(ɵɵdirectiveInject(ValidationMessage), ɵɵdirectiveInject(MatDialog)); };
FormFieldInputComponent.ɵcmp = ɵɵdefineComponent({ type: FormFieldInputComponent, selectors: [["ts-form-field-input"]], inputs: { autocomplete: "autocomplete", controlName: "controlName", group: "group", hint: "hint", mask: "mask", maxlength: "maxlength", placeholder: "placeholder", required: "required", suffix: "suffix", type: "type", idx: "idx", help: "help", textMask: "textMask", readonly: "readonly", value: "value" }, features: [ɵɵNgOnChangesFeature], decls: 9, vars: 17, consts: function () { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc  Display any instructional txt for the field
         * @meaning Hint
         */
        const MSG_EXTERNAL___controlName___hint$$LIB_COMPONENTS_FORM_FIELD_INPUT_FORM_FIELD_INPUT_COMPONENT_TS__1 = goog.getMsg("{$interpolation} {$startTagSpan}required{$closeTagSpan}", { "interpolation": "\uFFFD0\uFFFD", "startTagSpan": "\uFFFD*7:1\uFFFD\uFFFD#1:1\uFFFD", "closeTagSpan": "\uFFFD/#1:1\uFFFD\uFFFD/*7:1\uFFFD" });
        i18n_0 = MSG_EXTERNAL___controlName___hint$$LIB_COMPONENTS_FORM_FIELD_INPUT_FORM_FIELD_INPUT_COMPONENT_TS__1;
    }
    else {
        i18n_0 = $localize `:Hint| Display any instructional txt for the field@@{{controlName}}-hint␟a31ba24a9c9bcb173c7d736042c6e4ea775b0225␟3661485036709785900:${"\uFFFD0\uFFFD"}:INTERPOLATION: ${"\uFFFD*7:1\uFFFD\uFFFD#1:1\uFFFD"}:START_TAG_SPAN:required${"\uFFFD/#1:1\uFFFD\uFFFD/*7:1\uFFFD"}:CLOSE_TAG_SPAN:`;
    } let i18n_2; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc  Display any error ocurred for the field
         * @meaning Error
         */
        const MSG_EXTERNAL___controlName___error$$LIB_COMPONENTS_FORM_FIELD_INPUT_FORM_FIELD_INPUT_COMPONENT_TS__3 = goog.getMsg("{$interpolation}", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_2 = MSG_EXTERNAL___controlName___error$$LIB_COMPONENTS_FORM_FIELD_INPUT_FORM_FIELD_INPUT_COMPONENT_TS__3;
    }
    else {
        i18n_2 = $localize `:Error| Display any error ocurred for the field@@{{controlName}}-error␟6074c2c5ce7fbeecd76fa923a50efdc5d954058f␟6963966861158196265:${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
    } return [["appearance", "outline", 1, "nsc-ts-form-field", 3, "formGroup"], ["matInput", "", 3, "readonly", "value", "id", "formControlName", "maxlength", "placeholder", "type", "textMask"], ["matSuffix", "", "role", "img", "aria-hidden", "false", "aria-label", "Information", "tabindex", "0", 3, "id", "click", "keyup.enter", "keyup.space", 4, "ngIf"], i18n_0, ["class", "mat_hit_hidden", 4, "ngIf"], ["attr.aria-label", "content.errorMessage", 4, "ngIf"], ["matSuffix", "", "role", "img", "aria-hidden", "false", "aria-label", "Information", "tabindex", "0", 3, "id", "click", "keyup.enter", "keyup.space"], ["svgIcon", "assets:ts-info", 1, "nsc-ts-svgIcon__info"], [1, "mat_hit_hidden"], ["attr.aria-label", "content.errorMessage"], i18n_2]; }, template: function FormFieldInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-form-field", 0);
        ɵɵelementStart(1, "mat-label");
        ɵɵtext(2);
        ɵɵelementEnd();
        ɵɵelement(3, "input", 1);
        ɵɵtemplate(4, FormFieldInputComponent_div_4_Template, 2, 1, "div", 2);
        ɵɵelementStart(5, "mat-hint");
        ɵɵi18nStart(6, 3);
        ɵɵtemplate(7, FormFieldInputComponent_span_7_Template, 2, 0, "span", 4);
        ɵɵi18nEnd();
        ɵɵelementEnd();
        ɵɵtemplate(8, FormFieldInputComponent_mat_error_8_Template, 2, 1, "mat-error", 5);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("formGroup", ctx.group);
        ɵɵadvance(2);
        ɵɵtextInterpolate1(" ", ctx.placeholder, " ");
        ɵɵadvance(1);
        ɵɵpropertyInterpolate("value", ctx.value);
        ɵɵpropertyInterpolate1("id", "", ctx.controlName, "-field");
        ɵɵpropertyInterpolate("formControlName", ctx.controlName);
        ɵɵpropertyInterpolate("maxlength", ctx.maxlength);
        ɵɵpropertyInterpolate("placeholder", ctx.placeholder);
        ɵɵpropertyInterpolate("type", ctx.type);
        ɵɵproperty("readonly", ctx.readonly)("textMask", ɵɵpureFunction1(15, _c4, ctx.mask));
        ɵɵattribute("autocomplete", ctx.autocomplete);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.help);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.required);
        ɵɵi18nExp(ctx.content.hint);
        ɵɵi18nApply(6);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.group.controls[ctx.controlName].invalid);
    } }, directives: [MatFormField, NgControlStatusGroup, FormGroupDirective, MatLabel, MatInput, DefaultValueAccessor, NgControlStatus, FormControlName, MaxLengthValidator, MaskedInputDirective, NgIf, MatHint, MatSuffix, MatIcon, MatError], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(FormFieldInputComponent, [{
        type: Component,
        args: [{
                selector: 'ts-form-field-input',
                templateUrl: './form-field-input.component.html',
                styleUrls: ['./form-field-input.component.scss']
            }]
    }], function () { return [{ type: ValidationMessage }, { type: MatDialog }]; }, { autocomplete: [{
            type: Input
        }], controlName: [{
            type: Input
        }], group: [{
            type: Input
        }], hint: [{
            type: Input
        }], mask: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], required: [{
            type: Input
        }], suffix: [{
            type: Input
        }], type: [{
            type: Input
        }], idx: [{
            type: Input
        }], help: [{
            type: Input
        }], textMask: [{
            type: Input
        }], readonly: [{
            type: Input
        }], value: [{
            type: Input
        }] }); })();

class FormFieldInputModule {
}
FormFieldInputModule.ɵfac = function FormFieldInputModule_Factory(t) { return new (t || FormFieldInputModule)(); };
FormFieldInputModule.ɵmod = ɵɵdefineNgModule({ type: FormFieldInputModule });
FormFieldInputModule.ɵinj = ɵɵdefineInjector({ providers: [ValidationMessage], imports: [[
            CommonModule,
            MaterialModule,
            ReactiveFormsModule,
            TextMaskModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(FormFieldInputModule, { declarations: [FormFieldInputComponent], imports: [CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        TextMaskModule], exports: [FormFieldInputComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(FormFieldInputModule, [{
        type: NgModule,
        args: [{
                declarations: [FormFieldInputComponent],
                imports: [
                    CommonModule,
                    MaterialModule,
                    ReactiveFormsModule,
                    TextMaskModule
                ],
                providers: [ValidationMessage],
                exports: [FormFieldInputComponent]
            }]
    }], null, null); })();

function FormFieldConfirmComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 4);
    ɵɵelementStart(1, "ts-form-field-input", 5);
    ɵɵlistener("keydown", function FormFieldConfirmComponent_div_3_Template_ts_form_field_input_keydown_1_listener($event) { ɵɵrestoreView(_r2); const ctx_r1 = ɵɵnextContext(); return ctx_r1.handleSpace($event); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵpropertyInterpolate("controlName", ctx_r0.controlNameConfirm);
    ɵɵpropertyInterpolate("hint", ctx_r0.content.hintConfirm);
    ɵɵpropertyInterpolate("maxlength", ctx_r0.maxlength);
    ɵɵpropertyInterpolate1("placeholder", "Confirm ", ctx_r0.placeholder, "");
    ɵɵpropertyInterpolate("type", ctx_r0.type);
    ɵɵproperty("autocomplete", ctx_r0.values.autocompleteConfirm)("group", ctx_r0.group)("mask", ctx_r0.mask)("required", ctx_r0.requiredConfirm);
} }
class FormFieldConfirmComponent {
    constructor() {
        this.autocomplete = 'off';
        this.mask = false;
        this.requiredPrimary = true;
        this.requiredConfirm = true;
        this.type = 'text';
        this.content = {
            hintPrimary: null,
            hintConfirm: null
        };
        this.show = {
            confirm: null,
        };
        this.values = {
            // used to prevent the confirm field from being autopopulated;
            autocompleteConfirm: null,
            clipboarData: 'clipboardData'
        };
    }
    ngOnInit() {
        this.show.confirm = this.controlNameConfirm;
        // cf. https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
        // if the type is a password, browsers can override the random autocomplete value, so use 'new-password';
        this.values.autocompleteConfirm =
            this.type === 'password'
                ? 'new-password'
                : Math.random()
                    .toString(36)
                    .substring(7);
        // update validity of confirm field as the primary is changed;
        // so if the user enters in a valid value in confirm, and fixes the value in the primary;
        // the user will see the validator automatgically fix itself;
        if (this.show.confirm !== undefined && this.show.confirm !== null) {
            this.group.controls[this.controlNamePrimary].valueChanges.subscribe((value) => {
                if (value && value.length && this.show.confirm) {
                    this.group.controls[this.controlNameConfirm].updateValueAndValidity();
                }
            });
        }
        this.setHint();
    }
    ngOnChanges() {
        this.setHint();
    }
    handleSpace(e) {
        if (e && e.keyCode === 32) {
            return false;
        }
    }
    removeExtraSpaces(event) {
        // variable to be assigned the pasted value
        let clipboard;
        let dataTextType = '';
        // Accessing the pasted data in Chrome, Firefox, Edge browsers
        if (event && event.clipboardData) {
            clipboard = event.clipboardData;
            dataTextType = 'text/plain';
        }
        else if (window.clipboardData || window[this.values.clipboarData]) { // Accessing the pasted data in IE browser
            clipboard = window[this.values.clipboarData];
            dataTextType = 'text';
        }
        // removing spaces from data && extra data base on the maximun length allowed
        let pastedText = clipboard.getData(dataTextType).replace(/\s/g, '');
        if (this.maxlength) {
            const maxlengthText = Number(this.maxlength);
            if (maxlengthText > 0 && pastedText && pastedText.length > 0) {
                if (pastedText.length > maxlengthText) {
                    pastedText = pastedText.slice(0, -(pastedText.length - maxlengthText));
                }
            }
        }
        // setting up in the angular form
        this.group.controls[this.controlNamePrimary].setValue(pastedText);
        // Cancelling the event in order for the system to be updated the clipboarData with the new value
        // if we dont cancel the field will display the original value with the spaces.
        event.preventDefault();
    }
    setHint() {
        if (this.show.confirm !== undefined && this.show.confirm !== null) {
            // set the hints even if they're optional;
            this.content.hintPrimary = this.hint || '';
            this.content.hintConfirm = this.hint || '';
            // if the field is optional, show that (with the optional hint);
            if (this.requiredPrimary === false) {
                this.content.hintPrimary = `${this.content.hintPrimary}  `;
            }
            if (this.requiredConfirm === false) {
                this.content.hintConfirm = `${this.content.hintConfirm}  `;
            }
        }
    }
}
FormFieldConfirmComponent.ɵfac = function FormFieldConfirmComponent_Factory(t) { return new (t || FormFieldConfirmComponent)(); };
FormFieldConfirmComponent.ɵcmp = ɵɵdefineComponent({ type: FormFieldConfirmComponent, selectors: [["ts-form-field-confirm"]], inputs: { autocomplete: "autocomplete", controlNamePrimary: "controlNamePrimary", idx: "idx", controlNameConfirm: "controlNameConfirm", group: "group", hint: "hint", mask: "mask", maxlength: "maxlength", placeholder: "placeholder", requiredPrimary: "requiredPrimary", requiredConfirm: "requiredConfirm", type: "type" }, features: [ɵɵNgOnChangesFeature], decls: 4, vars: 11, consts: [[1, "row"], [3, "ngClass"], [3, "controlName", "hint", "maxlength", "placeholder", "type", "autocomplete", "group", "mask", "required", "paste", "keydown"], ["class", "col-12 col-md-6 col-lg-4", 4, "ngIf"], [1, "col-12", "col-md-6", "col-lg-4"], ["onPaste", "return false", "onCopy", "return false", 3, "controlName", "hint", "maxlength", "placeholder", "type", "autocomplete", "group", "mask", "required", "keydown"]], template: function FormFieldConfirmComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "ts-form-field-input", 2);
        ɵɵlistener("paste", function FormFieldConfirmComponent_Template_ts_form_field_input_paste_2_listener($event) { return ctx.removeExtraSpaces($event); })("keydown", function FormFieldConfirmComponent_Template_ts_form_field_input_keydown_2_listener($event) { return ctx.handleSpace($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(3, FormFieldConfirmComponent_div_3_Template, 2, 9, "div", 3);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ctx.show.confirm ? "col-12 col-md-6 col-lg-4" : "col-12");
        ɵɵadvance(1);
        ɵɵpropertyInterpolate("controlName", ctx.controlNamePrimary);
        ɵɵpropertyInterpolate("hint", ctx.content.hintPrimary);
        ɵɵpropertyInterpolate("maxlength", ctx.maxlength);
        ɵɵpropertyInterpolate("placeholder", ctx.placeholder);
        ɵɵpropertyInterpolate("type", ctx.type);
        ɵɵproperty("autocomplete", ctx.autocomplete)("group", ctx.group)("mask", ctx.mask)("required", ctx.requiredPrimary);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.show.confirm);
    } }, directives: [NgClass, FormFieldInputComponent, NgIf], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(FormFieldConfirmComponent, [{
        type: Component,
        args: [{
                selector: 'ts-form-field-confirm',
                templateUrl: './form-field-confirm.component.html',
                styleUrls: ['./form-field-confirm.component.scss']
            }]
    }], function () { return []; }, { autocomplete: [{
            type: Input
        }], controlNamePrimary: [{
            type: Input
        }], idx: [{
            type: Input
        }], controlNameConfirm: [{
            type: Input
        }], group: [{
            type: Input
        }], hint: [{
            type: Input
        }], mask: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], requiredPrimary: [{
            type: Input
        }], requiredConfirm: [{
            type: Input
        }], type: [{
            type: Input
        }] }); })();

class FormFieldConfirmModule {
}
FormFieldConfirmModule.ɵfac = function FormFieldConfirmModule_Factory(t) { return new (t || FormFieldConfirmModule)(); };
FormFieldConfirmModule.ɵmod = ɵɵdefineNgModule({ type: FormFieldConfirmModule });
FormFieldConfirmModule.ɵinj = ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormFieldInputModule,
            MaterialModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(FormFieldConfirmModule, { declarations: [FormFieldConfirmComponent], imports: [CommonModule,
        FormFieldInputModule,
        MaterialModule,
        ReactiveFormsModule], exports: [FormFieldConfirmComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(FormFieldConfirmModule, [{
        type: NgModule,
        args: [{
                declarations: [FormFieldConfirmComponent],
                imports: [
                    CommonModule,
                    FormFieldInputModule,
                    MaterialModule,
                    ReactiveFormsModule
                ],
                exports: [FormFieldConfirmComponent]
            }]
    }], null, null); })();

class DialogBoxService {
    constructor(dialog, dialogRef) {
        this.dialog = dialog;
        this.dialogRef = dialogRef;
    }
    // dialogRef: MatDialogRef<DialogBoxComponent>;
    openDialog(content) {
        this.dialog.open(DialogBoxComponent, {
            width: content.body.length > 200 ? '480px' : '310px',
            data: {
                autoFocus: false,
                title: content.title,
                body: content.body
            }
        });
    }
}
DialogBoxService.ɵfac = function DialogBoxService_Factory(t) { return new (t || DialogBoxService)(ɵɵinject(MatDialog), ɵɵinject(MatDialogRef)); };
DialogBoxService.ɵprov = ɵɵdefineInjectable({ token: DialogBoxService, factory: DialogBoxService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(DialogBoxService, [{
        type: Injectable
    }], function () { return [{ type: MatDialog }, { type: MatDialogRef }]; }, null); })();

class DialogBoxModule {
}
DialogBoxModule.ɵfac = function DialogBoxModule_Factory(t) { return new (t || DialogBoxModule)(); };
DialogBoxModule.ɵmod = ɵɵdefineNgModule({ type: DialogBoxModule });
DialogBoxModule.ɵinj = ɵɵdefineInjector({ providers: [
        SharedCommonValues,
        DialogBoxService
    ], imports: [[
            CommonModule,
            MaterialModule,
            SpacerModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(DialogBoxModule, { declarations: [DialogBoxComponent], imports: [CommonModule,
        MaterialModule,
        SpacerModule], exports: [DialogBoxComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(DialogBoxModule, [{
        type: NgModule,
        args: [{
                declarations: [DialogBoxComponent],
                imports: [
                    CommonModule,
                    MaterialModule,
                    SpacerModule
                ],
                // entryComponents: [DialogBoxComponent],
                providers: [
                    SharedCommonValues,
                    DialogBoxService
                ],
                exports: [DialogBoxComponent]
            }]
    }], null, null); })();

function FormFieldToggleComponent_mat_label_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-label", 13);
    ɵɵi18n(1, 14);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵpropertyInterpolate("id", ctx_r0.controlName);
    ɵɵadvance(1);
    ɵɵi18nExp(ctx_r0.label);
    ɵɵi18nApply(1);
} }
function FormFieldToggleComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 15);
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵpropertyInterpolate("id", ctx_r1.controlName);
    ɵɵpropertyInterpolate("innerHtml", ctx_r1.isHtmlContent, ɵɵsanitizeHtml);
} }
function FormFieldToggleComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 16);
    ɵɵlistener("click", function FormFieldToggleComponent_div_13_Template_div_click_0_listener() { ɵɵrestoreView(_r4); const ctx_r3 = ɵɵnextContext(); return ctx_r3.openDialog(); })("keyup.enter", function FormFieldToggleComponent_div_13_Template_div_keyup_enter_0_listener() { ɵɵrestoreView(_r4); const ctx_r5 = ɵɵnextContext(); return ctx_r5.openDialog(); })("keyup.space", function FormFieldToggleComponent_div_13_Template_div_keyup_space_0_listener() { ɵɵrestoreView(_r4); const ctx_r6 = ɵɵnextContext(); return ctx_r6.openDialog(); });
    ɵɵelement(1, "mat-icon", 17);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵpropertyInterpolate1("id", "toggle-", ctx_r2.controlName, "-help-icon");
} }
class FormFieldToggleComponent {
    constructor(sharedCommonValues, dialog) {
        this.sharedCommonValues = sharedCommonValues;
        this.dialog = dialog;
        this.disabled = false;
        this.required = true;
        this.selectedValue = null;
        this.idGroup = null;
        this.valueNo = this.sharedCommonValues.api.no;
        this.valueYes = this.sharedCommonValues.api.yes;
        this.ariaContent = '';
        this.values = {
            yes: this.valueYes,
            no: this.valueNo
        };
        this.hint = '';
    }
    ngOnInit() {
        // reset if the properties were defined (odd that it wasn't picked up during initialization);
        this.values = {
            yes: this.valueYes,
            no: this.valueNo
        };
        this.selectedValue = this.group.controls[this.controlName].value;
    }
    // button toggle to change the selected value;
    // this will trigger a listener to update the form requirements;
    changeValue(value) {
        const newValue = {};
        newValue[this.controlName] = value;
        this.selectedValue = value;
        this.group.patchValue(newValue);
    }
    clickBtn(value) {
        if (!this.disabled) {
            this.changeValue(value);
        }
    }
    openDialog() {
        const dialogRef = this.dialog.open(DialogBoxComponent, {
            width: this.help.length > 300 ? '480px' : '310px',
            autoFocus: false,
            data: {
                body: this.help
            }
        });
    }
}
FormFieldToggleComponent.ɵfac = function FormFieldToggleComponent_Factory(t) { return new (t || FormFieldToggleComponent)(ɵɵdirectiveInject(SharedCommonValues), ɵɵdirectiveInject(MatDialog)); };
FormFieldToggleComponent.ɵcmp = ɵɵdefineComponent({ type: FormFieldToggleComponent, selectors: [["ts-form-field-toggle"]], inputs: { controlName: "controlName", idx: "idx", disabled: "disabled", group: "group", help: "help", label: "label", note: "note", isHtmlContent: "isHtmlContent", classGroup: "classGroup", required: "required", selectedValue: "selectedValue", idGroup: "idGroup", valueNo: "valueNo", valueYes: "valueYes", ariaContent: "ariaContent" }, decls: 14, vars: 21, consts: function () { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc  Display a specific note for the group
         * @meaning note
         */
        const MSG_EXTERNAL_toggle___controlName___note$$LIB_COMPONENTS_FORM_FIELD_TOGGLE_FORM_FIELD_TOGGLE_COMPONENT_TS_1 = goog.getMsg(" {$interpolation}", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_0 = MSG_EXTERNAL_toggle___controlName___note$$LIB_COMPONENTS_FORM_FIELD_TOGGLE_FORM_FIELD_TOGGLE_COMPONENT_TS_1;
    }
    else {
        i18n_0 = $localize `:note| Display a specific note for the group@@toggle-{{controlName}}-note␟a63249e879f44509b85d109bbb17f322fe7fbc94␟4089009406001635750: ${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
    } let i18n_2; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_toggle___controlName___yes_btn$$LIB_COMPONENTS_FORM_FIELD_TOGGLE_FORM_FIELD_TOGGLE_COMPONENT_TS_3 = goog.getMsg("yes ");
        i18n_2 = MSG_EXTERNAL_toggle___controlName___yes_btn$$LIB_COMPONENTS_FORM_FIELD_TOGGLE_FORM_FIELD_TOGGLE_COMPONENT_TS_3;
    }
    else {
        i18n_2 = $localize `:@@toggle-{{controlName}}-yes-btn␟356187c81ce7816a765cd324fb2eb833db91ecdb␟7596653152940833331:yes `;
    } let i18n_4; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_toggle___controlName___no_btn$$LIB_COMPONENTS_FORM_FIELD_TOGGLE_FORM_FIELD_TOGGLE_COMPONENT_TS_5 = goog.getMsg("no ");
        i18n_4 = MSG_EXTERNAL_toggle___controlName___no_btn$$LIB_COMPONENTS_FORM_FIELD_TOGGLE_FORM_FIELD_TOGGLE_COMPONENT_TS_5;
    }
    else {
        i18n_4 = $localize `:@@toggle-{{controlName}}-no-btn␟82d01d94987596e19f237ba27f372baf95e963bd␟3788140257198135243:no `;
    } let i18n_6; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc Shows the question for the yes/no option
         * @meaning Toggle Label
         */
        const MSG_EXTERNAL_toggle___controlName___title$$LIB_COMPONENTS_FORM_FIELD_TOGGLE_FORM_FIELD_TOGGLE_COMPONENT_TS__7 = goog.getMsg("{$interpolation}", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_6 = MSG_EXTERNAL_toggle___controlName___title$$LIB_COMPONENTS_FORM_FIELD_TOGGLE_FORM_FIELD_TOGGLE_COMPONENT_TS__7;
    }
    else {
        i18n_6 = $localize `:Toggle Label|Shows the question for the yes/no option@@toggle-{{controlName}}-title␟2c9541dbd775dcc348f2fbc18a77cd2089fdab0b␟6433829452286779660:${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
    } return [[1, "nsc-ts-form-field-toggle__label"], ["class", "mat-body-2 ", 3, "id", 4, "ngIf"], ["class", "mat-body-2 ", 3, "id", "innerHtml", 4, "ngIf"], [1, "mat-caption", "mat-hint"], i18n_0, [1, "nsc-ts-form-field-toggle__actions"], [1, "radio-group", 3, "id", "name"], ["value", "YES", 1, "nsc-ts-radio-button", 3, "aria-label", "id", "disabled", "checked", "change", "click"], i18n_2, ["horizontal", "true"], ["value", "NO", 1, "nsc-ts-radio-button", 3, "aria-label", "id", "disabled", "checked", "change", "click"], i18n_4, ["class", "nsc-ts-form-field-toggle__help", "matSuffix", "", "aria-hidden", "false", "aria-label", "Information", "tabindex", "0", 3, "id", "click", "keyup.enter", "keyup.space", 4, "ngIf"], [1, "mat-body-2", 3, "id"], i18n_6, [1, "mat-body-2", 3, "id", "innerHtml"], ["matSuffix", "", "aria-hidden", "false", "aria-label", "Information", "tabindex", "0", 1, "nsc-ts-form-field-toggle__help", 3, "id", "click", "keyup.enter", "keyup.space"], ["svgIcon", "assets:ts-info", 1, "nsc-ts-svgIcon__info"]]; }, template: function FormFieldToggleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div");
        ɵɵelementStart(1, "div", 0);
        ɵɵtemplate(2, FormFieldToggleComponent_mat_label_2_Template, 2, 2, "mat-label", 1);
        ɵɵtemplate(3, FormFieldToggleComponent_div_3_Template, 1, 2, "div", 2);
        ɵɵelementStart(4, "mat-hint", 3);
        ɵɵi18n(5, 4);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(6, "div", 5);
        ɵɵelementStart(7, "mat-radio-group", 6);
        ɵɵelementStart(8, "mat-radio-button", 7);
        ɵɵlistener("change", function FormFieldToggleComponent_Template_mat_radio_button_change_8_listener() { return ctx.changeValue(ctx.values.yes); })("click", function FormFieldToggleComponent_Template_mat_radio_button_click_8_listener() { return ctx.clickBtn(ctx.values.yes); });
        ɵɵi18n(9, 8);
        ɵɵelementEnd();
        ɵɵelement(10, "ts-spacer", 9);
        ɵɵelementStart(11, "mat-radio-button", 10);
        ɵɵlistener("change", function FormFieldToggleComponent_Template_mat_radio_button_change_11_listener() { return ctx.changeValue(ctx.values.no); })("click", function FormFieldToggleComponent_Template_mat_radio_button_click_11_listener() { return ctx.clickBtn(ctx.values.no); });
        ɵɵi18n(12, 11);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(13, FormFieldToggleComponent_div_13_Template, 2, 1, "div", 12);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵclassMapInterpolate1("nsc-ts-form-field-toggle ", ctx.classGroup, "");
        ɵɵadvance(1);
        ɵɵclassProp("nsc-ts-form-field-toggle__label--disabled", ctx.disabled);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.label);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.isHtmlContent);
        ɵɵadvance(2);
        ɵɵi18nExp(ctx.note);
        ɵɵi18nApply(5);
        ɵɵadvance(2);
        ɵɵpropertyInterpolate1("id", "toggle-", ctx.controlName, "-group");
        ɵɵpropertyInterpolate("name", ctx.controlName);
        ɵɵattribute("aria-required", ctx.required)("aria-labelledby", ctx.controlName);
        ɵɵadvance(1);
        ɵɵpropertyInterpolate1("aria-label", "", ctx.controlName, "-yes");
        ɵɵpropertyInterpolate1("id", "toggle-", ctx.controlName, "-yes-btn");
        ɵɵproperty("disabled", ctx.disabled)("checked", ctx.group.controls[ctx.controlName].value === ctx.values.yes);
        ɵɵadvance(3);
        ɵɵpropertyInterpolate1("aria-label", "", ctx.controlName, "-no");
        ɵɵpropertyInterpolate1("id", "toggle-", ctx.controlName, "-no-btn");
        ɵɵproperty("disabled", ctx.disabled)("checked", ctx.group.controls[ctx.controlName].value === ctx.values.no);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.help);
    } }, directives: [NgIf, MatHint, MatRadioGroup, MatRadioButton, SpacerComponent, MatLabel, MatSuffix, MatIcon], styles: [".education-solutions-theme[_ngcontent-%COMP%]{--brand-color-1:#437c2b;--brand-color-2:#273f21;--brand-color-3:#6db944;--brand-color-4:#599a38;--brand-color-5:#e2f1da;--brand-color-6:rgba(109,185,68,0.2);--brand-color-7:#f3f9f0;--brand-color-8:rgba(109,185,68,0.08)}.nsc-ts-form-field-toggle[_ngcontent-%COMP%]{display:flex;align-items:center;width:100%;padding:.4375em 0 1.25em}.nsc-ts-form-field-toggle__label[_ngcontent-%COMP%]{padding-right:10px}.nsc-ts-form-field-toggle__label--disabled[_ngcontent-%COMP%]{color:rgba(0,0,0,.38)}.nsc-ts-form-field-toggle__label--disabled[_ngcontent-%COMP%]   .mat-hint[_ngcontent-%COMP%]{color:inherit}.nsc-ts-form-field-toggle__actions[_ngcontent-%COMP%]{white-space:nowrap}.nsc-ts-form-field-toggle__actions[_ngcontent-%COMP%]   .mat-radio-button[_ngcontent-%COMP%]{transition:background-color .2s ease;min-width:60px;line-height:36px;padding:0 16px;border-radius:6px;text-transform:uppercase;border:1px solid var(--brand-color-1);margin-right:0;color:var(--brand-color-1)}.nsc-ts-form-field-toggle__actions[_ngcontent-%COMP%]   .mat-radio-button[_ngcontent-%COMP%]:hover{cursor:pointer;transition:width .6s ease;color:var(--brand-color-2);background-color:#fff;border-color:var(--brand-color-2)}.nsc-ts-form-field-toggle__actions[_ngcontent-%COMP%]   .mat-radio-disabled[_ngcontent-%COMP%]{cursor:pointer!important}.nsc-ts-form-field-toggle__actions[_ngcontent-%COMP%]   .mat-radio-disabled.mat-radio-checked[_ngcontent-%COMP%]{font-weight:600}.nsc-ts-form-field-toggle__actions[_ngcontent-%COMP%]   .mat-radio-disabled.mat-radio-checked[_ngcontent-%COMP%], .nsc-ts-form-field-toggle__actions[_ngcontent-%COMP%]   .mat-radio-disabled.mat-radio-checked[_ngcontent-%COMP%]:hover{border-color:#c2c2c2;color:#444!important;background-color:#c2c2c2!important;box-shadow:none}.nsc-ts-form-field-toggle__actions[_ngcontent-%COMP%]   .mat-radio-disabled[_ngcontent-%COMP%]:hover{color:#c2c2c2;border-color:rgba(68,68,68,.75)}.nsc-ts-form-field-toggle__actions[_ngcontent-%COMP%]   .mat-radio-checked[_ngcontent-%COMP%]{color:#fff;background-color:var(--brand-color-1);border-color:var(--brand-color-1)}.nsc-ts-form-field-toggle__actions[_ngcontent-%COMP%]   .mat-radio-checked[_ngcontent-%COMP%]:hover{cursor:pointer;background-color:var(--brand-color-2);color:#fff;border-color:var(--brand-color-2)}.nsc-ts-form-field-toggle__help[_ngcontent-%COMP%]{cursor:pointer;margin-left:1rem}  .mat-radio-button.mat-accent .mat-radio-ripple .mat-ripple-element{display:none!important}  .mat-radio-button.mat-accent .mat-radio-label-content{padding-left:0}  .mat-radio-button .mat-radio-label{margin-bottom:0;justify-content:center}  .mat-radio-button .mat-radio-container{width:0}  .mat-radio-button .mat-radio-container .mat-radio-inner-circle,   .mat-radio-button .mat-radio-container .mat-radio-outer-circle{border:none;width:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(FormFieldToggleComponent, [{
        type: Component,
        args: [{
                selector: 'ts-form-field-toggle',
                templateUrl: './form-field-toggle.component.html',
                styleUrls: ['./form-field-toggle.component.scss']
            }]
    }], function () { return [{ type: SharedCommonValues }, { type: MatDialog }]; }, { controlName: [{
            type: Input
        }], idx: [{
            type: Input
        }], disabled: [{
            type: Input
        }], group: [{
            type: Input
        }], help: [{
            type: Input
        }], label: [{
            type: Input
        }], note: [{
            type: Input
        }], isHtmlContent: [{
            type: Input
        }], classGroup: [{
            type: Input
        }], required: [{
            type: Input
        }], selectedValue: [{
            type: Input
        }], idGroup: [{
            type: Input
        }], valueNo: [{
            type: Input
        }], valueYes: [{
            type: Input
        }], ariaContent: [{
            type: Input
        }] }); })();

// import { DialogBoxService } from '../../services/dialog-box/dialog-box.service';
class FormFieldToggleModule {
}
FormFieldToggleModule.ɵfac = function FormFieldToggleModule_Factory(t) { return new (t || FormFieldToggleModule)(); };
FormFieldToggleModule.ɵmod = ɵɵdefineNgModule({ type: FormFieldToggleModule });
FormFieldToggleModule.ɵinj = ɵɵdefineInjector({ providers: [SharedCommonValues], imports: [[
            // BrowserAnimationsModule,
            // BrowserModule,
            CommonModule,
            MaterialModule,
            SpacerModule,
            DialogBoxModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(FormFieldToggleModule, { declarations: [FormFieldToggleComponent], imports: [
        // BrowserAnimationsModule,
        // BrowserModule,
        CommonModule,
        MaterialModule,
        SpacerModule,
        DialogBoxModule], exports: [FormFieldToggleComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(FormFieldToggleModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    FormFieldToggleComponent,
                ],
                imports: [
                    // BrowserAnimationsModule,
                    // BrowserModule,
                    CommonModule,
                    MaterialModule,
                    SpacerModule,
                    DialogBoxModule
                ],
                // entryComponents: [DialogBoxComponent],
                providers: [SharedCommonValues],
                exports: [FormFieldToggleComponent]
            }]
    }], null, null); })();

class BlockingIndicatorComponent {
    constructor() { }
    ngOnInit() {
    }
}
BlockingIndicatorComponent.ɵfac = function BlockingIndicatorComponent_Factory(t) { return new (t || BlockingIndicatorComponent)(); };
BlockingIndicatorComponent.ɵcmp = ɵɵdefineComponent({ type: BlockingIndicatorComponent, selectors: [["ts-blocking-indicator"]], decls: 24, vars: 0, consts: function () { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_loading_img$$LIB_COMPONENTS_BLOCKING_INDICATOR_BLOCKING_INDICATOR_COMPONENT_TS_1 = goog.getMsg("Loading... Please wait");
        i18n_0 = MSG_EXTERNAL_loading_img$$LIB_COMPONENTS_BLOCKING_INDICATOR_BLOCKING_INDICATOR_COMPONENT_TS_1;
    }
    else {
        i18n_0 = $localize `:@@loading-img␟172fa0aab2cb9ffc177b03a45af1715e0b58997d␟2959370720191908927:Loading... Please wait`;
    } return [["id", "blockactivity", "tabindex", "0", "role", "alert", "aria-live", "assertive", "aria-label", "Loading...Please wait ", 1, "nsc-ts-overlay", "loading"], [1, "nsc-ts-treecontainer"], ["src", "assets/imgs/tree.svg", "title", i18n_0, "alt", "Loading... Please wait", 1, "nsc-ts-coinspin"], ["aria-hidden", "true", 1, "nsc-ts-letterrow"], [1, "nsc-ts-letter", "nsc-ts-letter-fold", 2, "animation-delay", "0.0s"], [1, "nsc-ts-letter", "nsc-ts-letter-fold", 2, "animation-delay", "0.1s"], [1, "nsc-ts-letter", "nsc-ts-letter-fold", 2, "animation-delay", "0.2s"], [1, "nsc-ts-letter", "nsc-ts-letter-fold", 2, "animation-delay", "0.3s"], [1, "nsc-ts-letter", "nsc-ts-letter-fold", 2, "animation-delay", "0.4s"], [1, "nsc-ts-letter", "nsc-ts-letter-fold", 2, "animation-delay", "0.5s"], [1, "nsc-ts-letter", "nsc-ts-letter-fold", 2, "animation-delay", "0.6s"], [1, "nsc-ts-letter", "nsc-ts-letter-fold", 2, "animation-delay", "0.7s"], [1, "nsc-ts-letter", "nsc-ts-letter-fold", 2, "animation-delay", "0.8s"], [1, "nsc-ts-letter", "nsc-ts-letter-fold", 2, "animation-delay", "0.9s"]]; }, template: function BlockingIndicatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelement(2, "img", 2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "div", 3);
        ɵɵelementStart(4, "div", 4);
        ɵɵtext(5, "L");
        ɵɵelementEnd();
        ɵɵelementStart(6, "div", 5);
        ɵɵtext(7, "o");
        ɵɵelementEnd();
        ɵɵelementStart(8, "div", 6);
        ɵɵtext(9, "a");
        ɵɵelementEnd();
        ɵɵelementStart(10, "div", 7);
        ɵɵtext(11, "d");
        ɵɵelementEnd();
        ɵɵelementStart(12, "div", 8);
        ɵɵtext(13, "i");
        ɵɵelementEnd();
        ɵɵelementStart(14, "div", 9);
        ɵɵtext(15, "n");
        ɵɵelementEnd();
        ɵɵelementStart(16, "div", 10);
        ɵɵtext(17, "g");
        ɵɵelementEnd();
        ɵɵelementStart(18, "div", 11);
        ɵɵtext(19, ".");
        ɵɵelementEnd();
        ɵɵelementStart(20, "div", 12);
        ɵɵtext(21, ".");
        ɵɵelementEnd();
        ɵɵelementStart(22, "div", 13);
        ɵɵtext(23, ".");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } }, styles: [".nsc-ts-letterrow[_ngcontent-%COMP%]{font-family:sans-serif;font-size:16px;display:flex;align-items:baseline;line-height:24px;color:#606060;justify-content:center;color:#fff}.nsc-ts-letter[_ngcontent-%COMP%]{position:relative;text-align:center;height:24px}.nsc-ts-letterfold[_ngcontent-%COMP%]{position:relative;top:0;transform:scaleX(0);-webkit-animation:letterfold 3s linear infinite;animation:letterfold 3s linear infinite}.nsc-ts-overlay[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;align-items:center;position:fixed;top:0;left:0;bottom:0;right:0;background-color:rgba(0,0,0,.5);background:radial-gradient(rgba(0,0,0,.5),rgba(0,0,0,.7));z-index:9999}.nsc-ts-treecontainer[_ngcontent-%COMP%]{width:150px;height:150px;perspective:400px}.nsc-ts-coinspin[_ngcontent-%COMP%]{-webkit-animation:coinspinAnim 3s ease infinite;animation:coinspinAnim 3s ease infinite}@-webkit-keyframes coinspinAnim{0%{transform:rotateY(0)}50%{transform:rotateY(180deg)}to{transform:rotateY(359.5deg)}}@keyframes coinspinAnim{0%{transform:rotateY(0)}50%{transform:rotateY(180deg)}to{transform:rotateY(359.5deg)}}@-webkit-keyframes letterfold{0%{transform:scaleX(0)}5%{transform:scaleX(1)}60%{transform:scaleX(1)}65%{transform:scaleX(0)}to{transform:scaleX(0)}}@keyframes letterfold{0%{transform:scaleX(0)}5%{transform:scaleX(1)}60%{transform:scaleX(1)}65%{transform:scaleX(0)}to{transform:scaleX(0)}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(BlockingIndicatorComponent, [{
        type: Component,
        args: [{
                selector: 'ts-blocking-indicator',
                templateUrl: './blocking-indicator.component.html',
                styleUrls: ['./blocking-indicator.component.scss']
            }]
    }], function () { return []; }, null); })();

class BlockingIndicatorModule {
}
BlockingIndicatorModule.ɵfac = function BlockingIndicatorModule_Factory(t) { return new (t || BlockingIndicatorModule)(); };
BlockingIndicatorModule.ɵmod = ɵɵdefineNgModule({ type: BlockingIndicatorModule });
BlockingIndicatorModule.ɵinj = ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(BlockingIndicatorModule, { declarations: [BlockingIndicatorComponent], imports: [CommonModule], exports: [BlockingIndicatorComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(BlockingIndicatorModule, [{
        type: NgModule,
        args: [{
                declarations: [BlockingIndicatorComponent],
                imports: [
                    CommonModule
                ],
                // entryComponents: [BlockingIndicatorComponent],
                exports: [BlockingIndicatorComponent]
            }]
    }], null, null); })();

class DataService {
    constructor(sharedCommonValues) {
        this.sharedCommonValues = sharedCommonValues;
        // emitter to let other components know when a recipient has been added to the data.form.recipients object;
        // lets the header know so it can update the shopping cart;
        this.recipientsUpdated = new EventEmitter();
        this.data = {
            // Added the sssRequestCheck to set this value when the request is coming in from Student Self Service
            sssRequestCheck: true,
            // school profile data obj;
            schoolProfile: null,
            // ellucian student profile data obj;
            studentProfile: null,
            // property config
            propertyConfig: null,
            // POST response data that drive application configuration/data;
            // only track the latest response;
            // not all POST responses matter, but if they do, they override the previous response;
            response: null,
            // store postOrder request headers
            request: null,
            // JWT token to pass in protected API calls;
            jsonWebToken: null,
            serviceAccountNumber: null,
            // user entered form data;
            form: {
                // information about the person making the transcript request;
                requestor: {
                    // Personal Information;
                    personal: {
                        clientReferenceId: null,
                        dob: null,
                        enrolledBefore: null,
                        enrolledCurrently: null,
                        zeroFeePrgmCurrEnroll: null,
                        state: null,
                        campus: null,
                        enrolledYearFrom: null,
                        enrolledYearTo: null,
                        nameChanged: null,
                        nameChangedFirst: null,
                        nameChangedLast: null,
                        nameChangedMiddle: null,
                        nameFirst: null,
                        nameLast: null,
                        nameMiddle: null,
                        path: null,
                        ssnConfirm: null,
                        ssnPrimary: null,
                        studentIdConfirm: null,
                        studentIdPrimary: null,
                        sendEmail: null
                    },
                    // Contact Information;
                    contact: {
                        addressLine1: null,
                        addressLine2: null,
                        city: null,
                        country: this.sharedCommonValues.api.us,
                        emailConfirm: null,
                        emailPrimary: null,
                        phone: null,
                        state: null,
                        textUpdates: null,
                        updateRecords: this.sharedCommonValues.api.no,
                        zip: null
                    },
                    // School Information;
                    attend: {
                        degree1: null,
                        degree2: null,
                        degree3: null,
                        degree4: null,
                        programs: null,
                        year1: null,
                        year2: null,
                        year3: null,
                        year4: null
                    }
                },
                // information about who will recieve the transcript;
                recipient: {
                    index: null,
                    fees: null,
                    // recipient route;
                    who: {
                        aamcAccountNumber: null,
                        amcasTranscriptIdNumber: null,
                        business: null,
                        casId: null,
                        country: this.sharedCommonValues.api.us,
                        department: null,
                        departmentNotInList: null,
                        emailConfirm: null,
                        emailPrimary: null,
                        lsacAccountNumber: null,
                        matchedUboxEntry: null,
                        oborDeliveryEligibility: null,
                        organization: null,
                        organizationNotInList: null,
                        recipientFiceCode: null,
                        recipientResponse: null,
                        recipientType: null,
                        school: null,
                        schoolNotInList: null,
                        sendElectronically: null,
                        state: null
                    },
                    // delivery-method route;
                    delivery: {
                        acceptTerms: null,
                        course1: null,
                        course2: null,
                        zeroFeeProgramEligible: null,
                        degreeTitle: null,
                        deliveryMethod: null,
                        howMany: null,
                        processingMethod: null,
                        program: null,
                        specialInstructions: null,
                        term: null,
                        transcriptWhen: null,
                        transcriptPurpose: null,
                        transcriptType: null,
                        ungradedTerm: null,
                        year: null
                    },
                    // recipient-address & recipient-address-electronic routes;
                    address: {
                        addressLine1: null,
                        addressLine2: null,
                        attention: null,
                        city: null,
                        country: this.sharedCommonValues.api.us,
                        emailConfirm: null,
                        emailPrimary: null,
                        phone: null,
                        recipient: null,
                        state: null,
                        zip: null,
                        isVerifiedAddress: null,
                        isAckgInvalidAddress: null,
                        enteredAddressLine1: null,
                        enteredAddressLine2: null
                    },
                    attachments: []
                },
                // all recipients for the order;
                recipients: [],
            }
        };
        this.dataEmpty = cloneDeep(this.data);
    }
    transformContent(content) {
        // these keys need special characters stripped from the value;
        const addressKeys = ['recipient', 'attention', 'addressLine1', 'addressLine2', 'city'];
        // these keys should not be transformed into uppercase;
        const dontTransform = ['jsonWebToken', 'degreeTitle', 'term', 'course1', 'course2'];
        // trim all string values;
        // and convert to uppercase;
        Object.keys(content).forEach((key, index) => {
            const shouldTransform = dontTransform.indexOf(key) === -1;
            if (typeof content[key] === 'string') {
                // if this is the JWT value, dont transform it;
                if (shouldTransform) {
                    content[key] = trim(content[key].toUpperCase());
                }
                // for address fields we need to remove the pipe character;
                if (addressKeys.indexOf(key) > -1) {
                    content[key] = content[key].replace(/\|/gi, '');
                }
            }
        });
        return content;
    }
    save(newContentObject, dataProperty) {
        const assignTarget = dataProperty ? get(this.data, dataProperty) : this.data;
        Object.assign(assignTarget, this.transformContent(newContentObject));
    }
    deleteAttachmentWithFileId(id) {
        Array.from(this.data.form.recipient.attachments).forEach((uploadedFile, index) => {
            if (uploadedFile.attachmentResponse && uploadedFile.attachmentResponse.status === 'success') {
                const tempAttachment = {
                    fileIdentifier: uploadedFile.attachmentResponse.fileIdentifier,
                    originalFileName: uploadedFile.attachmentResponse.originalFileName,
                    contentType: uploadedFile.attachmentResponse.contentType
                };
                if (tempAttachment.fileIdentifier === id) {
                    this.data.form.recipient.attachments.splice(index, 1);
                }
            }
        });
    }
    deleteRecipient(index) {
        this.data.form.recipients.splice(index, 1);
        this.emitRecipientCount();
        // console.log(_cloneDeep(this.data));
    }
    editRecipient(index) {
        this.data.form.recipient = cloneDeep(this.data.form.recipients[index]);
        // record the index so when done editing, we can replace the value;
        this.data.form.recipient.index = index;
        // console.log(_cloneDeep(this.data));
    }
    emitRecipientCount() {
        this.recipientsUpdated.emit(this.data.form.recipients.length);
    }
    isEnrolledBefore() {
        // if enrolledBefore is null, return false as we have no requirements from school profile.
        // else if enrolledBefore is not null, we check if it's value is 'Y' and if it is, return true because student was enrolledBefore therefore student should not see electronic delivery methods.
        // else if enrolledBefore is not null, we check if it's value is 'N' and if it is, return false because student was not enrolledBefore therefore you should see eletronic delivery methods.
        return (this.data.form.requestor.personal.enrolledBefore) ?
            (this.data.form.requestor.personal.enrolledBefore === this.sharedCommonValues.api.yes) : false;
    }
    isFeePathTypeF() {
        return this.data.response.orderHeader.feePathType === this.sharedCommonValues.api.free;
    }
    isFeePathTypeP() {
        return this.data.response.orderHeader.feePathType === this.sharedCommonValues.api.pay;
    }
    isElectronicPDFAvailable() {
        let electronicPDFAvailability = false;
        this.getFeePathType().deliveryMethods.forEach((option) => {
            if (option.deliveryMethodType === this.sharedCommonValues.api.electronic) {
                electronicPDFAvailability = true;
            }
        });
        return electronicPDFAvailability;
    }
    isElectronicETXAvailable() {
        let electronicETXAvailable = false;
        this.getFeePathType().deliveryMethods.forEach((option) => {
            if (option.deliveryMethodType === this.sharedCommonValues.api.etx) {
                electronicETXAvailable = true;
            }
        });
        return electronicETXAvailable;
    }
    isNotOnlyElectronicDeliveryMethod() {
        let isNotOnlyElectronicMethods = false;
        this.getFeePathType().deliveryMethods.forEach((option) => {
            if (option.deliveryMethodType !== this.sharedCommonValues.api.electronic && option.deliveryMethodType !== this.sharedCommonValues.api.etx) {
                isNotOnlyElectronicMethods = true;
            }
        });
        return isNotOnlyElectronicMethods;
    }
    isZeroFeePrgmEligible() {
        const who = this.data.form.recipient.who;
        // we know if this is an ETX recipient if a recipient had a response object, and the value isn't "not in list";
        return (who.recipientResponse !== null && (who.department !== null && who.department.toString() !== this.sharedCommonValues.select.notInList.value) &&
            (who.recipientResponse.zeroFeePrgmId != null && who.recipientResponse.zeroFeePrgmId > 0));
    }
    isUserNotAuthenticated() {
        return this.data.jsonWebToken === null;
    }
    isNullorBlank(text) {
        if (typeof text !== 'undefined' && text !== ' ' && text) {
            return false;
        }
        return true;
    }
    isSchoolEllucian() {
        return get(this.data.schoolProfile, 'integrationProvider', false) !== false;
    }
    isStudentVerified() {
        return get(this.data.studentProfile, 'verifiedStudentId', false) !== false;
    }
    isStudentNotFound() {
        const obj = this.data.studentProfile;
        // if the value is an empty object, then the student wasn't found;
        return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
    }
    // used in the security route checks;
    // if these return true (different routes have different checks), then the route won't be loaded;
    isSchoolNull() {
        return this.data.schoolProfile === null;
    }
    isRequireTermForDegreeRecords() {
        return get(this.data.schoolProfile, 'askDegreeTerm', null) === 'R';
    }
    isRecipientNull() {
        return this.data.form.recipient.who.recipientType === null;
    }
    isRecipientsEmpty() {
        return this.data.form.recipients.length === 0;
    }
    isIntegrationProviderSISCloudAPI() {
        const integrationProvider = this.getIntegrationProvider();
        return (integrationProvider && integrationProvider === this.sharedCommonValues.SISCloudAPIntegrationProvider);
    }
    get() {
        // return a read only clone so a controller can't manipulate the data directly;
        return cloneDeep(this.data);
    }
    getFullName() {
        const response = this.data.response.student;
        return `${response.firstName} ${response.middleName || ''} ${response.lastName}`.replace('  ', ' ');
    }
    getPreviousName() {
        const response = this.data.response.student;
        if ((response.schlFirstName != null) && (response.schlLastName != null)) {
            return `${response.schlFirstName} ${response.schlMiddleName || ''} ${response.schlLastName}`.replace('  ', ' ');
        }
    }
    getIntegrationProvider() {
        return get(this.data.schoolProfile, 'integrationProvider', null);
    }
    getNote(notesType) {
        const notesArray = filter(this.data.schoolProfile.toSchoolNotes, {
            notesType: notesType
        });
        return notesArray.length ? notesArray[0].notes : null;
    }
    getDeliveryMethodObject(id) {
        return filter(this.getFeePathType().deliveryMethods, {
            deliveryMethodId: id
        })[0];
    }
    getFeePathType() {
        if (this.isZeroFeePrgmEligible() || this.isSPDEZeroFeePrgmEligible()) {
            return this.isFeePathTypeP()
                ? this.data.schoolProfile.zeroPayOptions
                : this.data.schoolProfile.zeroFreeOptions;
        }
        else {
            return this.isFeePathTypeP()
                ? this.data.schoolProfile.payOptions
                : this.data.schoolProfile.freeOptions;
        }
    }
    getProcessingOptionObject(code) {
        return filter(this.data.schoolProfile.processingOptions, {
            code: code
        })[0];
    }
    getRecipient(index = null) {
        // index is defined when we want to get the recipient name for a recipient in the recipients[] array;
        // if index isn't defined, then we're dealing with the active recipient;
        const who = index !== null ? this.data.form.recipients[index].who : this.data.form.recipient.who;
        const isCollege = who.recipientType === this.sharedCommonValues.api.college;
        const isCollegeNotInList = who.school === this.sharedCommonValues.autocomplete.notInList.schlName.toUpperCase();
        const collegeValue = isCollegeNotInList ? who.schoolNotInList : who.school;
        const isOrganization = who.recipientType === this.sharedCommonValues.api.organization;
        const isOrganizationNotInList = who.organization === this.sharedCommonValues.autocomplete.notInList.schlName.toUpperCase();
        const organizationValue = isOrganizationNotInList
            ? who.organizationNotInList
            : who.organization;
        const isBusiness = who.recipientType === this.sharedCommonValues.api.business;
        const businessValue = who.business;
        // return either the college name, or the users name;
        return isCollege
            ? collegeValue
            : isOrganization
                ? organizationValue
                : isBusiness
                    ? businessValue
                    : this.getFullName();
    }
    getStudentTerms() {
        return get(this.data.studentProfile, 'ungradedTerms', []);
    }
    getSchlName() {
        return this.data.schoolProfile.schlName;
    }
    getStudentHolds() {
        return get(this.data.studentProfile, 'restrictions', []);
    }
    getStudentPrograms() {
        return get(this.data.studentProfile, 'programs', []);
    }
    getTotalFees() {
        let totalFee = 0;
        this.data.form.recipients.forEach(recipient => {
            const recptFees = recipient.fees;
            const totalFeeRecpt = recptFees.find((item) => item.name === 'totalFee');
            totalFee += totalFeeRecpt.value;
        });
        return totalFee;
    }
    getTranscriptTypeObject(id) {
        return find(this.getFeePathType().transcriptTypes, { xcriptTypeId: id });
    }
    getQuantityObject(id) {
        return find(this.getFeePathType().quantities, { quantityId: id });
    }
    getZeroOptions() {
        return this.isFeePathTypeP()
            ? this.data.schoolProfile.zeroPayOptions
            : this.data.schoolProfile.zeroFreeOptions;
    }
    getZeroFeeDeliveryMethodObject(id) {
        return filter(this.getZeroOptions().deliveryMethods, {
            deliveryMethodId: id
        })[0];
    }
    getZeroFeeTranscriptTypeObject(id) {
        return filter(this.getZeroOptions().transcriptTypes, {
            xcriptTypeId: id
        })[0];
    }
    getZeroFeeQuantityObject(id) {
        return filter(this.getZeroOptions().quantities, { quantityId: id })[0];
    }
    isSPDEZeroFeePrgmEligible(recipient) {
        const who = recipient ? recipient : this.data.form.recipient.who;
        if (who.recipientResponse && who.recipientResponse.exchangeNetworkType) {
            return this.getSPDEZeroFeeEligibilityByNetworkCode(who.recipientResponse.exchangeNetworkType);
        }
        return false;
    }
    getSPDEZeroFeeEligibilityByNetworkCode(exchangeNetworkType) {
        if (exchangeNetworkType && exchangeNetworkType === this.sharedCommonValues.api.speede) {
            const networkInfos = get(this.data.schoolProfile, 'networkInfos', []);
            const networkInfo = filter(networkInfos, {
                exchangeNetworkTypeCode: this.sharedCommonValues.api.speede
            });
            const isFeeReduceEligible = networkInfo.length > 0 ? get(networkInfo[0], 'isFeeReduceEligible', null) : null;
            if (isFeeReduceEligible && isFeeReduceEligible === this.sharedCommonValues.api.yes) {
                return true;
            }
        }
        return false;
    }
    resetDataObject() {
        this.data = cloneDeep(this.dataEmpty);
    }
    resetUserData() {
        this.data.form = cloneDeep(this.dataEmpty.form);
        this.data.response = cloneDeep(this.dataEmpty.response);
        this.data.studentProfile = cloneDeep(this.dataEmpty.studentProfile);
        this.data.schoolProfile = cloneDeep(this.dataEmpty.schoolProfile);
    }
    resetRequestorIdentification() {
        this.data.form.requestor.personal = cloneDeep(this.dataEmpty.form.requestor.personal);
    }
    resetDataForm() {
        this.data.form = cloneDeep(this.dataEmpty.form);
        this.data.response = cloneDeep(this.dataEmpty.response);
        this.data.studentProfile = cloneDeep(this.dataEmpty.studentProfile);
    }
    resetRequestorAttend() {
        this.data.form.requestor.attend = cloneDeep(this.dataEmpty.form.requestor.attend);
    }
    resetRecipientEmail() {
        this.data.form.recipient.address = cloneDeep(this.dataEmpty.form.recipient.address);
    }
    resetRecipientDeliveryMethod() {
        this.data.form.recipient.delivery = cloneDeep(this.dataEmpty.form.recipient.delivery);
    }
    resetRecipientAddress() {
        this.data.form.recipient.address = cloneDeep(this.dataEmpty.form.recipient.address);
    }
    resetRecipientSelect() {
        this.data.form.recipient.who = cloneDeep(this.dataEmpty.form.recipient.who);
    }
    // preserveIndex is for when a recipient is in edit mode, but changed;
    // without preserveIndex, then the app would act like a new recipient is being generated, and not replace the one being edited;
    resetRecipient(preserveIndex = false) {
        const index = preserveIndex ? this.data.form.recipient.index : null;
        this.data.form.recipient = cloneDeep(this.dataEmpty.form.recipient);
        if (index !== null) {
            this.data.form.recipient.index = index;
        }
    }
    saveRecipient() {
        const recipient = cloneDeep(this.data.form.recipient);
        const index = this.data.form.recipient.index;
        const recipients = this.data.form.recipients;
        // if in edit mode, replace the old recipient with the new recipient;
        // and reset the edit index because we're no longer editing a recipient;
        if (index !== null) {
            recipients[index] = recipient;
            // otherwise save the new recipient;
        }
        else {
            recipients.push(recipient);
        }
        // update the shopping cart count;
        this.emitRecipientCount();
        // reset the recipient since we're done with it;
        this.resetRecipient();
        // console.log(_cloneDeep(this.data));
    }
    showDegreeQuestions() {
        return this.data.schoolProfile.askDegrees === this.sharedCommonValues.api.optional;
    }
    showProgramQuestions() {
        const showQuestionsValues = [this.sharedCommonValues.api.optional, this.sharedCommonValues.api.required];
        const showQuestions = showQuestionsValues.indexOf(this.data.schoolProfile.askSchools) > -1;
        const haveQuestions = this.data.schoolProfile.attendSchoolLabels.length > 0;
        // only show the questions, if there we are suppose to, and there are questions to ask;
        return showQuestions && haveQuestions;
    }
    isNotNull(json) {
        // checks only null-undefined
        return json == null && json != null;
    }
}
DataService.ɵfac = function DataService_Factory(t) { return new (t || DataService)(ɵɵinject(SharedCommonValues)); };
DataService.ɵprov = ɵɵdefineInjectable({ token: DataService, factory: DataService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(DataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: SharedCommonValues }]; }, null); })();

function MessageComponent_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 8);
    ɵɵlistener("click", function MessageComponent_button_9_Template_button_click_0_listener() { ɵɵrestoreView(_r2); const ctx_r1 = ɵɵnextContext(); return ctx_r1.restart(); });
    ɵɵtext(1, "Restart Order");
    ɵɵelementEnd();
} }
class MessageComponent {
    constructor(activatedRoute, sharedCommonValues, dataService, router) {
        this.activatedRoute = activatedRoute;
        this.sharedCommonValues = sharedCommonValues;
        this.dataService = dataService;
        this.router = router;
        this.unsubscribe$ = new Subject();
        this.content = {
            title: '',
            message: '',
            error: {
                title: 'Temporary Service Interruption',
                message: 'A temporary service error was identified. Unfortunately, you will need to initiate a new transcript order request. We are sorry for this inconvenience. Please contact our customer service department at <a href="mailto:transcripts@studentclearinghouse.org">transcripts@studentclearinghouse.org</a> for further assistance if this error reoccurs. Thank you'
            },
            network: {
                title: 'Network Error',
                message: 'An error occurred during your order. Please check your Internet connection and try again. Thank you.'
            },
            payment: {
                title: 'Payment Error',
                message: 'We were unable to process your credit card and this order has been canceled. Please submit a new request.'
            },
            timeout: {
                title: 'Inactivity Timeout',
                message: 'The session has timed out due to inactivity and your order information has been cleared. Please restart the order.'
            },
        };
        this.show = {
            restartButton: true
        };
    }
    ngOnInit() {
        this.dataService.resetDataObject();
        this.activatedRoute.params.pipe(takeUntil(this.unsubscribe$)).subscribe(params => {
            if (this.content[params.reason]) {
                this.content.title = this.content[params.reason].title;
                this.content.message = this.content[params.reason].message;
                this.show.restartButton = false;
            }
            else {
                this.restart();
            }
        });
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    restart() {
        this.router.navigate([this.sharedCommonValues.routes.schoolSelect.routePath], this.sharedCommonValues.routes.extras);
    }
}
MessageComponent.ɵfac = function MessageComponent_Factory(t) { return new (t || MessageComponent)(ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(SharedCommonValues), ɵɵdirectiveInject(DataService), ɵɵdirectiveInject(Router)); };
MessageComponent.ɵcmp = ɵɵdefineComponent({ type: MessageComponent, selectors: [["ts-nsc-message"]], decls: 10, vars: 3, consts: [["novalidate", ""], [1, "row"], [1, "col-12", "col-md-10", "offset-md-1", "col-lg-8", "offset-lg-2"], [3, "title"], [1, "mat-typography", 3, "innerHTML"], ["size", "md"], [1, "nsc-ts-form-actions"], ["mat-raised-button", "", "class", "nsc-ts-form-actions__button", "color", "primary", "type", "button", 3, "click", 4, "ngIf"], ["mat-raised-button", "", "color", "primary", "type", "button", 1, "nsc-ts-form-actions__button", 3, "click"]], template: function MessageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "form", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "ts-card");
        ɵɵelement(4, "ts-card-title", 3);
        ɵɵelementStart(5, "ts-card-content");
        ɵɵelement(6, "div", 4);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(7, "ts-spacer", 5);
        ɵɵelementStart(8, "div", 6);
        ɵɵtemplate(9, MessageComponent_button_9_Template, 2, 0, "button", 7);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(4);
        ɵɵproperty("title", ctx.content.title);
        ɵɵadvance(2);
        ɵɵproperty("innerHTML", ctx.content.message, ɵɵsanitizeHtml);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.show.restartButton);
    } }, directives: [CardComponent, CardTitleComponent, CardContentComponent, SpacerComponent, NgIf], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(MessageComponent, [{
        type: Component,
        args: [{
                selector: 'ts-nsc-message',
                templateUrl: './message.component.html',
                styleUrls: ['./message.component.scss']
            }]
    }], function () { return [{ type: ActivatedRoute }, { type: SharedCommonValues }, { type: DataService }, { type: Router }]; }, null); })();

class MessageModule {
}
MessageModule.ɵfac = function MessageModule_Factory(t) { return new (t || MessageModule)(); };
MessageModule.ɵmod = ɵɵdefineNgModule({ type: MessageModule });
MessageModule.ɵinj = ɵɵdefineInjector({ imports: [[
            CommonModule,
            CardsModule,
            SpacerModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(MessageModule, { declarations: [MessageComponent], imports: [CommonModule,
        CardsModule,
        SpacerModule], exports: [MessageComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(MessageModule, [{
        type: NgModule,
        args: [{
                declarations: [MessageComponent],
                imports: [
                    CommonModule,
                    CardsModule,
                    SpacerModule
                ],
                // entryComponents: [MessageComponent],
                exports: [MessageComponent]
            }]
    }], null, null); })();

const _c0$4 = ["alertMessage"];
class DialogTimeoutComponent {
    constructor(dialogRef, timeoutService, renderer) {
        this.dialogRef = dialogRef;
        this.timeoutService = timeoutService;
        this.renderer = renderer;
        this.values = {
            countdownFrom: 118,
            count: 118,
            startTime: performance.now()
        };
        this.timeMinSec = this.convertTimeMinSec(this.returnTime(this.values.countdownFrom));
        this.content = {
            message: this.returnMessage(this.returnTime(this.values.countdownFrom), this.timeMinSec),
            convertedTimeMessage: this.returnConvertedMessage(this.returnTime(this.values.countdownFrom), this.timeMinSec)
        };
    }
    ngOnInit() {
        // start the countdown with an interval;
        // on each interval set the new number of seconds that will used to generate the displayed time;
        this.countdown$ = interval(1000).pipe(map(n => {
            return this.getTimeRemaining();
        }));
        // create a subscription that listens to the observable;
        this.countdownSubscription = this.countdown$.subscribe(n => {
            // parse the time based on the number of seconds;
            const time = this.returnTime(n);
            // determine if the timer has reached zero;
            const atZero = n === 0;
            // time needs to be split in order the screen reader read time correctly
            this.timeMinSec = this.convertTimeMinSec(time);
            // set the message based on the amount of time left;
            this.content.message = this.returnMessage(time, this.timeMinSec);
            this.content.convertedTimeMessage = this.returnConvertedMessage(time, this.timeMinSec);
            // once the countdown hits zero;
            // kill the subscription (for to save memory);
            // and end the user session;
            if (atZero) {
                this.countdownSubscription.unsubscribe();
                this.timeoutService.endSession();
                this.dialogRef.close();
            }
        });
    }
    //find the time remaining by seeing how much time has elapsed since
    //the component was initialized. Necessary if app is running on a background tab
    getTimeRemaining() {
        const currentTime = performance.now();
        var timeDiff = currentTime - this.values.startTime; //in ms
        // strip the ms
        timeDiff /= 1000;
        // get seconds 
        var secondsPassed = Math.round(timeDiff);
        //console.log(secondsPassed + " seconds have elapsed");
        // get seconds remaining
        var secondsRemaining = this.values.count = (this.values.countdownFrom - secondsPassed) > 0 ?
            (this.values.countdownFrom - secondsPassed) :
            0;
        return secondsRemaining;
    }
    // abstracted to its own method so it can be used in in the subscription and during initalization;
    returnMessage(time, timeMinSec) {
        return `Your session is about to expire in ${time} ${timeMinSec.intMin > 0 ? 'minutes' : 'seconds'}. Please select OK to renew the session, or your work might be lost.`;
    }
    // custom message for screen reader
    returnConvertedMessage(time, timeMinSec) {
        // converting min to seconds
        const minSec = (timeMinSec.intMin * 60) + timeMinSec.intSec;
        // check if popup is present
        if (this.el) {
            // screen reader needs to be announced every 30 sec
            // condition to check that
            if ((minSec % 30) === 0) {
                if (minSec <= 3) {
                    this.removeAttr();
                }
                else {
                    // setting attributes in order to be announced the time
                    this.renderer.setAttribute(this.el.nativeElement, 'aria-atomic', 'true');
                    this.renderer.setAttribute(this.el.nativeElement, 'aria-live', 'polite');
                }
            }
            else {
                this.removeAttr();
            }
        }
        // we are checking for less than 2 sec because we dont need that the session will expire in 0 sec ( otherwise blind people can get confuse with it)
        // message sending as string instead of template
        if (minSec < 2) {
            return 'Session expired';
        }
        else {
            return 'Your session is about to expire in' + timeMinSec.txtMinutes + timeMinSec.intSec + 'seconds. Please select OK to renew the session, or your work might be lost.';
        }
    }
    // abstract min and sec
    convertTimeMinSec(time) {
        const obj = {};
        const splitTime = (time.split(':'));
        obj.intSec = +(splitTime[1]);
        obj.intMin = +(splitTime[0]);
        // if minutes are 0 then should not be read and show in the popup
        obj.txtMinutes = obj.intMin > 0 ? (obj.intMin + 'minutes') : '';
        return obj;
    }
    removeAttr() {
        this.renderer.removeAttribute(this.el.nativeElement, 'aria-atomic');
        this.renderer.removeAttribute(this.el.nativeElement, 'aria-live');
    }
    // abstracted to its own method so it can be used in in the subscription and during initalization;
    returnTime(n) {
        return new Date(n * 1000).toISOString().substr(15, 4);
    }
    // start the countdown again when the user clicks OK;
    resetCountdown() {
        this.countdownSubscription.unsubscribe();
        this.dialogRef.close();
        // if there was time left, that means the user session is still valid;
        // so start the timer again;
        if (this.values.count) {
            this.timeoutService.startWarningCountdown();
        }
    }
}
DialogTimeoutComponent.ɵfac = function DialogTimeoutComponent_Factory(t) { return new (t || DialogTimeoutComponent)(ɵɵdirectiveInject(MatDialogRef), ɵɵdirectiveInject(TimeoutService), ɵɵdirectiveInject(Renderer2)); };
DialogTimeoutComponent.ɵcmp = ɵɵdefineComponent({ type: DialogTimeoutComponent, selectors: [["ts-dialog-timeout"]], viewQuery: function DialogTimeoutComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$4, 1);
    } if (rf & 2) {
        let _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.el = _t.first);
    } }, decls: 10, vars: 3, consts: function () { let i18n_1; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc  Displays the  time before the session expires
         * @meaning Dialog timeout content
         */
        const MSG_EXTERNAL_timeout_message$$LIB_COMPONENTS_DIALOG_TIMEOUT_DIALOG_TIMEOUT_COMPONENT_TS_2 = goog.getMsg(" {$interpolation}", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_1 = MSG_EXTERNAL_timeout_message$$LIB_COMPONENTS_DIALOG_TIMEOUT_DIALOG_TIMEOUT_COMPONENT_TS_2;
    }
    else {
        i18n_1 = $localize `:Dialog timeout content | Displays the  time before the session expires@@timeout-message␟4556758d31142f2170729ddff3d3269718fefcf7␟8554056558729042083: ${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
    } return [["mat-dialog-title", ""], ["role", "dialog", "aria-labelledby", "message", "aria-modal", "true", "id", "message", 1, "nsc-ts-dialog__content", "mat-typography"], ["alertMessage", ""], ["aria-hidden", "true"], i18n_1, ["align", "end"], ["id", "timeout-ok-btn", "mat-raised-button", "", "color", "primary", "type", "button", "cdkFocusInitial", "", 3, "mat-dialog-close", "click"]]; }, template: function DialogTimeoutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "h4", 0);
        ɵɵtext(1, " System Timeout\n");
        ɵɵelementEnd();
        ɵɵelementStart(2, "mat-dialog-content", 1, 2);
        ɵɵelementStart(4, "p", 3);
        ɵɵi18n(5, 4);
        ɵɵelementEnd();
        ɵɵelement(6, "span");
        ɵɵelementEnd();
        ɵɵelementStart(7, "mat-dialog-actions", 5);
        ɵɵelementStart(8, "button", 6);
        ɵɵlistener("click", function DialogTimeoutComponent_Template_button_click_8_listener() { return ctx.resetCountdown(); });
        ɵɵtext(9, "OK");
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(5);
        ɵɵi18nExp(ctx.content.message);
        ɵɵi18nApply(5);
        ɵɵadvance(1);
        ɵɵattribute("aria-label", ctx.content.convertedTimeMessage);
        ɵɵadvance(2);
        ɵɵproperty("mat-dialog-close", true);
    } }, directives: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatDialogClose], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(DialogTimeoutComponent, [{
        type: Component,
        args: [{
                selector: 'ts-dialog-timeout',
                templateUrl: './dialog-timeout.component.html',
                styleUrls: ['./dialog-timeout.component.scss']
            }]
    }], function () { return [{ type: MatDialogRef }, { type: TimeoutService }, { type: Renderer2 }]; }, { el: [{
            type: ViewChild,
            args: ['alertMessage']
        }] }); })();

class DialogTimeoutModule {
}
DialogTimeoutModule.ɵfac = function DialogTimeoutModule_Factory(t) { return new (t || DialogTimeoutModule)(); };
DialogTimeoutModule.ɵmod = ɵɵdefineNgModule({ type: DialogTimeoutModule });
DialogTimeoutModule.ɵinj = ɵɵdefineInjector({ imports: [[
            CommonModule,
            CardsModule,
            MaterialModule,
            SpacerModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(DialogTimeoutModule, { declarations: [DialogTimeoutComponent], imports: [CommonModule,
        CardsModule,
        MaterialModule,
        SpacerModule], exports: [DialogTimeoutComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(DialogTimeoutModule, [{
        type: NgModule,
        args: [{
                declarations: [DialogTimeoutComponent],
                imports: [
                    CommonModule,
                    CardsModule,
                    MaterialModule,
                    SpacerModule
                ],
                // entryComponents: [ DialogTimeoutComponent],
                exports: [DialogTimeoutComponent]
            }]
    }], null, null); })();

class SecurityService {
    constructor() {
        this.showDeactivateWarning = false;
        this.handleSecurityInApp$ = new Subject();
    }
    canDeactivate() {
        const confirmMessage = 
        // tslint:disable-next-line:max-line-length
        'We do not recommend using the browser back button if you want to proceed with this order. To exit the Transcript Ordering Center, please select ‘OK’. If you would like to continue with your order but require changes, select ‘Cancel’ and review the available editing options.';
        return this.showDeactivateWarning ? window.confirm(confirmMessage) : true;
    }
    canActivate(route, state) {
        return true;
    }
    setDeactivateWarning(value) {
        this.showDeactivateWarning = value;
    }
    // if any security check fails, load the school-select route;
    loadSafeURL(currentUrlPath) {
        this.setDeactivateWarning(false);
    }
    // `cancel order` button click;
    // reset any user entered data, then load the school-select route;
    cancelOrder() {
        const confirmMessage = 'This order will be canceled. You will not be charged for this order. To continue canceling the order, select OK';
        if (window.confirm(confirmMessage)) {
            this.setDeactivateWarning(false);
        }
    }
    catchResponse(error, apiName) {
        console.error(error);
        this.setDeactivateWarning(false);
        const obj = {
            actionType: 'catchResponse',
            apiName,
            response: error
        };
        this.handleSecurityInApp$.next(obj);
        // stop the chain, so the subscribe method doesn't fire;
        return EMPTY;
    }
    // use this when error while calling a service can be ignored and user can continue forward
    ignoreError(error) {
        // stop the chain, so the subscribe method doesn't fire;
        console.error(error);
        return EMPTY;
    }
}
SecurityService.ɵfac = function SecurityService_Factory(t) { return new (t || SecurityService)(); };
SecurityService.ɵprov = ɵɵdefineInjectable({ token: SecurityService, factory: SecurityService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(SecurityService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class SystemMessagesService {
    constructor(http, securityService) {
        this.http = http;
        this.securityService = securityService;
        this.data$ = new BehaviorSubject([]);
        this.unsubscribe$ = new Subject();
    }
    ngOnDestroy() {
        this.unsubscribe();
    }
    unsubscribe() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    getData() {
        this.http
            .get('/api/system/message')
            .pipe(takeUntil(this.unsubscribe$), catchError(error => this.securityService.ignoreError(error)))
            .subscribe((data) => {
            this.data$.next(data);
        });
    }
    setData(data) {
        this.data$.next(data);
    }
}
SystemMessagesService.ɵfac = function SystemMessagesService_Factory(t) { return new (t || SystemMessagesService)(ɵɵinject(HttpClient), ɵɵinject(SecurityService)); };
SystemMessagesService.ɵprov = ɵɵdefineInjectable({ token: SystemMessagesService, factory: SystemMessagesService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(SystemMessagesService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: SecurityService }]; }, null); })();

function SystemMessageComponent_div_0_p_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p");
    ɵɵelementStart(1, "strong");
    ɵɵi18n(2, 7);
    ɵɵelementEnd();
    ɵɵtext(3);
    ɵɵelementEnd();
} if (rf & 2) {
    const message_r2 = ctx.$implicit;
    ɵɵadvance(2);
    ɵɵi18nExp(message_r2.titleDescription);
    ɵɵi18nApply(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(": ", message_r2.message, " ");
} }
function SystemMessageComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "ts-card", 1);
    ɵɵelementStart(2, "ts-card-title", 2);
    ɵɵi18n(3, 3);
    ɵɵelementEnd();
    ɵɵelementStart(4, "ts-card-content");
    ɵɵelementStart(5, "div", 4);
    ɵɵtemplate(6, SystemMessageComponent_div_0_p_6_Template, 4, 2, "p", 5);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelement(7, "ts-spacer", 6);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("error", true);
    ɵɵadvance(4);
    ɵɵproperty("ngForOf", ctx_r0.systemMessages.data$.value);
} }
class SystemMessageComponent {
    constructor(systemMessages) {
        this.systemMessages = systemMessages;
    }
    ngOnInit() {
        this.systemMessages.getData();
    }
}
SystemMessageComponent.ɵfac = function SystemMessageComponent_Factory(t) { return new (t || SystemMessageComponent)(ɵɵdirectiveInject(SystemMessagesService)); };
SystemMessageComponent.ɵcmp = ɵɵdefineComponent({ type: SystemMessageComponent, selectors: [["ts-system-message"]], decls: 1, vars: 1, consts: function () { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_system_error_message$$LIB_COMPONENTS_SYSTEM_MESSAGE_SYSTEM_MESSAGE_COMPONENT_TS__1 = goog.getMsg("System Messages");
        i18n_0 = MSG_EXTERNAL_system_error_message$$LIB_COMPONENTS_SYSTEM_MESSAGE_SYSTEM_MESSAGE_COMPONENT_TS__1;
    }
    else {
        i18n_0 = $localize `:@@system-error-message␟37eec2f95b4aef571c8e0417f16a670693cb6e8f␟3903778330042462634:System Messages`;
    } let i18n_2; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_system_error_content$$LIB_COMPONENTS_SYSTEM_MESSAGE_SYSTEM_MESSAGE_COMPONENT_TS___3 = goog.getMsg("{$interpolation}", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_2 = MSG_EXTERNAL_system_error_content$$LIB_COMPONENTS_SYSTEM_MESSAGE_SYSTEM_MESSAGE_COMPONENT_TS___3;
    }
    else {
        i18n_2 = $localize `:@@system-error-content␟486d9b1d8e8c1d5e4b56a7e3ff7639000d3fc7be␟7968173687258939957:${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
    } return [[4, "ngIf"], [1, "nsc-ts-card--error"], [3, "error"], i18n_0, [1, "mat-typography"], [4, "ngFor", "ngForOf"], ["size", "md"], i18n_2]; }, template: function SystemMessageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, SystemMessageComponent_div_0_Template, 8, 2, "div", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.systemMessages.data$.value.length);
    } }, directives: [NgIf, CardComponent, CardTitleComponent, CardContentComponent, NgForOf, SpacerComponent], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(SystemMessageComponent, [{
        type: Component,
        args: [{
                selector: 'ts-system-message',
                templateUrl: './system-message.component.html',
                styleUrls: ['./system-message.component.scss']
            }]
    }], function () { return [{ type: SystemMessagesService }]; }, null); })();

class SystemMessageModule {
}
SystemMessageModule.ɵfac = function SystemMessageModule_Factory(t) { return new (t || SystemMessageModule)(); };
SystemMessageModule.ɵmod = ɵɵdefineNgModule({ type: SystemMessageModule });
SystemMessageModule.ɵinj = ɵɵdefineInjector({ imports: [[
            CommonModule,
            CardsModule,
            SpacerModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(SystemMessageModule, { declarations: [SystemMessageComponent], imports: [CommonModule,
        CardsModule,
        SpacerModule], exports: [SystemMessageComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(SystemMessageModule, [{
        type: NgModule,
        args: [{
                declarations: [SystemMessageComponent],
                imports: [
                    CommonModule,
                    CardsModule,
                    SpacerModule
                ],
                exports: [SystemMessageComponent]
            }]
    }], null, null); })();

function FormFieldSelectComponent_mat_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-option", 6);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const obj_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r0 = ɵɵnextContext();
    ɵɵpropertyInterpolate2("id", "dropdown-", ctx_r0.controlName, "-option-", i_r3, "");
    ɵɵproperty("value", obj_r2.value);
    ɵɵattribute("aria-selected", obj_r2.value === ctx_r0.selectedValue.id ? true : false)("aria-label", obj_r2.name);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", obj_r2.name, " ");
} }
function FormFieldSelectComponent_mat_error_9_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵi18nStart(0, 7, 1);
    ɵɵelement(1, "span");
    ɵɵi18nEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵattribute("aria-label", ctx_r4.content.errorMessage);
} }
function FormFieldSelectComponent_mat_error_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-error");
    ɵɵi18nStart(1, 7);
    ɵɵtemplate(2, FormFieldSelectComponent_mat_error_9_span_2_Template, 2, 1, "span", 5);
    ɵɵi18nEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r1.group.controls[ctx_r1.controlName].touched);
    ɵɵi18nExp(ctx_r1.setErrorMessage(ctx_r1.group.controls[ctx_r1.controlName], ctx_r1.placeholder));
    ɵɵi18nApply(1);
} }
class FormFieldSelectComponent {
    constructor(validationMessage, sharedCommonValues) {
        this.validationMessage = validationMessage;
        this.sharedCommonValues = sharedCommonValues;
        this.loading = false;
        this.required = true;
        this.selectedValue = {
            value: null,
            name: null,
        };
        this.content = {
            hint: '',
            errorMessage: ''
        };
    }
    ngOnInit() {
        if (this.group.controls[this.controlName].value) {
            const controls = this.group.controls[this.controlName].value;
            const selectObjectsList = cloneDeep(this.selectObjects);
            // tslint:disable-next-line: no-shadowed-variable
            const selectedValueTemp = find(selectObjectsList => {
                if (selectObjectsList.value === controls) {
                    return selectObjectsList;
                }
            });
            if (typeof selectedValueTemp !== this.sharedCommonValues.api.undefined && selectedValueTemp != null) {
                this.selectedValue = selectedValueTemp;
            }
        }
    }
    changeValue(value) {
        this.selectedValue.name = value.source.selected.viewValue;
        this.selectedValue.id = value.source.selected.value;
    }
    openedChange(opened) {
        this.selectedValue.opened = opened ? true : false;
    }
    setErrorMessage(controlName, placeholder) {
        this.content.errorMessage = this.validationMessage.get(controlName, placeholder);
        return (this.content.hint + this.content.errorMessage);
    }
}
FormFieldSelectComponent.ɵfac = function FormFieldSelectComponent_Factory(t) { return new (t || FormFieldSelectComponent)(ɵɵdirectiveInject(ValidationMessage), ɵɵdirectiveInject(SharedCommonValues)); };
FormFieldSelectComponent.ɵcmp = ɵɵdefineComponent({ type: FormFieldSelectComponent, selectors: [["ts-form-field-select"]], inputs: { controlName: "controlName", idx: "idx", group: "group", hint: "hint", placeholder: "placeholder", selectObjects: "selectObjects", loading: "loading", required: "required" }, decls: 10, vars: 13, consts: function () { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc  Display any instructional txt for the field
         * @meaning Hint
         */
        const MSG_EXTERNAL_dropdown___controlName___hint$$LIB_COMPONENTS_FORM_FIELD_SELECT_FORM_FIELD_SELECT_COMPONENT_TS_1 = goog.getMsg("{$interpolation} {$startTagSpan}{$closeTagSpan}{$startTagSpan_1}{$closeTagSpan}", { "interpolation": "\uFFFD0\uFFFD", "startTagSpan": "\uFFFD#7\uFFFD", "closeTagSpan": "[\uFFFD/#7\uFFFD|\uFFFD/#8\uFFFD]", "startTagSpan_1": "\uFFFD#8\uFFFD" });
        i18n_0 = MSG_EXTERNAL_dropdown___controlName___hint$$LIB_COMPONENTS_FORM_FIELD_SELECT_FORM_FIELD_SELECT_COMPONENT_TS_1;
    }
    else {
        i18n_0 = $localize `:Hint| Display any instructional txt for the field@@dropdown-{{controlName}}-hint␟0a833eb8a7a1abe5fe181c0a6d10170c7b8b8fce␟2998508059769545697:${"\uFFFD0\uFFFD"}:INTERPOLATION: ${"\uFFFD#7\uFFFD"}:START_TAG_SPAN:${"[\uFFFD/#7\uFFFD|\uFFFD/#8\uFFFD]"}:CLOSE_TAG_SPAN:${"\uFFFD#8\uFFFD"}:START_TAG_SPAN_1:${"[\uFFFD/#7\uFFFD|\uFFFD/#8\uFFFD]"}:CLOSE_TAG_SPAN:`;
    } i18n_0 = ɵɵi18nPostprocess(i18n_0); let i18n_2; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc  Display any error ocurred for the field
         * @meaning Error
         */
        const MSG_EXTERNAL_dropdown___controlName___error$$LIB_COMPONENTS_FORM_FIELD_SELECT_FORM_FIELD_SELECT_COMPONENT_TS___3 = goog.getMsg("{$startTagSpan}{$closeTagSpan}{$interpolation}", { "startTagSpan": "\uFFFD*2:1\uFFFD\uFFFD#1:1\uFFFD", "closeTagSpan": "\uFFFD/#1:1\uFFFD\uFFFD/*2:1\uFFFD", "interpolation": "\uFFFD0\uFFFD" });
        i18n_2 = MSG_EXTERNAL_dropdown___controlName___error$$LIB_COMPONENTS_FORM_FIELD_SELECT_FORM_FIELD_SELECT_COMPONENT_TS___3;
    }
    else {
        i18n_2 = $localize `:Error| Display any error ocurred for the field@@dropdown-{{controlName}}-error␟26c46d76c8d18af7b544ce7dc457746dc3781307␟6255887143054136232:${"\uFFFD*2:1\uFFFD\uFFFD#1:1\uFFFD"}:START_TAG_SPAN:${"\uFFFD/#1:1\uFFFD\uFFFD/*2:1\uFFFD"}:CLOSE_TAG_SPAN:${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
    } return [["appearance", "outline", 1, "nsc-ts-form-field", 3, "formGroup", "ngClass"], [3, "id", "formControlName", "placeholder", "value", "openedChange", "selectionChange", "valueChange"], [3, "id", "value", 4, "ngFor", "ngForOf"], i18n_0, ["aria-live", "assertive"], [4, "ngIf"], [3, "id", "value"], i18n_2]; }, template: function FormFieldSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-form-field", 0);
        ɵɵelementStart(1, "mat-label");
        ɵɵtext(2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "mat-select", 1);
        ɵɵlistener("openedChange", function FormFieldSelectComponent_Template_mat_select_openedChange_3_listener($event) { return ctx.openedChange($event); })("selectionChange", function FormFieldSelectComponent_Template_mat_select_selectionChange_3_listener($event) { return ctx.changeValue($event); })("valueChange", function FormFieldSelectComponent_Template_mat_select_valueChange_3_listener($event) { return ctx.selectedValue.id = $event; });
        ɵɵtemplate(4, FormFieldSelectComponent_mat_option_4_Template, 2, 6, "mat-option", 2);
        ɵɵelementEnd();
        ɵɵelementStart(5, "mat-hint");
        ɵɵi18nStart(6, 3);
        ɵɵelement(7, "span");
        ɵɵelement(8, "span", 4);
        ɵɵi18nEnd();
        ɵɵelementEnd();
        ɵɵtemplate(9, FormFieldSelectComponent_mat_error_9_Template, 3, 2, "mat-error", 5);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("formGroup", ctx.group)("ngClass", ctx.loading ? "nsc-ts-form-field-loading" : "");
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.placeholder);
        ɵɵadvance(1);
        ɵɵpropertyInterpolate1("id", "dropdown-", ctx.controlName, "");
        ɵɵproperty("formControlName", ctx.controlName)("placeholder", ctx.placeholder)("value", ctx.selectedValue.id);
        ɵɵattribute("aria-expanded", ctx.selectedValue.opened);
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.selectObjects);
        ɵɵadvance(3);
        ɵɵattribute("aria-label", ctx.required ? "required" : "");
        ɵɵadvance(1);
        ɵɵattribute("aria-label", ctx.selectedValue.name);
        ɵɵi18nExp(ctx.hint);
        ɵɵi18nApply(6);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.group.controls[ctx.controlName].invalid);
    } }, directives: [MatFormField, NgControlStatusGroup, FormGroupDirective, NgClass, MatLabel, MatSelect, NgControlStatus, FormControlName, NgForOf, MatHint, NgIf, MatOption, MatError], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(FormFieldSelectComponent, [{
        type: Component,
        args: [{
                selector: 'ts-form-field-select',
                templateUrl: './form-field-select.component.html',
                styleUrls: ['./form-field-select.component.scss']
            }]
    }], function () { return [{ type: ValidationMessage }, { type: SharedCommonValues }]; }, { controlName: [{
            type: Input
        }], idx: [{
            type: Input
        }], group: [{
            type: Input
        }], hint: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], selectObjects: [{
            type: Input
        }], loading: [{
            type: Input
        }], required: [{
            type: Input
        }] }); })();

class FormFieldSelectModule {
}
FormFieldSelectModule.ɵfac = function FormFieldSelectModule_Factory(t) { return new (t || FormFieldSelectModule)(); };
FormFieldSelectModule.ɵmod = ɵɵdefineNgModule({ type: FormFieldSelectModule });
FormFieldSelectModule.ɵinj = ɵɵdefineInjector({ imports: [[
            CommonModule,
            MaterialModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(FormFieldSelectModule, { declarations: [FormFieldSelectComponent], imports: [CommonModule,
        MaterialModule,
        ReactiveFormsModule], exports: [FormFieldSelectComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(FormFieldSelectModule, [{
        type: NgModule,
        args: [{
                declarations: [FormFieldSelectComponent],
                imports: [
                    CommonModule,
                    MaterialModule,
                    ReactiveFormsModule
                ],
                exports: [FormFieldSelectComponent]
            }]
    }], null, null); })();

function FormFieldSelectOptgroupComponent_mat_optgroup_4_mat_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-option", 8);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const obj2_r4 = ctx.$implicit;
    const i_r5 = ctx.index;
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵpropertyInterpolate2("id", "dropdown-", ctx_r3.controlName, "-option-", i_r5, "");
    ɵɵproperty("value", obj2_r4.value);
    ɵɵattribute("aria-selected", obj2_r4.value === ctx_r3.selectedValue.id)("aria-label", obj2_r4.name);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", obj2_r4.name, " ");
} }
function FormFieldSelectOptgroupComponent_mat_optgroup_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-optgroup", 6);
    ɵɵtemplate(1, FormFieldSelectOptgroupComponent_mat_optgroup_4_mat_option_1_Template, 2, 6, "mat-option", 7);
    ɵɵelementEnd();
} if (rf & 2) {
    const obj_r2 = ctx.$implicit;
    const ctx_r0 = ɵɵnextContext();
    ɵɵpropertyInterpolate1("id", "dropdown-", ctx_r0.controlName, "-optiongroup");
    ɵɵproperty("label", obj_r2.label);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", obj_r2.options);
} }
function FormFieldSelectOptgroupComponent_mat_error_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-error");
    ɵɵi18n(1, 9);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵattribute("aria-label", ctx_r1.content.errorMessage);
    ɵɵadvance(1);
    ɵɵi18nExp(ctx_r1.setErrorMessage(ctx_r1.group.controls[ctx_r1.controlName], ctx_r1.placeholder));
    ɵɵi18nApply(1);
} }
class FormFieldSelectOptgroupComponent {
    constructor(validationMessage) {
        this.validationMessage = validationMessage;
        this.loading = false;
        this.required = true;
        this.content = {
            hint: '',
            errorMessage: ''
        };
        this.selectedValue = {
            value: null,
            name: null,
        };
    }
    ngOnInit() { }
    changeValue(value) {
        this.selectedValue.name = value.source.selected.viewValue;
        this.selectedValue.id = value.source.selected.value;
    }
    openedChange(opened) {
        this.selectedValue.opened = opened ? true : false;
    }
    setErrorMessage(controlName, placeholder) {
        this.content.errorMessage = this.validationMessage.get(controlName, placeholder);
        return (this.content.hint + this.content.errorMessage);
    }
}
FormFieldSelectOptgroupComponent.ɵfac = function FormFieldSelectOptgroupComponent_Factory(t) { return new (t || FormFieldSelectOptgroupComponent)(ɵɵdirectiveInject(ValidationMessage)); };
FormFieldSelectOptgroupComponent.ɵcmp = ɵɵdefineComponent({ type: FormFieldSelectOptgroupComponent, selectors: [["ts-form-field-select-optgroup"]], inputs: { controlName: "controlName", idx: "idx", group: "group", hint: "hint", placeholder: "placeholder", selectObjects: "selectObjects", loading: "loading", required: "required" }, decls: 10, vars: 12, consts: function () { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc  Display any instructional txt for the field
         * @meaning Hint
         */
        const MSG_EXTERNAL_dropdown___controlName___hint$$LIB_COMPONENTS_FORM_FIELD_SELECT_OPTGROUP_FORM_FIELD_SELECT_OPTGROUP_COMPONENT_TS_1 = goog.getMsg("{$interpolation} {$startTagSpan}{$closeTagSpan}{$startTagSpan_1}{$closeTagSpan}", { "interpolation": "\uFFFD0\uFFFD", "startTagSpan": "\uFFFD#7\uFFFD", "closeTagSpan": "[\uFFFD/#7\uFFFD|\uFFFD/#8\uFFFD]", "startTagSpan_1": "\uFFFD#8\uFFFD" });
        i18n_0 = MSG_EXTERNAL_dropdown___controlName___hint$$LIB_COMPONENTS_FORM_FIELD_SELECT_OPTGROUP_FORM_FIELD_SELECT_OPTGROUP_COMPONENT_TS_1;
    }
    else {
        i18n_0 = $localize `:Hint| Display any instructional txt for the field@@dropdown-{{controlName}}-hint␟d7605ab6b5a4d8a81b3ec1d88dea8f1a86261402␟2702890326735442231:${"\uFFFD0\uFFFD"}:INTERPOLATION: ${"\uFFFD#7\uFFFD"}:START_TAG_SPAN:${"[\uFFFD/#7\uFFFD|\uFFFD/#8\uFFFD]"}:CLOSE_TAG_SPAN:${"\uFFFD#8\uFFFD"}:START_TAG_SPAN_1:${"[\uFFFD/#7\uFFFD|\uFFFD/#8\uFFFD]"}:CLOSE_TAG_SPAN:`;
    } i18n_0 = ɵɵi18nPostprocess(i18n_0); let i18n_2; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        /**
         * @desc  Display any error ocurred for the field
         * @meaning Error
         */
        const MSG_EXTERNAL_dropdown___controlName___error$$LIB_COMPONENTS_FORM_FIELD_SELECT_OPTGROUP_FORM_FIELD_SELECT_OPTGROUP_COMPONENT_TS__3 = goog.getMsg("{$interpolation}", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_2 = MSG_EXTERNAL_dropdown___controlName___error$$LIB_COMPONENTS_FORM_FIELD_SELECT_OPTGROUP_FORM_FIELD_SELECT_OPTGROUP_COMPONENT_TS__3;
    }
    else {
        i18n_2 = $localize `:Error| Display any error ocurred for the field@@dropdown-{{controlName}}-error␟6074c2c5ce7fbeecd76fa923a50efdc5d954058f␟6963966861158196265:${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
    } return [["appearance", "outline", 1, "nsc-ts-form-field", 3, "formGroup", "ngClass"], ["role", "listbox", 3, "id", "formControlName", "placeholder", "openedChange", "selectionChange"], ["role", "group", 3, "label", "id", 4, "ngFor", "ngForOf"], i18n_0, ["aria-live", "polite"], [4, "ngIf"], ["role", "group", 3, "label", "id"], ["role", "option", 3, "id", "value", 4, "ngFor", "ngForOf"], ["role", "option", 3, "id", "value"], i18n_2]; }, template: function FormFieldSelectOptgroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-form-field", 0);
        ɵɵelementStart(1, "mat-label");
        ɵɵtext(2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "mat-select", 1);
        ɵɵlistener("openedChange", function FormFieldSelectOptgroupComponent_Template_mat_select_openedChange_3_listener($event) { return ctx.openedChange($event); })("selectionChange", function FormFieldSelectOptgroupComponent_Template_mat_select_selectionChange_3_listener($event) { return ctx.changeValue($event); });
        ɵɵtemplate(4, FormFieldSelectOptgroupComponent_mat_optgroup_4_Template, 2, 3, "mat-optgroup", 2);
        ɵɵelementEnd();
        ɵɵelementStart(5, "mat-hint");
        ɵɵi18nStart(6, 3);
        ɵɵelement(7, "span", 4);
        ɵɵelement(8, "span");
        ɵɵi18nEnd();
        ɵɵelementEnd();
        ɵɵtemplate(9, FormFieldSelectOptgroupComponent_mat_error_9_Template, 2, 2, "mat-error", 5);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("formGroup", ctx.group)("ngClass", ctx.loading ? "nsc-ts-form-field-loading" : "");
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.placeholder);
        ɵɵadvance(1);
        ɵɵpropertyInterpolate1("id", "dropdown-", ctx.controlName, "");
        ɵɵpropertyInterpolate("formControlName", ctx.controlName);
        ɵɵpropertyInterpolate("placeholder", ctx.placeholder);
        ɵɵattribute("aria-expanded", ctx.selectedValue.opened);
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.selectObjects);
        ɵɵadvance(3);
        ɵɵattribute("aria-label", ctx.selectedValue.name);
        ɵɵadvance(1);
        ɵɵattribute("aria-label", ctx.required ? "required" : "");
        ɵɵi18nExp(ctx.hint);
        ɵɵi18nApply(6);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.group.controls[ctx.controlName].invalid);
    } }, directives: [MatFormField, NgControlStatusGroup, FormGroupDirective, NgClass, MatLabel, MatSelect, NgControlStatus, FormControlName, NgForOf, MatHint, NgIf, MatOptgroup, MatOption, MatError], styles: [".mat-optgroup-label[_ngcontent-%COMP%]{margin-bottom:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(FormFieldSelectOptgroupComponent, [{
        type: Component,
        args: [{
                selector: 'ts-form-field-select-optgroup',
                templateUrl: './form-field-select-optgroup.component.html',
                styleUrls: ['./form-field-select-optgroup.component.scss']
            }]
    }], function () { return [{ type: ValidationMessage }]; }, { controlName: [{
            type: Input
        }], idx: [{
            type: Input
        }], group: [{
            type: Input
        }], hint: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], selectObjects: [{
            type: Input
        }], loading: [{
            type: Input
        }], required: [{
            type: Input
        }] }); })();

class FormFieldSelectOptgroupModule {
}
FormFieldSelectOptgroupModule.ɵfac = function FormFieldSelectOptgroupModule_Factory(t) { return new (t || FormFieldSelectOptgroupModule)(); };
FormFieldSelectOptgroupModule.ɵmod = ɵɵdefineNgModule({ type: FormFieldSelectOptgroupModule });
FormFieldSelectOptgroupModule.ɵinj = ɵɵdefineInjector({ imports: [[
            CommonModule,
            MaterialModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(FormFieldSelectOptgroupModule, { declarations: [FormFieldSelectOptgroupComponent], imports: [CommonModule,
        MaterialModule,
        ReactiveFormsModule], exports: [FormFieldSelectOptgroupComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(FormFieldSelectOptgroupModule, [{
        type: NgModule,
        args: [{
                declarations: [FormFieldSelectOptgroupComponent],
                imports: [
                    CommonModule,
                    MaterialModule,
                    ReactiveFormsModule
                ],
                exports: [FormFieldSelectOptgroupComponent]
            }]
    }], null, null); })();

class ScrollToTopComponent {
    constructor() {
        this.show = {
            button: false
        };
        this.values = {
            scrollPositionTrigger: window.innerHeight / 2
        };
    }
    ngAfterViewInit() {
        // run after the view is initalized so the browser adjusts the inital scroll position;
        // if we run before, pageYOffset is 0;
        this.toggleButtonVisibility();
    }
    ngOnInit() {
        // check to see if the button should be visible;
        fromEvent(window, 'scroll')
            .pipe(debounceTime(150))
            .subscribe(() => {
            this.toggleButtonVisibility();
        });
    }
    scrollToTop() {
        window.scrollTo(0, 0);
    }
    toggleButtonVisibility() {
        this.show.button = window.pageYOffset > this.values.scrollPositionTrigger;
    }
}
ScrollToTopComponent.ɵfac = function ScrollToTopComponent_Factory(t) { return new (t || ScrollToTopComponent)(); };
ScrollToTopComponent.ɵcmp = ɵɵdefineComponent({ type: ScrollToTopComponent, selectors: [["ts-scroll-to-top"]], decls: 4, vars: 2, consts: [["role", "complementary"], ["mat-mini-fab", "", "aria-label", "Scroll to top", "color", "warn", 1, "nsc-ts-scroll-to-top", 3, "click"]], template: function ScrollToTopComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "button", 1);
        ɵɵlistener("click", function ScrollToTopComponent_Template_button_click_1_listener() { return ctx.scrollToTop(); });
        ɵɵelementStart(2, "mat-icon");
        ɵɵtext(3, "file_upload");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵclassProp("nsc-ts-scroll-to-top--visible", ctx.show.button);
    } }, directives: [MatButton, MatIcon], styles: [".education-solutions-theme[_ngcontent-%COMP%]{--brand-color-1:#437c2b;--brand-color-2:#273f21;--brand-color-3:#6db944;--brand-color-4:#599a38;--brand-color-5:#e2f1da;--brand-color-6:rgba(109,185,68,0.2);--brand-color-7:#f3f9f0;--brand-color-8:rgba(109,185,68,0.08)}.nsc-ts-scroll-to-top[_ngcontent-%COMP%]{display:block;position:fixed;bottom:10px;right:-100px;opacity:0;transition:all .5s}@media (min-width:768px){.nsc-ts-scroll-to-top[_ngcontent-%COMP%]{display:none}}.nsc-ts-scroll-to-top--visible[_ngcontent-%COMP%]{right:10px;opacity:1}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(ScrollToTopComponent, [{
        type: Component,
        args: [{
                selector: 'ts-scroll-to-top',
                templateUrl: './scroll-to-top.component.html',
                styleUrls: ['./scroll-to-top.component.scss']
            }]
    }], function () { return []; }, null); })();

class ScrollToTopModule {
}
ScrollToTopModule.ɵfac = function ScrollToTopModule_Factory(t) { return new (t || ScrollToTopModule)(); };
ScrollToTopModule.ɵmod = ɵɵdefineNgModule({ type: ScrollToTopModule });
ScrollToTopModule.ɵinj = ɵɵdefineInjector({ imports: [[
            CommonModule,
            MaterialModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ScrollToTopModule, { declarations: [ScrollToTopComponent], imports: [CommonModule,
        MaterialModule], exports: [ScrollToTopComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(ScrollToTopModule, [{
        type: NgModule,
        args: [{
                declarations: [ScrollToTopComponent],
                imports: [
                    CommonModule,
                    MaterialModule
                ],
                exports: [ScrollToTopComponent]
            }]
    }], null, null); })();

function DeliveryFeeSummaryComponent_div_6_div_1_a_8_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", 16);
    ɵɵlistener("click", function DeliveryFeeSummaryComponent_div_6_div_1_a_8_Template_a_click_0_listener() { ɵɵrestoreView(_r8); const ctx_r7 = ɵɵnextContext(3); return ctx_r7.viewTotalFeeTNDetails(); });
    ɵɵi18nStart(1, 17);
    ɵɵelement(2, "mat-icon", 18);
    ɵɵi18nEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const fee_r2 = ɵɵnextContext(2).$implicit;
    ɵɵpropertyInterpolate1("id", "fee-", fee_r2.name, "-help-btn");
} }
function DeliveryFeeSummaryComponent_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 10);
    ɵɵelementStart(1, "div", 11);
    ɵɵelementStart(2, "span");
    ɵɵi18n(3, 12);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 13);
    ɵɵelementStart(5, "span");
    ɵɵi18n(6, 14);
    ɵɵpipe(7, "currency");
    ɵɵelementEnd();
    ɵɵtemplate(8, DeliveryFeeSummaryComponent_div_6_div_1_a_8_Template, 3, 1, "a", 15);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵɵnextContext();
    const $last_r4 = ctx_r10.last;
    const fee_r2 = ctx_r10.$implicit;
    const ctx_r5 = ɵɵnextContext();
    ɵɵproperty("ngClass", $last_r4 ? "align-right" : "");
    ɵɵadvance(3);
    ɵɵi18nExp(fee_r2.description);
    ɵɵi18nApply(3);
    ɵɵadvance(1);
    ɵɵproperty("ngClass", $last_r4 ? "nsc-ts-fee-table__col--total" : "");
    ɵɵadvance(3);
    ɵɵi18nExp(ɵɵpipeBind1(7, 5, fee_r2.value));
    ɵɵi18nApply(6);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r5.isTNSchool && fee_r2.name === "totalFee" && fee_r2.value === 0);
} }
function DeliveryFeeSummaryComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 8);
    ɵɵtemplate(1, DeliveryFeeSummaryComponent_div_6_div_1_Template, 9, 7, "div", 9);
    ɵɵelementEnd();
} if (rf & 2) {
    const fee_r2 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", fee_r2.showItem || fee_r2.value && fee_r2.value !== 0);
} }
function DeliveryFeeSummaryComponent_p_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p", 19);
    ɵɵelementStart(1, "b");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate(ctx_r1.note);
} }
class DeliveryFeeSummaryComponent {
    constructor() {
        this.showTNFeeDetails = new EventEmitter();
    }
    ngOnInit() { }
    // trigget pop up parent event in order to see TNFee details message
    viewTotalFeeTNDetails() {
        this.showTNFeeDetails.emit();
    }
}
DeliveryFeeSummaryComponent.ɵfac = function DeliveryFeeSummaryComponent_Factory(t) { return new (t || DeliveryFeeSummaryComponent)(); };
DeliveryFeeSummaryComponent.ɵcmp = ɵɵdefineComponent({ type: DeliveryFeeSummaryComponent, selectors: [["ts-delivery-fee-summary"]], inputs: { title: "title", fees: "fees", showZeroFee: "showZeroFee", isTNSchool: "isTNSchool", note: "note", showNote: "showNote" }, outputs: { showTNFeeDetails: "showTNFeeDetails" }, decls: 10, vars: 3, consts: function () { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_fee_description____index__$$LIB_COMPONENTS_DELIVERY_FEE_SUMMARY_DELIVERY_FEE_SUMMARY_COMPONENT_TS___1 = goog.getMsg("{$interpolation}", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_0 = MSG_EXTERNAL_fee_description____index__$$LIB_COMPONENTS_DELIVERY_FEE_SUMMARY_DELIVERY_FEE_SUMMARY_COMPONENT_TS___1;
    }
    else {
        i18n_0 = $localize `:@@fee-description-{{$index}}␟364a5f8023a95c0036abfcda8b5a4a010bcb8e80␟4563967383856681910:${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
    } let i18n_2; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_fee_value____index__$$LIB_COMPONENTS_DELIVERY_FEE_SUMMARY_DELIVERY_FEE_SUMMARY_COMPONENT_TS___3 = goog.getMsg("{$interpolation}", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_2 = MSG_EXTERNAL_fee_value____index__$$LIB_COMPONENTS_DELIVERY_FEE_SUMMARY_DELIVERY_FEE_SUMMARY_COMPONENT_TS___3;
    }
    else {
        i18n_2 = $localize `:@@fee-value-{{$index}}␟a780d11d92bbb9620b45f57ef44e3c028baed8b7␟3688199737678551422:${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
    } let i18n_4; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_fee____index__$$LIB_COMPONENTS_DELIVERY_FEE_SUMMARY_DELIVERY_FEE_SUMMARY_COMPONENT_TS____5 = goog.getMsg("{$startTagMatIcon}{$closeTagMatIcon}", { "startTagMatIcon": "\uFFFD#2\uFFFD", "closeTagMatIcon": "\uFFFD/#2\uFFFD" });
        i18n_4 = MSG_EXTERNAL_fee____index__$$LIB_COMPONENTS_DELIVERY_FEE_SUMMARY_DELIVERY_FEE_SUMMARY_COMPONENT_TS____5;
    }
    else {
        i18n_4 = $localize `:@@fee-{{$index}}␟25d7a350b9b5ec44e0032806ded52c633437f692␟8994677646290238209:${"\uFFFD#2\uFFFD"}:START_TAG_MAT_ICON:${"\uFFFD/#2\uFFFD"}:CLOSE_TAG_MAT_ICON:`;
    } return [[3, "title"], [1, "row"], [1, "col-12", "col-lg-6"], [1, "nsc-ts-fee-table", "nsc-ts-fee-table--no-title"], ["tabindex", "0", 4, "ngFor", "ngForOf"], [1, "col-12"], ["size", "xs"], ["class", "", "i18", "@@fee-summary-note", "tabIndex", "0", 4, "ngIf"], ["tabindex", "0"], ["class", "nsc-ts-fee-table__row nsc-ts-fee-table__row--wrapper", 3, "ngClass", 4, "ngIf"], [1, "nsc-ts-fee-table__row", "nsc-ts-fee-table__row--wrapper", 3, "ngClass"], [1, "nsc-ts-fee-table__col", "nsc-ts-fee-table__col--label"], i18n_0, [1, "nsc-ts-fee-table__col", "nsc-ts-fee-table__col--value", 3, "ngClass"], i18n_2, ["role", "button", "tabindex", "0", "aria-label", "info", "class", "info-icon", 3, "id", "click", 4, "ngIf"], ["role", "button", "tabindex", "0", "aria-label", "info", 1, "info-icon", 3, "id", "click"], i18n_4, ["svgIcon", "assets:ts-info", 1, "nsc-ts-svgIcon__info"], ["i18", "@@fee-summary-note", "tabIndex", "0", 1, ""]]; }, template: function DeliveryFeeSummaryComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "ts-card");
        ɵɵelement(1, "ts-card-title", 0);
        ɵɵelementStart(2, "ts-card-content");
        ɵɵelementStart(3, "div", 1);
        ɵɵelementStart(4, "div", 2);
        ɵɵelementStart(5, "div", 3);
        ɵɵtemplate(6, DeliveryFeeSummaryComponent_div_6_Template, 2, 1, "div", 4);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(7, "div", 5);
        ɵɵelement(8, "ts-spacer", 6);
        ɵɵtemplate(9, DeliveryFeeSummaryComponent_p_9_Template, 3, 1, "p", 7);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("title", ctx.title);
        ɵɵadvance(5);
        ɵɵproperty("ngForOf", ctx.fees);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.showNote);
    } }, directives: [CardComponent, CardTitleComponent, CardContentComponent, NgForOf, SpacerComponent, NgIf, NgClass, MatIcon], pipes: [CurrencyPipe], styles: [".align-right[_ngcontent-%COMP%]{text-align:right}.note[_ngcontent-%COMP%]:focus, .note[_ngcontent-%COMP%]:focus-within{outline:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(DeliveryFeeSummaryComponent, [{
        type: Component,
        args: [{
                selector: 'ts-delivery-fee-summary',
                templateUrl: './delivery-fee-summary.component.html',
                styleUrls: ['./delivery-fee-summary.component.scss']
            }]
    }], function () { return []; }, { title: [{
            type: Input
        }], fees: [{
            type: Input
        }], showZeroFee: [{
            type: Input
        }], isTNSchool: [{
            type: Input
        }], showTNFeeDetails: [{
            type: Output
        }], note: [{
            type: Input
        }], showNote: [{
            type: Input
        }] }); })();

class DeliveryFeeSummaryModule {
}
DeliveryFeeSummaryModule.ɵfac = function DeliveryFeeSummaryModule_Factory(t) { return new (t || DeliveryFeeSummaryModule)(); };
DeliveryFeeSummaryModule.ɵmod = ɵɵdefineNgModule({ type: DeliveryFeeSummaryModule });
DeliveryFeeSummaryModule.ɵinj = ɵɵdefineInjector({ imports: [[
            CommonModule,
            CardsModule,
            MaterialModule,
            SpacerModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(DeliveryFeeSummaryModule, { declarations: [DeliveryFeeSummaryComponent], imports: [CommonModule,
        CardsModule,
        MaterialModule,
        SpacerModule], exports: [DeliveryFeeSummaryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(DeliveryFeeSummaryModule, [{
        type: NgModule,
        args: [{
                declarations: [DeliveryFeeSummaryComponent],
                imports: [
                    CommonModule,
                    CardsModule,
                    MaterialModule,
                    SpacerModule
                ],
                exports: [DeliveryFeeSummaryComponent]
            }]
    }], null, null); })();

function ManageUploadFilesComponent_div_10_th_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "th", 24);
    ɵɵi18nStart(1, 25);
    ɵɵelement(2, "div", 26);
    ɵɵi18nEnd();
    ɵɵelementEnd();
} }
function ManageUploadFilesComponent_div_10_td_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "td", 27);
    ɵɵi18n(1, 28);
    ɵɵelementEnd();
} if (rf & 2) {
    const uploadedFile_r13 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵi18nExp(uploadedFile_r13.originalFileItem.file.name);
    ɵɵi18nApply(1);
} }
function ManageUploadFilesComponent_div_10_th_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "th", 24);
    ɵɵi18nStart(1, 29);
    ɵɵelement(2, "div", 26);
    ɵɵi18nEnd();
    ɵɵelementEnd();
} }
function ManageUploadFilesComponent_div_10_td_8_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵi18n(1, 32);
    ɵɵelementEnd();
} if (rf & 2) {
    const uploadedFile_r15 = ɵɵnextContext().$implicit;
    ɵɵattribute("aria-label", uploadedFile_r15.originalFileItem.file.name);
} }
function ManageUploadFilesComponent_div_10_td_8_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵi18n(1, 33);
    ɵɵelementEnd();
} if (rf & 2) {
    const uploadedFile_r15 = ɵɵnextContext().$implicit;
    ɵɵattribute("aria-label", uploadedFile_r15.originalFileItem.file.name);
} }
function ManageUploadFilesComponent_div_10_td_8_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 34);
    ɵɵi18n(1, 35);
    ɵɵelementEnd();
} if (rf & 2) {
    const uploadedFile_r15 = ɵɵnextContext().$implicit;
    ɵɵattribute("aria-label", uploadedFile_r15.originalFileItem.file.name);
} }
function ManageUploadFilesComponent_div_10_td_8_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵi18n(1, 36);
    ɵɵelementEnd();
} if (rf & 2) {
    const uploadedFile_r15 = ɵɵnextContext().$implicit;
    ɵɵattribute("aria-label", uploadedFile_r15.originalFileItem.file.name);
} }
function ManageUploadFilesComponent_div_10_td_8_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵi18n(1, 37);
    ɵɵelementEnd();
} if (rf & 2) {
    const uploadedFile_r15 = ɵɵnextContext().$implicit;
    ɵɵattribute("aria-label", uploadedFile_r15.originalFileItem.file.name);
} }
function ManageUploadFilesComponent_div_10_td_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "td", 30);
    ɵɵelement(1, "div");
    ɵɵtemplate(2, ManageUploadFilesComponent_div_10_td_8_span_2_Template, 2, 1, "span", 10);
    ɵɵtemplate(3, ManageUploadFilesComponent_div_10_td_8_span_3_Template, 2, 1, "span", 10);
    ɵɵtemplate(4, ManageUploadFilesComponent_div_10_td_8_span_4_Template, 2, 1, "span", 31);
    ɵɵtemplate(5, ManageUploadFilesComponent_div_10_td_8_span_5_Template, 2, 1, "span", 10);
    ɵɵtemplate(6, ManageUploadFilesComponent_div_10_td_8_span_6_Template, 2, 1, "span", 10);
    ɵɵelementEnd();
} if (rf & 2) {
    const uploadedFile_r15 = ctx.$implicit;
    ɵɵadvance(2);
    ɵɵproperty("ngIf", !uploadedFile_r15.originalFileItem.isSuccess && !uploadedFile_r15.originalFileItem.isError && !uploadedFile_r15.originalFileItem.isCancel && !uploadedFile_r15.originalFileItem.isUploading);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", uploadedFile_r15.originalFileItem.isSuccess && (uploadedFile_r15.attachmentResponse && uploadedFile_r15.attachmentResponse.status !== "fail"));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (uploadedFile_r15.originalFileItem.isError || uploadedFile_r15.attachmentResponse && uploadedFile_r15.attachmentResponse.status === "fail") && !uploadedFile_r15.originalFileItem.isUploading);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", uploadedFile_r15.originalFileItem.isCancel);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", uploadedFile_r15.originalFileItem.isUploading);
} }
function ManageUploadFilesComponent_div_10_th_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "th", 24);
    ɵɵi18nStart(1, 38);
    ɵɵelement(2, "div", 26);
    ɵɵi18nEnd();
    ɵɵelementEnd();
} }
function ManageUploadFilesComponent_div_10_td_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "td", 39);
    ɵɵi18n(1, 40);
    ɵɵelementEnd();
} if (rf & 2) {
    const uploadedFile_r27 = ctx.$implicit;
    const ctx_r7 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵi18nExp(ctx_r7.roundFileSizeValue(uploadedFile_r27.originalFileItem.file.size));
    ɵɵi18nApply(1);
} }
function ManageUploadFilesComponent_div_10_th_13_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "th", 24);
    ɵɵi18nStart(1, 41);
    ɵɵelement(2, "div", 26);
    ɵɵi18nEnd();
    ɵɵelementEnd();
} }
function ManageUploadFilesComponent_div_10_td_14_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 46);
    ɵɵlistener("click", function ManageUploadFilesComponent_div_10_td_14_button_1_Template_button_click_0_listener() { ɵɵrestoreView(_r34); const uploadedFile_r29 = ɵɵnextContext().$implicit; const ctx_r32 = ɵɵnextContext(2); return ctx_r32.retryFileClick(uploadedFile_r29); });
    ɵɵi18nStart(1, 47);
    ɵɵelement(2, "mat-icon");
    ɵɵi18nEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const $index_r30 = ɵɵnextContext().index;
    ɵɵpropertyInterpolate1("id", "@@file-", $index_r30, "-retry-btn");
} }
function ManageUploadFilesComponent_div_10_td_14_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "td", 30);
    ɵɵtemplate(1, ManageUploadFilesComponent_div_10_td_14_button_1_Template, 3, 1, "button", 42);
    ɵɵelementStart(2, "button", 43);
    ɵɵlistener("click", function ManageUploadFilesComponent_div_10_td_14_Template_button_click_2_listener() { ɵɵrestoreView(_r37); const uploadedFile_r29 = ctx.$implicit; const ctx_r36 = ɵɵnextContext(2); return ctx_r36.removeFileClick(uploadedFile_r29); });
    ɵɵi18nStart(3, 44);
    ɵɵelement(4, "mat-icon", 45);
    ɵɵi18nEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const uploadedFile_r29 = ctx.$implicit;
    const $index_r30 = ctx.index;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (uploadedFile_r29.originalFileItem.isError || uploadedFile_r29.originalFileItem.isCancel || uploadedFile_r29.attachmentResponse && uploadedFile_r29.attachmentResponse.status === "fail") && !uploadedFile_r29.originalFileItem.isUploading);
    ɵɵadvance(1);
    ɵɵpropertyInterpolate1("id", "@@file-", $index_r30, "-remove-btn");
} }
function ManageUploadFilesComponent_div_10_tr_15_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "tr", 48);
} }
function ManageUploadFilesComponent_div_10_tr_16_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "tr", 49);
} }
const _c28 = function (a0) { return { "width": a0 }; };
function ManageUploadFilesComponent_div_10_div_17_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "ts-spacer", 23);
    ɵɵelementStart(2, "div", 50);
    ɵɵtext(3, "Upload progress:");
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 51);
    ɵɵelement(5, "div", 52);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵɵnextContext(2);
    ɵɵadvance(5);
    ɵɵproperty("ngStyle", ɵɵpureFunction1(1, _c28, ctx_r12.uploader.progress + "%"));
} }
function ManageUploadFilesComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "table", 11, 12);
    ɵɵelementContainerStart(3, 13);
    ɵɵtemplate(4, ManageUploadFilesComponent_div_10_th_4_Template, 3, 0, "th", 14);
    ɵɵtemplate(5, ManageUploadFilesComponent_div_10_td_5_Template, 2, 1, "td", 15);
    ɵɵelementContainerEnd();
    ɵɵelementContainerStart(6, 16);
    ɵɵtemplate(7, ManageUploadFilesComponent_div_10_th_7_Template, 3, 0, "th", 14);
    ɵɵtemplate(8, ManageUploadFilesComponent_div_10_td_8_Template, 7, 5, "td", 17);
    ɵɵelementContainerEnd();
    ɵɵelementContainerStart(9, 18);
    ɵɵtemplate(10, ManageUploadFilesComponent_div_10_th_10_Template, 3, 0, "th", 14);
    ɵɵtemplate(11, ManageUploadFilesComponent_div_10_td_11_Template, 2, 1, "td", 19);
    ɵɵelementContainerEnd();
    ɵɵelementContainerStart(12, 20);
    ɵɵtemplate(13, ManageUploadFilesComponent_div_10_th_13_Template, 3, 0, "th", 14);
    ɵɵtemplate(14, ManageUploadFilesComponent_div_10_td_14_Template, 5, 2, "td", 17);
    ɵɵelementContainerEnd();
    ɵɵtemplate(15, ManageUploadFilesComponent_div_10_tr_15_Template, 1, 0, "tr", 21);
    ɵɵtemplate(16, ManageUploadFilesComponent_div_10_tr_16_Template, 1, 0, "tr", 22);
    ɵɵelementEnd();
    ɵɵtemplate(17, ManageUploadFilesComponent_div_10_div_17_Template, 6, 3, "div", 10);
    ɵɵelement(18, "ts-spacer", 23);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("dataSource", ctx_r0.dataSource);
    ɵɵadvance(14);
    ɵɵproperty("matHeaderRowDef", ctx_r0.columnsToDisplay);
    ɵɵadvance(1);
    ɵɵproperty("matRowDefColumns", ctx_r0.columnsToDisplay);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.uploader.isUploading);
} }
class ManageUploadFilesComponent {
    constructor(dialog, dataService) {
        this.dialog = dialog;
        this.dataService = dataService;
        this.columnsToDisplay = ['itemName', 'itemStatus', 'itemSize', 'itemButtons'];
        this.uploadedFiles = [];
        this.reg = /^((?![.]{2})[a-zA-Z0-9 _.-]){1,}$/;
    }
    ngOnInit() {
        const uploadParameters = {
            url: this.url,
        };
        if (this.authToken) {
            uploadParameters.authToken = this.authToken;
        }
        if (this.headers) {
            uploadParameters.headers = this.headers;
        }
        this.uploader = new FileUploader(uploadParameters);
        this.uploader.onAfterAddingFile = (fileItem) => {
            const uploadedFile = {
                originalFileItem: fileItem
            };
            // push fileItem to array.
            this.uploadedFiles.push(uploadedFile);
            // update datasource
            this.updateDataSource();
            // upload File
            this.uploadFile(fileItem);
        };
        this.uploader.onErrorItem = (item, response, status, headers) => {
            Array.from(this.uploadedFiles).forEach((uploadedFile, index) => {
                if (uploadedFile.originalFileItem === item) {
                    this.uploader.removeFromQueue(item);
                    this.uploadedFiles.splice(index, 1);
                }
            });
            window.alert('We are unable to accept any file uploads at this time due to a technical difficulty.');
        };
        // only using onSuccessItem, because API will always return a 200 status. It may fail in the API layer, but it will still come here.
        this.uploader.onSuccessItem = (item, response, status, headers) => {
            try {
                response = JSON.parse(response);
                this.uploadStatus = response.originalFileName;
                if (response.level === 'ERROR') {
                    window.alert(response.message);
                    response = { status: 'fail' };
                    Array.from(this.uploadedFiles).forEach((uploadedFile, index) => {
                        if (uploadedFile.originalFileItem === item) {
                            this.uploader.removeFromQueue(item);
                            this.uploadedFiles.splice(index, 1);
                        }
                    });
                }
            }
            catch (e) {
                // 'fail' status will be set by API in case of Vvirus detected' or 'System is out of service'.
                // here, we protect the UI from any other possible problem, such as error parsing. If API returns 'Internal Server Error', we fake a response with 'fail' status.
                response = { status: 'fail' };
            }
            Array.from(this.uploadedFiles).forEach((uploadedFile, index) => {
                if (uploadedFile.originalFileItem === item) {
                    uploadedFile.attachmentResponse = response;
                }
            });
        };
        this.dataSource = new MatTableDataSource();
        this.infoText = '<div><span class="mat-title" autofocus tabindex="0" >File Requirements</span><ul tabindex="0">' +
            '<li class=\"mat-caption\">File name(s): Supports alpha numeric characters, non-consecutive periods, dashes, underscores and spaces</li>' +
            '<li class=\"mat-caption\">Maximum file name size: 64 characters</li>' +
            '<li class=\"mat-caption\">Number of documents allowed: ' + this.maxFileCount + '</li>' +
            '<li class=\"mat-caption\">Supported formats: .' + this.allowedFileTypes.join(', .') + '</li>' +
            '<li class=\"mat-caption\">Do not upload secured or password protected documents.</li>' +
            '</ul></div>';
    }
    onChange(event) {
        event.srcElement.value = '';
        if (!this.uploader.isUploading) {
            this.uploader.isUploading = false;
        }
    }
    updateDataSource() {
        // we update dataSource for the file table.
        this.dataSource.data = this.uploadedFiles;
    }
    // Pass the 'select files' button click to the file input element
    fileInputClick() {
        const fileInput = document.getElementById('input-files');
        fileInput.click();
    }
    uploadFile(fileItem) {
        const validFile = this.validateUploadedFile(fileItem);
        if (validFile) {
            this.uploader.uploadItem(fileItem);
        }
        else {
            this.removeInvalidFile(fileItem);
        }
    }
    validateUploadedFile(fileItem) {
        // Double-check that all file parameters are valid
        let validUpload = true;
        const item = fileItem;
        const filenameArr = item.file.name.split('.'); // split filename into array
        const ext = filenameArr.pop(); // keep last element as the file extension
        // Check filename against regex
        if (!this.reg.test(item.file.name)) {
            validUpload = false;
            window.alert('The document does not meet the file naming conventions. File names may only contain alpha numeric characters, periods, dashes, underscore and spaces. Please ensure your document meets this requirement and try again.');
        }
        // Check filename length
        if (item.file.name.length > 64) {
            validUpload = false;
            window.alert('The file name cannot exceed 64 characters. Please rename the file and try again.');
        }
        // Check the extension
        if (filenameArr.length > 0 && this.allowedFileTypes.indexOf(ext.toLowerCase()) < 0) {
            validUpload = false;
            window.alert('The document you are trying to upload does not meet the requirements, it is the wrong file type. Please ensure your document meets this requirement and try again.');
        }
        // Check the file size
        if (item.file.size > 5000000) {
            validUpload = false;
            window.alert('The document you are trying to upload does not meet the requirements, it is larger than 5 MB. Please ensure your document meets this requirement and try again.');
        }
        return validUpload;
    }
    removeInvalidFile(uploadedFile) {
        const self = this;
        Array.from(this.uploadedFiles).forEach((tempFile, index) => {
            if (tempFile.originalFileItem.file.name === uploadedFile.file.name) {
                self.uploader.removeFromQueue(tempFile.originalFileItem);
                self.uploadedFiles.splice(index, 1);
            }
        });
        this.updateDataSource();
    }
    removeFileClick(uploadedFile) {
        const remove = window.confirm('Are you sure you want to remove the ' + uploadedFile.originalFileItem.file.name + ' file?');
        const rmStatus = uploadedFile.originalFileItem.file.name + ' has been removed.';
        const self = this;
        const alreadyUploadedFiles = this.uploadedFiles;
        if (remove) {
            Array.from(alreadyUploadedFiles).forEach((tempFile, index) => {
                if (tempFile.attachmentResponse.fileIdentifier === uploadedFile.attachmentResponse.fileIdentifier) {
                    if (self.uploader.queue.length > 0) {
                        self.uploader.removeFromQueue(tempFile.originalFileItem);
                    }
                    else {
                        this.dataService.deleteAttachmentWithFileId(uploadedFile.attachmentResponse.fileIdentifier);
                    }
                    this.removeStatus = rmStatus;
                    self.uploadedFiles.splice(index, 1);
                }
            });
            this.updateDataSource();
        }
    }
    retryFileClick(uploadedFile) {
        const self = this;
        Array.from(this.uploadedFiles).forEach((tempFile, index) => {
            if (tempFile.originalFileItem.file.name === uploadedFile.originalFileItem.file.name) {
                self.uploadedFiles.splice(index, 1);
            }
        });
        this.uploader.addToQueue(uploadedFile.originalFileItem._file);
        this.uploader.uploadItem(this.uploader.queue[0]);
    }
    // Simple utility methods to format the file byte size
    roundFileSizeValue(val) {
        let size = val;
        let suffix = ' bytes';
        // This could be something more elegant, but I don't
        // need to account for anything bigger than megabytes
        if (size > 1000) {
            size = this.byteRounding(size);
            suffix = ' kB';
        }
        if (size > 1000) {
            size = this.byteRounding(size);
            suffix = ' MB';
        }
        return size + suffix;
    }
    byteRounding(val) {
        return Math.round((val / 1000.0) * 10) / 10;
    }
    openDialog() {
        const dialogRef = this.dialog.open(DialogBoxComponent, {
            width: this.infoText.length > 300 ? '480px' : '310px',
            data: {
                body: this.infoText
            }
        });
    }
}
ManageUploadFilesComponent.ɵfac = function ManageUploadFilesComponent_Factory(t) { return new (t || ManageUploadFilesComponent)(ɵɵdirectiveInject(MatDialog), ɵɵdirectiveInject(DataService)); };
ManageUploadFilesComponent.ɵcmp = ɵɵdefineComponent({ type: ManageUploadFilesComponent, selectors: [["ts-manage-upload-files"]], inputs: { url: "url", allowedFileTypes: "allowedFileTypes", maxFileCount: "maxFileCount", authToken: "authToken", headers: "headers" }, decls: 11, vars: 6, consts: function () { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_add_file_btn$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS_1 = goog.getMsg("{$startTagDiv}{$startTagMatIcon}{$closeTagMatIcon}{$closeTagDiv} Add File ", { "startTagDiv": "\uFFFD#3\uFFFD", "startTagMatIcon": "\uFFFD#4\uFFFD", "closeTagMatIcon": "\uFFFD/#4\uFFFD", "closeTagDiv": "\uFFFD/#3\uFFFD" });
        i18n_0 = MSG_EXTERNAL_add_file_btn$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS_1;
    }
    else {
        i18n_0 = $localize `:@@add-file-btn␟9b3d84b8be3ae87404d0930c23648397a89cf382␟8876932865722139771:${"\uFFFD#3\uFFFD"}:START_TAG_DIV:${"\uFFFD#4\uFFFD"}:START_TAG_MAT_ICON:${"\uFFFD/#4\uFFFD"}:CLOSE_TAG_MAT_ICON:${"\uFFFD/#3\uFFFD"}:CLOSE_TAG_DIV: Add File `;
    } let i18n_2; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_file_title$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS___3 = goog.getMsg("{$startTagDiv}File{$closeTagDiv}", { "startTagDiv": "\uFFFD#2\uFFFD", "closeTagDiv": "\uFFFD/#2\uFFFD" });
        i18n_2 = MSG_EXTERNAL_file_title$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS___3;
    }
    else {
        i18n_2 = $localize `:@@file-title␟0239341975bb2cde9b211803e50f0fea30b5d34b␟8816741763204854374:${"\uFFFD#2\uFFFD"}:START_TAG_DIV:File${"\uFFFD/#2\uFFFD"}:CLOSE_TAG_DIV:`;
    } let i18n_4; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_file_name____index__$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS___5 = goog.getMsg(" {$interpolation}", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_4 = MSG_EXTERNAL_file_name____index__$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS___5;
    }
    else {
        i18n_4 = $localize `:@@file-name-{{$index}}␟9e45773131926ee3214f1f8b9a44a103109b91ed␟933413510729677065: ${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
    } let i18n_6; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_file_status_title$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS___7 = goog.getMsg("{$startTagDiv}Status{$closeTagDiv}", { "startTagDiv": "\uFFFD#2\uFFFD", "closeTagDiv": "\uFFFD/#2\uFFFD" });
        i18n_6 = MSG_EXTERNAL_file_status_title$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS___7;
    }
    else {
        i18n_6 = $localize `:@@file-status-title␟bc6e5b79a8705e967af35c108cae2cc87672af40␟3640866294626204254:${"\uFFFD#2\uFFFD"}:START_TAG_DIV:Status${"\uFFFD/#2\uFFFD"}:CLOSE_TAG_DIV:`;
    } let i18n_8; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_file____index___status_pending$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS____9 = goog.getMsg("Pending ");
        i18n_8 = MSG_EXTERNAL_file____index___status_pending$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS____9;
    }
    else {
        i18n_8 = $localize `:@@file-{{$index}}-status-pending␟47e7037744d8b57da0156592612ec1df3b3fb8d5␟4513427451565488736:Pending `;
    } let i18n_10; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_file____index___status_uploaded$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS____11 = goog.getMsg("Uploaded ");
        i18n_10 = MSG_EXTERNAL_file____index___status_uploaded$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS____11;
    }
    else {
        i18n_10 = $localize `:@@file-{{$index}}-status-uploaded␟221659bd4229d0170a3f8970797c62f2f372a1f3␟3296471249837970748:Uploaded `;
    } let i18n_12; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_file____index___status_error$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS____13 = goog.getMsg("Error ");
        i18n_12 = MSG_EXTERNAL_file____index___status_error$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS____13;
    }
    else {
        i18n_12 = $localize `:@@file-{{$index}}-status-error␟96aa2a5723007756e6cdfe85cc4a78d5d61fc40c␟4526667546376867879:Error `;
    } let i18n_14; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_file____index___status_cancelled$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS____15 = goog.getMsg("Cancelled ");
        i18n_14 = MSG_EXTERNAL_file____index___status_cancelled$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS____15;
    }
    else {
        i18n_14 = $localize `:@@file-{{$index}}-status-cancelled␟93330e93e10a39c4240e9692291c130e6e260b44␟8234218318901950291:Cancelled `;
    } let i18n_16; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_file____index___status_uploading___$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS____17 = goog.getMsg("Uploading... ");
        i18n_16 = MSG_EXTERNAL_file____index___status_uploading___$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS____17;
    }
    else {
        i18n_16 = $localize `:@@file-{{$index}}-status-uploading...␟00b91b5dea02fe3a286583f8e393749bf41c9601␟2864184404249425714:Uploading... `;
    } let i18n_18; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_file_size_title$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS___19 = goog.getMsg("{$startTagDiv}Size{$closeTagDiv}", { "startTagDiv": "\uFFFD#2\uFFFD", "closeTagDiv": "\uFFFD/#2\uFFFD" });
        i18n_18 = MSG_EXTERNAL_file_size_title$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS___19;
    }
    else {
        i18n_18 = $localize `:@@file-size-title␟61d47ad9ac90e69d42799e5ca3dfd78842c21102␟5649715377672251833:${"\uFFFD#2\uFFFD"}:START_TAG_DIV:Size${"\uFFFD/#2\uFFFD"}:CLOSE_TAG_DIV:`;
    } let i18n_20; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_file____index___size$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS___21 = goog.getMsg(" {$interpolation} ", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_20 = MSG_EXTERNAL_file____index___size$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS___21;
    }
    else {
        i18n_20 = $localize `:@@file-{{$index}}-size␟0d5e884a96f10d2bd6189d39402f04d1cac986a0␟5923026037243241630: ${"\uFFFD0\uFFFD"}:INTERPOLATION: `;
    } let i18n_22; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_file_remove_title$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS___23 = goog.getMsg("{$startTagDiv}Remove{$closeTagDiv}", { "startTagDiv": "\uFFFD#2\uFFFD", "closeTagDiv": "\uFFFD/#2\uFFFD" });
        i18n_22 = MSG_EXTERNAL_file_remove_title$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS___23;
    }
    else {
        i18n_22 = $localize `:@@file-remove-title␟d746e4ff73138dbb0f6e8edf1b6d58d441a4c1c0␟1787443118470546167:${"\uFFFD#2\uFFFD"}:START_TAG_DIV:Remove${"\uFFFD/#2\uFFFD"}:CLOSE_TAG_DIV:`;
    } let i18n_24; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_file____index___remove_btn$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS___25 = goog.getMsg("{$startTagMatIcon}{$closeTagMatIcon}", { "startTagMatIcon": "\uFFFD#4\uFFFD", "closeTagMatIcon": "\uFFFD/#4\uFFFD" });
        i18n_24 = MSG_EXTERNAL_file____index___remove_btn$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS___25;
    }
    else {
        i18n_24 = $localize `:@@file-{{$index}}-remove-btn␟33d02196c04945dbf99f94dca84702a0a1dd7f23␟1438497999291276546:${"\uFFFD#4\uFFFD"}:START_TAG_MAT_ICON:${"\uFFFD/#4\uFFFD"}:CLOSE_TAG_MAT_ICON:`;
    } let i18n_26; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_file____index___retry_btn$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS____27 = goog.getMsg("{$startTagMatIcon}replay{$closeTagMatIcon}", { "startTagMatIcon": "\uFFFD#2\uFFFD", "closeTagMatIcon": "\uFFFD/#2\uFFFD" });
        i18n_26 = MSG_EXTERNAL_file____index___retry_btn$$LIB_COMPONENTS_MANAGE_UPLOAD_FILES_MANAGE_UPLOAD_FILES_COMPONENT_TS____27;
    }
    else {
        i18n_26 = $localize `:@@file-{{$index}}-retry-btn␟c8d870f0ee4a3a2bd2e43511ef65812e1f554571␟8800153074971236371:${"\uFFFD#2\uFFFD"}:START_TAG_MAT_ICON:replay${"\uFFFD/#2\uFFFD"}:CLOSE_TAG_MAT_ICON:`;
    } return [[1, "nsc-ts-form-add-file"], ["mat-raised-button", "", "id", "add-file-btn", "for", "input-files", "type", "button", "color", "primary", 1, "nsc-ts-form-actions__button", "button-big", 3, "disabled", "click"], i18n_0, [1, "nsc-ts-left__icon"], ["svgIcon", "assets:ts-add", 1, "nsc-ts-svgIcon", "nsc-ts-svgIcon__add"], ["ng2FileSelect", "", "id", "input-files", "type", "file", 3, "disabled", "accept", "uploader", "change"], ["size", "sm"], ["matSuffix", "", "tabindex", "0", 1, "nsc-ts-form-field-toggle__help", 3, "click", "keyup.enter", "keyup.space"], ["svgIcon", "assets:ts-info", 1, "nsc-ts-svgIcon__info"], ["role", "alert", "aria-live", "assertive"], [4, "ngIf"], ["mat-table", "", 1, "mat-table", 3, "dataSource"], ["table", ""], ["matColumnDef", "itemName"], ["mat-header-cell", "", 4, "matHeaderCellDef"], ["mat-cell", "", "aria-label", "file", 4, "matCellDef"], ["matColumnDef", "itemStatus"], ["mat-cell", "", "role", "alert", "aria-live", "assertive", 4, "matCellDef"], ["matColumnDef", "itemSize"], ["mat-cell", "", 4, "matCellDef"], ["matColumnDef", "itemButtons"], ["mat-header-row", "", "tabindex", "0", 4, "matHeaderRowDef"], ["mat-row", "", "tabindex", "0", 4, "matRowDef", "matRowDefColumns"], ["size", "md"], ["mat-header-cell", ""], i18n_2, [1, "column-title"], ["mat-cell", "", "aria-label", "file"], i18n_4, i18n_6, ["mat-cell", "", "role", "alert", "aria-live", "assertive"], ["class", "mat-error", 4, "ngIf"], i18n_8, i18n_10, [1, "mat-error"], i18n_12, i18n_14, i18n_16, i18n_18, ["mat-cell", ""], i18n_20, i18n_22, ["mat-icon-button", "", 3, "id", "click", 4, "ngIf"], ["mat-icon-button", "", "aria-label", "Remove", 3, "id", "click"], i18n_24, ["svgIcon", "assets:ts-delete", 1, "nsc-ts-svgIcon", "nsc-ts-svgIcon__delete"], ["mat-icon-button", "", 3, "id", "click"], i18n_26, ["mat-header-row", "", "tabindex", "0"], ["mat-row", "", "tabindex", "0"], [1, "mat-subheading-1"], [1, "progress"], ["role", "progressbar", 1, "progress-bar", 3, "ngStyle"]]; }, template: function ManageUploadFilesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "button", 1);
        ɵɵlistener("click", function ManageUploadFilesComponent_Template_button_click_1_listener() { return ctx.fileInputClick(); });
        ɵɵi18nStart(2, 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵelement(4, "mat-icon", 4);
        ɵɵelementEnd();
        ɵɵi18nEnd();
        ɵɵelementEnd();
        ɵɵelementStart(5, "input", 5);
        ɵɵlistener("change", function ManageUploadFilesComponent_Template_input_change_5_listener($event) { return ctx.onChange($event); });
        ɵɵelementEnd();
        ɵɵelement(6, "ts-spacer", 6);
        ɵɵelementStart(7, "div", 7);
        ɵɵlistener("click", function ManageUploadFilesComponent_Template_div_click_7_listener() { return ctx.openDialog(); })("keyup.enter", function ManageUploadFilesComponent_Template_div_keyup_enter_7_listener() { return ctx.openDialog(); })("keyup.space", function ManageUploadFilesComponent_Template_div_keyup_space_7_listener() { return ctx.openDialog(); });
        ɵɵelement(8, "mat-icon", 8);
        ɵɵelementEnd();
        ɵɵelement(9, "span", 9);
        ɵɵelementEnd();
        ɵɵtemplate(10, ManageUploadFilesComponent_div_10_Template, 19, 4, "div", 10);
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("disabled", ctx.uploadedFiles.length >= ctx.maxFileCount);
        ɵɵadvance(4);
        ɵɵproperty("disabled", ctx.uploadedFiles.length >= ctx.maxFileCount)("accept", "." + ctx.allowedFileTypes.join(", ."))("uploader", ctx.uploader);
        ɵɵadvance(4);
        ɵɵattribute("aria-label", ctx.removeStatus);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.uploadedFiles.length > 0);
    } }, directives: [MatButton, MatIcon, FileSelectDirective, SpacerComponent, MatSuffix, NgIf, MatTable, MatColumnDef, MatHeaderCellDef, MatCellDef, MatHeaderRowDef, MatRowDef, MatHeaderCell, MatCell, MatHeaderRow, MatRow, NgStyle], styles: [".education-solutions-theme[_ngcontent-%COMP%]{--brand-color-1:#437c2b;--brand-color-2:#273f21;--brand-color-3:#6db944;--brand-color-4:#599a38;--brand-color-5:#e2f1da;--brand-color-6:rgba(109,185,68,0.2);--brand-color-7:#f3f9f0;--brand-color-8:rgba(109,185,68,0.08)}#input-files[_ngcontent-%COMP%]{display:none}.progress[_ngcontent-%COMP%]{height:20px;margin-bottom:20px;overflow:hidden;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar[_ngcontent-%COMP%]{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:var(--brand-color-1);box-shadow:inset 0 -2px 4px var(--brand-color-6),2px 0 4px var(--brand-color-6),0 2px 4px var(--brand-color-6),1px 0 4px var(--brand-color-6);transition:width .6s ease}.mat-column-itemName[_ngcontent-%COMP%]{min-width:25%}.nsc-ts-form-add-file[_ngcontent-%COMP%]{align-items:center;display:flex;width:100%;padding:.4375em 0 1.25em}.nsc-ts-form-add-file__help[_ngcontent-%COMP%]{padding-left:10px}.nsc-ts-form-add-file__help[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{cursor:pointer}@media (min-width:992px){.mat-header-row[_ngcontent-%COMP%], .mat-row[_ngcontent-%COMP%]{width:85%}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(ManageUploadFilesComponent, [{
        type: Component,
        args: [{
                selector: 'ts-manage-upload-files',
                templateUrl: './manage-upload-files.component.html',
                styleUrls: ['./manage-upload-files.component.scss']
            }]
    }], function () { return [{ type: MatDialog }, { type: DataService }]; }, { url: [{
            type: Input
        }], allowedFileTypes: [{
            type: Input
        }], maxFileCount: [{
            type: Input
        }], authToken: [{
            type: Input
        }], headers: [{
            type: Input
        }] }); })();

class ManageUploadFilesModule {
}
ManageUploadFilesModule.ɵfac = function ManageUploadFilesModule_Factory(t) { return new (t || ManageUploadFilesModule)(); };
ManageUploadFilesModule.ɵmod = ɵɵdefineNgModule({ type: ManageUploadFilesModule });
ManageUploadFilesModule.ɵinj = ɵɵdefineInjector({ imports: [[
            CommonModule,
            DialogBoxModule,
            FileUploadModule,
            MaterialModule,
            SpacerModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ManageUploadFilesModule, { declarations: [ManageUploadFilesComponent], imports: [CommonModule,
        DialogBoxModule,
        FileUploadModule,
        MaterialModule,
        SpacerModule], exports: [ManageUploadFilesComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(ManageUploadFilesModule, [{
        type: NgModule,
        args: [{
                declarations: [ManageUploadFilesComponent],
                imports: [
                    CommonModule,
                    DialogBoxModule,
                    FileUploadModule,
                    MaterialModule,
                    SpacerModule
                ],
                exports: [ManageUploadFilesComponent]
            }]
    }], null, null); })();

class DynamicTableService {
    constructor() {
        this.showRow$ = new Subject();
    }
    handleDetailsRow(value) {
        this.showRow$.next(value);
    }
}
DynamicTableService.ɵfac = function DynamicTableService_Factory(t) { return new (t || DynamicTableService)(); };
DynamicTableService.ɵprov = ɵɵdefineInjectable({ token: DynamicTableService, factory: DynamicTableService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(DynamicTableService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0$5 = ["matPaginator"];
const _c1$2 = ["matSort"];
function DynamicTableComponent_ng_container_2_th_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "th", 14);
    ɵɵelementStart(1, "div", 15);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const def_r7 = ɵɵnextContext().$implicit;
    ɵɵproperty("disabled", def_r7.disabled);
    ɵɵattribute("aria-label", def_r7.keyCustomName);
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", def_r7.keyCustomName, "");
} }
function DynamicTableComponent_ng_container_2_td_3_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const element_r11 = ɵɵnextContext().$implicit;
    const def_r7 = ɵɵnextContext().$implicit;
    ɵɵattribute("aria-label", element_r11[def_r7.key]);
    ɵɵadvance(1);
    ɵɵtextInterpolate(element_r11[def_r7.key]);
} }
function DynamicTableComponent_ng_container_2_td_3_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "a", 20);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const element_r11 = ɵɵnextContext().$implicit;
    const def_r7 = ɵɵnextContext().$implicit;
    ɵɵpropertyInterpolate("href", element_r11[def_r7.typeLinkUrl], ɵɵsanitizeUrl);
    ɵɵadvance(1);
    ɵɵtextInterpolate(element_r11[def_r7.key]);
} }
function DynamicTableComponent_ng_container_2_td_3_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 21);
    ɵɵlistener("click", function DynamicTableComponent_ng_container_2_td_3_button_3_Template_button_click_0_listener() { ɵɵrestoreView(_r22); const ctx_r21 = ɵɵnextContext(); const element_r11 = ctx_r21.$implicit; const i_r12 = ctx_r21.dataIndex; const ctx_r20 = ɵɵnextContext(2); return ctx_r20.toggleRow(element_r11, i_r12); });
    ɵɵelementStart(1, "mat-icon", 22);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = ɵɵnextContext();
    const i_r12 = ctx_r23.dataIndex;
    const element_r11 = ctx_r23.$implicit;
    ɵɵpropertyInterpolate1("id", "btn-expand-row-", i_r12, "");
    ɵɵattributeInterpolate2("aria-label", "Clickeable ", element_r11.showRow ? "collapsed" : "expandable", " row", i_r12 + 1, "");
    ɵɵadvance(2);
    ɵɵtextInterpolate(element_r11.showRow ? "keyboard_arrow_up" : "keyboard_arrow_down");
} }
function DynamicTableComponent_ng_container_2_td_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "td", 16);
    ɵɵtemplate(1, DynamicTableComponent_ng_container_2_td_3_span_1_Template, 2, 2, "span", 17);
    ɵɵtemplate(2, DynamicTableComponent_ng_container_2_td_3_a_2_Template, 2, 2, "a", 18);
    ɵɵtemplate(3, DynamicTableComponent_ng_container_2_td_3_button_3_Template, 3, 4, "button", 19);
    ɵɵelementEnd();
} if (rf & 2) {
    const def_r7 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !def_r7.type);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", def_r7.type === "link");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", def_r7.type === "icons");
} }
function DynamicTableComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0, 10);
    ɵɵelementContainerStart(1, 11);
    ɵɵtemplate(2, DynamicTableComponent_ng_container_2_th_2_Template, 3, 3, "th", 12);
    ɵɵtemplate(3, DynamicTableComponent_ng_container_2_td_3_Template, 4, 3, "td", 13);
    ɵɵelementContainerEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const def_r7 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("matColumnDef", def_r7.key);
} }
function DynamicTableComponent_td_4_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "td", 23);
    ɵɵelementStart(1, "div", 24);
    ɵɵlistener("blur", function DynamicTableComponent_td_4_Template_div_blur_1_listener() { ɵɵrestoreView(_r28); const $index_r26 = ctx.dataIndex; const ctx_r27 = ɵɵnextContext(); return ctx_r27.setRowFocus(false, $index_r26); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const element_r25 = ctx.$implicit;
    const $index_r26 = ctx.dataIndex;
    const ctx_r2 = ɵɵnextContext();
    ɵɵattribute("colspan", ctx_r2.columnsToDisplay.length);
    ɵɵadvance(1);
    ɵɵstyleProp("height", element_r25.showRow ? "unset" : "0 !important");
    ɵɵpropertyInterpolate1("id", "details-box-", $index_r26, "");
    ɵɵproperty("@detailExpand", element_r25.showRow ? "expanded" : "collapsed")("innerHTML", ctx_r2.safeHtml(element_r25.detailsRow), ɵɵsanitizeHtml);
    ɵɵattribute("aria-expanded", element_r25.showRow);
} }
function DynamicTableComponent_tr_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "tr", 25);
} }
function DynamicTableComponent_tr_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "tr", 26);
} }
function DynamicTableComponent_tr_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "tr", 27);
} }
const _c2$2 = function () { return ["expandedDetail"]; };
class DynamicTableComponent {
    constructor(dynamicTableService, renderer, sanitizer) {
        this.dynamicTableService = dynamicTableService;
        this.renderer = renderer;
        this.sanitizer = sanitizer;
        this.columnsToDisplay = [];
        this.dataSource = null;
        this.tableDef = [];
        this.pageSizeOptions = [5, 10, 25, 100];
        this.pageSize = 5;
        this.details$ = new EventEmitter();
        this.expandedElement = [];
    }
    ngOnInit() {
        this.dynamicTableService.showRow$.subscribe((pos) => {
            this.dataSource.data[pos].showRow = !this.dataSource.data[pos].showRow;
            this.setRowFocus(true, pos);
        });
    }
    ngOnChanges(changes) {
        if (this.dataSource) {
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.dataSource.paginator._intl.itemsPerPageLabel = this.customItemPerPageLbl;
        }
    }
    toggleRow(value, position) {
        if (!value.showRow) {
            if (!value.detailsRow) {
                this.details$.emit(value);
            }
            else {
                value.showRow = true;
                this.setRowFocus(value.showRow, position);
            }
        }
        else {
            value.showRow = false;
            this.setRowFocus(value.showRow, position);
        }
    }
    setRowFocus(showRow, index) {
        const elementRow = this.renderer.selectRootElement(`#details-box-${index}`);
        if (showRow) {
            setTimeout(() => {
                elementRow.setAttribute('aria-live', 'polite');
                elementRow.setAttribute('tabindex', 0);
                elementRow.focus();
            }, 10);
        }
        else {
            elementRow.setAttribute('aria-live', 'off');
            elementRow.setAttribute('tabindex', -1);
        }
    }
    safeHtml(value) {
        return this.sanitizer.bypassSecurityTrustHtml(value);
    }
}
DynamicTableComponent.ɵfac = function DynamicTableComponent_Factory(t) { return new (t || DynamicTableComponent)(ɵɵdirectiveInject(DynamicTableService), ɵɵdirectiveInject(Renderer2), ɵɵdirectiveInject(DomSanitizer)); };
DynamicTableComponent.ɵcmp = ɵɵdefineComponent({ type: DynamicTableComponent, selectors: [["ts-dynamic-table"]], viewQuery: function DynamicTableComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$5, 3, MatPaginator);
        ɵɵviewQuery(_c1$2, 3, MatSort);
    } if (rf & 2) {
        let _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.paginator = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.sort = _t.first);
    } }, inputs: { columnsToDisplay: "columnsToDisplay", dataSource: "dataSource", tableDef: "tableDef", pageSizeOptions: "pageSizeOptions", pageSize: "pageSize", customItemPerPageLbl: "customItemPerPageLbl" }, outputs: { details$: "details$" }, features: [ɵɵNgOnChangesFeature], decls: 10, vars: 9, consts: [["mat-table", "", "matSort", "", "role", "grid", "multiTemplateDataRows", "", 1, "nsc-ts-table", 3, "dataSource"], ["matSort", ""], ["tabindex", "0", 4, "ngFor", "ngForOf"], ["matColumnDef", "expandedDetail"], ["mat-cell", "", 4, "matCellDef"], ["mat-header-row", "", 4, "matHeaderRowDef"], ["mat-row", "", 4, "matRowDef", "matRowDefColumns"], ["mat-row", "", "class", "nsc-ts-detail-row", 4, "matRowDef", "matRowDefColumns"], ["showFirstLastButtons", "", 3, "length", "pageSize", "pageSizeOptions"], ["matPaginator", ""], ["tabindex", "0"], [3, "matColumnDef"], ["class", "nsc-ts-th__cell--header", "scope", "col", "mat-sort-header", "", "mat-header-cell", "", 3, "disabled", 4, "matHeaderCellDef"], ["class", "nsc-ts-td__cell", "mat-cell", "", "scope", "row", 4, "matCellDef"], ["scope", "col", "mat-sort-header", "", "mat-header-cell", "", 1, "nsc-ts-th__cell--header", 3, "disabled"], [1, "column-title"], ["mat-cell", "", "scope", "row", 1, "nsc-ts-td__cell"], [4, "ngIf"], ["target", "_blank", "rel", "noopener noreferrer", 3, "href", 4, "ngIf"], ["class", "nsc-ts-btn", "mat-icon-button", "", 3, "id", "click", 4, "ngIf"], ["target", "_blank", "rel", "noopener noreferrer", 3, "href"], ["mat-icon-button", "", 1, "nsc-ts-btn", 3, "id", "click"], [1, "nsc-ts-btn__icon"], ["mat-cell", ""], ["tabindex", "-1", 1, "nsc-ts-detail__element", 3, "id", "innerHTML", "blur"], ["mat-header-row", ""], ["mat-row", ""], ["mat-row", "", 1, "nsc-ts-detail-row"]], template: function DynamicTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "table", 0, 1);
        ɵɵtemplate(2, DynamicTableComponent_ng_container_2_Template, 4, 1, "ng-container", 2);
        ɵɵelementContainerStart(3, 3);
        ɵɵtemplate(4, DynamicTableComponent_td_4_Template, 2, 7, "td", 4);
        ɵɵelementContainerEnd();
        ɵɵtemplate(5, DynamicTableComponent_tr_5_Template, 1, 0, "tr", 5);
        ɵɵtemplate(6, DynamicTableComponent_tr_6_Template, 1, 0, "tr", 6);
        ɵɵtemplate(7, DynamicTableComponent_tr_7_Template, 1, 0, "tr", 7);
        ɵɵelementEnd();
        ɵɵelement(8, "mat-paginator", 8, 9);
    } if (rf & 2) {
        ɵɵproperty("dataSource", ctx.dataSource);
        ɵɵadvance(2);
        ɵɵproperty("ngForOf", ctx.tableDef);
        ɵɵadvance(3);
        ɵɵproperty("matHeaderRowDef", ctx.columnsToDisplay);
        ɵɵadvance(1);
        ɵɵproperty("matRowDefColumns", ctx.columnsToDisplay);
        ɵɵadvance(1);
        ɵɵproperty("matRowDefColumns", ɵɵpureFunction0(8, _c2$2));
        ɵɵadvance(1);
        ɵɵproperty("length", ctx.dataSource ? ctx.dataSource.length : 0)("pageSize", ctx.pageSize)("pageSizeOptions", ctx.pageSizeOptions);
    } }, directives: [MatTable, MatSort, NgForOf, MatColumnDef, MatCellDef, MatHeaderRowDef, MatRowDef, MatPaginator, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCell, NgIf, MatButton, MatIcon, MatHeaderRow, MatRow], styles: [".education-solutions-theme[_ngcontent-%COMP%]{--brand-color-1:#437c2b;--brand-color-2:#273f21;--brand-color-3:#6db944;--brand-color-4:#599a38;--brand-color-5:#e2f1da;--brand-color-6:rgba(109,185,68,0.2);--brand-color-7:#f3f9f0;--brand-color-8:rgba(109,185,68,0.08)}.mat-row[_ngcontent-%COMP%]:nth-child(4n+3), .mat-row[_ngcontent-%COMP%]:nth-child(4n+4){background-color:var(--brand-color-7)}.nsc-ts-table[_ngcontent-%COMP%]{width:100%;display:block;overflow:auto}.nsc-ts-table[_ngcontent-%COMP%]   td.mat-cell[_ngcontent-%COMP%], .nsc-ts-table[_ngcontent-%COMP%]   td.mat-footer-cell[_ngcontent-%COMP%], .nsc-ts-table[_ngcontent-%COMP%]   th.mat-header-cell[_ngcontent-%COMP%]{padding:0 6px;border-bottom-color:transparent}.nsc-ts-table[_ngcontent-%COMP%]   td.mat-cell[_ngcontent-%COMP%]:last-of-type, .nsc-ts-table[_ngcontent-%COMP%]   td.mat-footer-cell[_ngcontent-%COMP%]:last-of-type, .nsc-ts-table[_ngcontent-%COMP%]   th.mat-header-cell[_ngcontent-%COMP%]:last-of-type{padding-right:7px}.nsc-ts-table[_ngcontent-%COMP%]   td.mat-cell[_ngcontent-%COMP%]:first-of-type, .nsc-ts-table[_ngcontent-%COMP%]   td.mat-footer-cell[_ngcontent-%COMP%]:first-of-type, .nsc-ts-table[_ngcontent-%COMP%]   th.mat-header-cell[_ngcontent-%COMP%]:first-of-type{padding-left:7px}.nsc-ts-th__cell--header[_ngcontent-%COMP%]{font-size:14px;font-weight:600;color:inherit}.nsc-ts-detail-row[_ngcontent-%COMP%]{height:0;margin-top:1rem;padding-top:1rem}.nsc-ts-detail__element[_ngcontent-%COMP%]{border-top:1.33333px dashed #c2c2c2;overflow:hidden;border-bottom:1px solid #e8e8e8}"], data: { animation: [
            trigger('detailExpand', [
                state('collapsed, void', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
                state('expanded', style({ height: '*', visibility: 'visible' })),
                transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
                transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
            ]),
        ] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(DynamicTableComponent, [{
        type: Component,
        args: [{
                selector: 'ts-dynamic-table',
                templateUrl: './dynamic-table.component.html',
                styleUrls: ['./dynamic-table.component.scss'],
                animations: [
                    trigger('detailExpand', [
                        state('collapsed, void', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
                        state('expanded', style({ height: '*', visibility: 'visible' })),
                        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
                        transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
                    ]),
                ],
            }]
    }], function () { return [{ type: DynamicTableService }, { type: Renderer2 }, { type: DomSanitizer }]; }, { paginator: [{
            type: ViewChild,
            args: ['matPaginator', { read: MatPaginator, static: true }]
        }], sort: [{
            type: ViewChild,
            args: ['matSort', { read: MatSort, static: true }]
        }], columnsToDisplay: [{
            type: Input
        }], dataSource: [{
            type: Input
        }], tableDef: [{
            type: Input
        }], pageSizeOptions: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], customItemPerPageLbl: [{
            type: Input
        }], details$: [{
            type: Output
        }] }); })();

class DynamicTableModule {
}
DynamicTableModule.ɵfac = function DynamicTableModule_Factory(t) { return new (t || DynamicTableModule)(); };
DynamicTableModule.ɵmod = ɵɵdefineNgModule({ type: DynamicTableModule });
DynamicTableModule.ɵinj = ɵɵdefineInjector({ imports: [[
            CommonModule,
            MaterialModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(DynamicTableModule, { declarations: [DynamicTableComponent], imports: [CommonModule,
        MaterialModule], exports: [DynamicTableComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(DynamicTableModule, [{
        type: NgModule,
        args: [{
                declarations: [DynamicTableComponent],
                imports: [
                    CommonModule,
                    MaterialModule,
                ],
                exports: [
                    DynamicTableComponent
                ]
            }]
    }], null, null); })();

class FormFieldSearchComponent {
    constructor(sharedCommonValues, formBuilder, manageFields) {
        this.sharedCommonValues = sharedCommonValues;
        this.formBuilder = formBuilder;
        this.manageFields = manageFields;
        this.schlData$ = new EventEmitter();
        this.unsubscribe$ = new Subject();
        this.values = {
            chFlag: this.sharedCommonValues.chFlagOptions
        };
        this.masks = {
            ficeCode: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]
        };
        this.validationFicecode = [
            Validators.required,
            Validators.minLength(9)
        ];
    }
    ngOnInit() {
        this.initForm();
    }
    initForm() {
        this.formGroup = this.formBuilder.group({
            ficeCode: new FormControl(null, this.validationFicecode),
            chFlag: new FormControl(null, [Validators.required]),
        });
    }
    getSchool() {
        this.schlData$.emit(this.formGroup.value);
    }
    clearFilter() {
        this.manageFields.reset([
            this.formGroup.controls.ficeCode,
            this.formGroup.controls.chFlag
        ]);
        this.schlData$.emit();
    }
}
FormFieldSearchComponent.ɵfac = function FormFieldSearchComponent_Factory(t) { return new (t || FormFieldSearchComponent)(ɵɵdirectiveInject(SharedCommonValues), ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(ManageFields)); };
FormFieldSearchComponent.ɵcmp = ɵɵdefineComponent({ type: FormFieldSearchComponent, selectors: [["ts-form-field-search"]], outputs: { schlData$: "schlData$" }, decls: 15, vars: 6, consts: function () { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_search_btn$$LIB_COMPONENTS_FORM_FIELD_SEARCH_FORM_FIELD_SEARCH_COMPONENT_TS_1 = goog.getMsg("Get School");
        i18n_0 = MSG_EXTERNAL_search_btn$$LIB_COMPONENTS_FORM_FIELD_SEARCH_FORM_FIELD_SEARCH_COMPONENT_TS_1;
    }
    else {
        i18n_0 = $localize `:@@search-btn␟3ea57c6a7ec5618c0914199539e6729bfe9e5fe4␟597969339729773869:Get School`;
    } let i18n_2; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_clear_btn$$LIB_COMPONENTS_FORM_FIELD_SEARCH_FORM_FIELD_SEARCH_COMPONENT_TS_3 = goog.getMsg("X");
        i18n_2 = MSG_EXTERNAL_clear_btn$$LIB_COMPONENTS_FORM_FIELD_SEARCH_FORM_FIELD_SEARCH_COMPONENT_TS_3;
    }
    else {
        i18n_2 = $localize `:@@clear-btn␟eb652ec6e5b2ef867985722c158224053cca15ab␟2995774437111770399:X`;
    } return [["novalidate", "", 3, "formGroup"], [1, "row"], [1, "col-12", "col-lg-2"], ["autocomplete", "off", "controlName", "ficeCode", "placeholder", "Enter a school", "minlength", "9", 3, "mask", "group"], ["size", "sm"], [1, "col-12", "col-lg-4"], ["controlName", "chFlag", "placeholder", "Data Filter", 3, "group", "selectObjects"], ["size", "md"], [1, "nsc-ts-form-actions"], ["mat-raised-button", "", "id", "search-btn", "color", "primary", "type", "button", 1, "nsc-ts-form-actions__button", "button-big", 3, "disabled", "click"], i18n_0, ["mat-button", "", "matSuffix", "", "id", "clear-btn", "type", "button", 1, "nsc-ts-form-actions__button--clear", 3, "click"], i18n_2]; }, template: function FormFieldSearchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "form", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelement(3, "ts-form-field-input", 3);
        ɵɵelementEnd();
        ɵɵelement(4, "ts-spacer", 4);
        ɵɵelementStart(5, "div", 5);
        ɵɵelement(6, "ts-form-field-select", 6);
        ɵɵelementEnd();
        ɵɵelement(7, "ts-spacer", 7);
        ɵɵelementStart(8, "div", 5);
        ɵɵelementStart(9, "div", 8);
        ɵɵelementStart(10, "button", 9);
        ɵɵlistener("click", function FormFieldSearchComponent_Template_button_click_10_listener() { return ctx.getSchool(); });
        ɵɵi18n(11, 10);
        ɵɵelementEnd();
        ɵɵelement(12, "ts-spacer", 4);
        ɵɵelementStart(13, "button", 11);
        ɵɵlistener("click", function FormFieldSearchComponent_Template_button_click_13_listener() { return ctx.clearFilter(); });
        ɵɵi18n(14, 12);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("formGroup", ctx.formGroup);
        ɵɵadvance(3);
        ɵɵproperty("mask", ctx.masks.ficeCode)("group", ctx.formGroup);
        ɵɵadvance(3);
        ɵɵproperty("group", ctx.formGroup)("selectObjects", ctx.values.chFlag);
        ɵɵadvance(4);
        ɵɵproperty("disabled", !ctx.formGroup.valid);
    } }, directives: [ɵangular_packages_forms_forms_ba, NgControlStatusGroup, FormGroupDirective, FormFieldInputComponent, SpacerComponent, FormFieldSelectComponent, MatButton, MatSuffix], styles: [".nsc-ts-form-actions__button--clear[_ngcontent-%COMP%]:focus, .nsc-ts-form-actions__button--clear[_ngcontent-%COMP%]:focus-within, .nsc-ts-form-actions__button--clear[_ngcontent-%COMP%]:hover{outline:none;font-weight:600}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(FormFieldSearchComponent, [{
        type: Component,
        args: [{
                selector: 'ts-form-field-search',
                templateUrl: './form-field-search.component.html',
                styleUrls: ['./form-field-search.component.scss']
            }]
    }], function () { return [{ type: SharedCommonValues }, { type: FormBuilder }, { type: ManageFields }]; }, { schlData$: [{
            type: Output
        }] }); })();

class FormFieldSearchModule {
}
FormFieldSearchModule.ɵfac = function FormFieldSearchModule_Factory(t) { return new (t || FormFieldSearchModule)(); };
FormFieldSearchModule.ɵmod = ɵɵdefineNgModule({ type: FormFieldSearchModule });
FormFieldSearchModule.ɵinj = ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormFieldInputModule,
            FormFieldSelectModule,
            MaterialModule,
            ReactiveFormsModule,
            SpacerModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(FormFieldSearchModule, { declarations: [FormFieldSearchComponent], imports: [CommonModule,
        FormFieldInputModule,
        FormFieldSelectModule,
        MaterialModule,
        ReactiveFormsModule,
        SpacerModule], exports: [FormFieldSearchComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(FormFieldSearchModule, [{
        type: NgModule,
        args: [{
                declarations: [FormFieldSearchComponent],
                imports: [
                    CommonModule,
                    FormFieldInputModule,
                    FormFieldSelectModule,
                    MaterialModule,
                    ReactiveFormsModule,
                    SpacerModule
                ],
                exports: [
                    FormFieldSearchComponent
                ]
            }]
    }], null, null); })();

class FormFieldFilesComponent {
    constructor() {
        this.uploadedFiles = [];
        this.isMaxCountReached = false;
        this.reg = /^((?![.]{2})[a-zA-Z0-9 _.-]){1,}$/;
        this.showWindowAlert = true;
        this.fileAddedEvent = new EventEmitter();
        this.displayCustomError = new EventEmitter();
    }
    ngOnInit() {
        this.initUploader();
        this.uploader.onAfterAddingFile = (fileItem) => this.onAfterAddingFile(fileItem);
        this.uploader.onBuildItemForm = (fileItem, form) => this.onBuildItemForm(fileItem, form);
        this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
        this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
    }
    initUploader() {
        const options = { url: this.url, queueLimit: this.maxFileCount };
        const headers = [];
        if (this.authorizationToken) {
            headers.push({ name: 'authorization', value: this.authorizationToken });
            options.headers = headers;
        }
        this.uploader = new FileUploader(options);
    }
    initialiseExistingFileUpload(filesUploadedBefore) {
        if (filesUploadedBefore && filesUploadedBefore.length > 0) {
            filesUploadedBefore.forEach((item) => {
                this.uploadFileManually(item);
            });
            this.savedAttachmentId = null;
        }
    }
    onAfterAddingFile(fileItem) {
        let uploadedFile = {
            originalFileItem: fileItem
        };
        if (this.savedAttachmentId) {
            uploadedFile.attachmentResponse = {
                attachmentId: this.savedAttachmentId
            };
        }
        // push fileItem to array.
        this.uploadedFiles.push(uploadedFile);
        // upload File
        this.uploadFile(fileItem);
    }
    onSuccessItem(item, response, status, headers) {
        response = JSON.parse(response);
        if (!response.success) {
            if (this.showWindowAlert) {
                window.alert(response);
            }
            else {
                const errors = response.errors ? response.errors : null;
                let scanFileErr = null;
                if (errors) {
                    scanFileErr = errors.find(error => error.message === "Virus Detected");
                }
                if (scanFileErr && scanFileErr.message && scanFileErr.message === "Virus Detected") {
                    this.displayCustomError.emit('scanfileerror');
                }
                else {
                    this.displayCustomError.emit('saveattachmentapierror');
                }
            }
            Array.from(this.uploadedFiles).forEach((uploadedFile, index) => {
                if (uploadedFile.originalFileItem === item) {
                    this.uploader.removeFromQueue(item);
                    this.uploadedFiles.splice(index, 1);
                }
            });
        }
        else {
            this.updateDataSource(response.data);
            Array.from(this.uploadedFiles).forEach((uploadedFile, index) => {
                if (uploadedFile.originalFileItem === item) {
                    uploadedFile.attachmentResponse = response.data[0];
                }
            });
            // this.isMaxCountReached = this.checkFileUploadMaxCountReached();
        }
    }
    onErrorItem(item, response, status, headers) {
        Array.from(this.uploadedFiles).forEach((uploadedFile, index) => {
            if (uploadedFile.originalFileItem === item) {
                this.uploader.removeFromQueue(item);
                this.uploadedFiles.splice(index, 1);
            }
        });
        window.alert('We are unable to accept any file uploads at this time due to a technical difficulty.');
    }
    onBuildItemForm(fileItem, form) {
        //form.append('sendAttachmentWithOrder','Y');
        Object.keys(this.formData).forEach(key => {
            form.append(key, this.formData[key]);
        });
        return { fileItem, form };
    }
    updateDataSource(data) {
        this.fileAddedEvent.emit(data);
    }
    // Pass the 'select files' button click to the file input element
    fileInputClick() {
        const fileInput = document.getElementById('input-files');
        fileInput.click();
    }
    uploadFile(fileItem) {
        if (!this.savedAttachmentId) {
            const validFile = this.validateUploadedFile(fileItem);
            if (validFile) {
                this.uploader.uploadItem(fileItem);
            }
            else {
                this.removeInvalidFile(fileItem);
            }
        }
    }
    validateUploadedFile(fileItem) {
        // Double-check that all file parameters are valid
        let validUpload = true;
        const item = fileItem;
        const filenameArr = item.file.name.split('.'); // split filename into array
        const ext = filenameArr.pop(); // keep last element as the file extension
        const fileName = filenameArr.pop();
        // Check filename against regex
        if (!this.reg.test(item.file.name)) {
            validUpload = false;
            if (this.showWindowAlert) {
                window.alert('The document does not meet the file naming conventions. File names may only contain alpha numeric characters, periods, dashes, underscore and spaces. Please ensure your document meets this requirement and try again.');
            }
            else {
                this.displayCustomError.emit('fileName');
            }
        }
        // Check filename length
        if (fileName.length > 64) {
            validUpload = false;
            if (this.showWindowAlert) {
                window.alert('The file name cannot exceed 64 characters. Please rename the file and try again.');
            }
            else {
                this.displayCustomError.emit('fileLength');
            }
        }
        // Check the extension
        if (ext && this.allowedFileTypes.indexOf(ext.toLowerCase()) < 0) {
            validUpload = false;
            if (this.showWindowAlert) {
                window.alert('The document you are trying to upload does not meet the requirements, it is the wrong file type. Please ensure your document meets this requirement and try again.');
            }
            else {
                this.displayCustomError.emit('fileExt');
            }
        }
        // Check the file size
        if (item.file.size > 5000000) {
            validUpload = false;
            if (this.showWindowAlert) {
                window.alert('The document you are trying to upload does not meet the requirements, it is larger than 5 MB. Please ensure your document meets this requirement and try again.');
            }
            else {
                this.displayCustomError.emit('fileSize');
            }
        }
        return validUpload;
    }
    uploadFileManually(data) {
        this.savedAttachmentId = data.attachmentId;
        // if we have a base64 content then we need to convert to blob
        //const fileConverted = this.convertBase64toBlob(data.content, data.contentType);
        const file = new File([data.content], data.name);
        this.uploader.addToQueue(new Array(file));
    }
    convertBase64toBlob(content, contentType) {
        contentType = contentType || '';
        const sliceSize = 512;
        const byteCharacters = window.atob(content);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, {
            type: contentType
        });
        return blob;
    }
    removeFile(uploadedFile) {
        const self = this;
        Array.from(this.uploadedFiles).forEach((tempFile, index) => {
            if (tempFile.attachmentResponse.attachmentId === uploadedFile.attachmentId) {
                self.uploader.removeFromQueue(tempFile.originalFileItem);
                self.uploadedFiles.splice(index, 1);
            }
        });
    }
    removeInvalidFile(uploadedFile) {
        const self = this;
        Array.from(this.uploadedFiles).forEach((tempFile, index) => {
            if (tempFile.originalFileItem === uploadedFile) {
                self.uploader.removeFromQueue(tempFile.originalFileItem);
                self.uploadedFiles.splice(index, 1);
            }
        });
    }
    onChange(event) {
        event.srcElement.value = "";
        if (!this.uploader.isUploading) {
            this.uploader.isUploading = false;
        }
    }
}
FormFieldFilesComponent.ɵfac = function FormFieldFilesComponent_Factory(t) { return new (t || FormFieldFilesComponent)(); };
FormFieldFilesComponent.ɵcmp = ɵɵdefineComponent({ type: FormFieldFilesComponent, selectors: [["ts-form-field-files"]], inputs: { url: "url", allowedFileTypes: "allowedFileTypes", maxFileCount: "maxFileCount", authorizationToken: "authorizationToken", formData: "formData", showWindowAlert: "showWindowAlert" }, outputs: { fileAddedEvent: "fileAddedEvent", displayCustomError: "displayCustomError" }, decls: 2, vars: 3, consts: [[1, "nsc-form-add-file"], ["ng2FileSelect", "", "id", "input-files", "type", "file", 2, "display", "none", 3, "disabled", "accept", "uploader", "change"]], template: function FormFieldFilesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "input", 1);
        ɵɵlistener("change", function FormFieldFilesComponent_Template_input_change_1_listener($event) { return ctx.onChange($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("disabled", ctx.uploadedFiles.length === ctx.maxFileCount)("accept", "." + ctx.allowedFileTypes.join(", ."))("uploader", ctx.uploader);
    } }, directives: [FileSelectDirective], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(FormFieldFilesComponent, [{
        type: Component,
        args: [{
                selector: 'ts-form-field-files',
                templateUrl: './form-field-files.component.html',
                styleUrls: ['./form-field-files.component.scss']
            }]
    }], function () { return []; }, { url: [{
            type: Input
        }], allowedFileTypes: [{
            type: Input
        }], maxFileCount: [{
            type: Input
        }], authorizationToken: [{
            type: Input
        }], formData: [{
            type: Input
        }], showWindowAlert: [{
            type: Input
        }], fileAddedEvent: [{
            type: Output
        }], displayCustomError: [{
            type: Output
        }] }); })();

class FormFieldFilesModule {
}
FormFieldFilesModule.ɵfac = function FormFieldFilesModule_Factory(t) { return new (t || FormFieldFilesModule)(); };
FormFieldFilesModule.ɵmod = ɵɵdefineNgModule({ type: FormFieldFilesModule });
FormFieldFilesModule.ɵinj = ɵɵdefineInjector({ imports: [[
            CommonModule,
            FileUploadModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(FormFieldFilesModule, { declarations: [FormFieldFilesComponent], imports: [CommonModule,
        FileUploadModule], exports: [FormFieldFilesComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(FormFieldFilesModule, [{
        type: NgModule,
        args: [{
                declarations: [FormFieldFilesComponent],
                imports: [
                    CommonModule,
                    FileUploadModule
                ],
                exports: [FormFieldFilesComponent]
            }]
    }], null, null); })();

class CheckApiResponse {
    // check the API response to make sure that there isn't an error;
    // if no JSON, then there was a server error, or an interruption with connecting to the server;
    // if the status is `fail`, then the server return a valid response that contained an error;
    isValid(json) {
        return json && json.status !== 'fail';
    }
}

// cf. https://webaim.org/resources/contrastchecker/
// cf. https://webaim.org/resources/contrastchecker/contrast.js
class WebAimContrastChecker {
    // take a foreground and background color to determine if they meet WCAG 2.0 level AA compliance;
    hasEnoughContrast(foregroudColor, backgroundColor) {
        const foregroundLuminosity = this.getLuminosity(foregroudColor);
        const backgroundLuminosity = this.getLuminosity(backgroundColor);
        const maxLuminosity = Math.max(foregroundLuminosity, backgroundLuminosity);
        const minLuminosity = Math.min(foregroundLuminosity, backgroundLuminosity);
        const ratio = (maxLuminosity + 0.05) / (minLuminosity + 0.05);
        return ratio >= 4.5;
    }
    getLuminosity(color) {
        const r = 0.2126 * this.getsRGB(color.substr(1, 2));
        const g = 0.7152 * this.getsRGB(color.substr(3, 2));
        const b = 0.0722 * this.getsRGB(color.substr(-2));
        return r + g + b;
    }
    getsRGB(color) {
        const rgbColor = parseInt(color, 16) / 255;
        return rgbColor <= 0.03928 ? rgbColor / 12.92 : Math.pow((rgbColor + 0.055) / 1.055, 2.4);
    }
}

class ConvertDeliveryMethod {
    constructor() {
        this.deliveryMethod = {
            electronicDisplaySource: ['Electronic PDF', 'Electronic Exchange'],
            electronicDisplayTarget: 'Electronic' // value to convert to;
        };
        this.deliveryFee = {
            electronicDisplaySource: ['Delivery Fee'],
            electronicDisplayTarget: 'Secure Electronic PDF Fee' // value to convert to;
        };
    }
    get(value) {
        let returnValue = value;
        this.deliveryMethod.electronicDisplaySource.forEach(source => {
            returnValue = returnValue.replace(source, this.deliveryMethod.electronicDisplayTarget);
        });
        this.deliveryFee.electronicDisplaySource.forEach(source => {
            returnValue = returnValue.replace(source, this.deliveryFee.electronicDisplayTarget);
        });
        return returnValue;
    }
}

class BlockingIndicatorRef {
    constructor(overlayRef) {
        this.overlayRef = overlayRef;
    }
    close() {
        this.overlayRef.dispose();
    }
}

class BlockingIndicatorService {
    constructor(overlay) {
        this.overlay = overlay;
    }
    open() {
        if (this.blockingRef) {
            this.blockingRef.close();
        }
        // Create an Overlay ref
        const overlayRef = this.overlay.create({
            scrollStrategy: this.overlay.scrollStrategies.block()
        });
        // Create a BlockingIndicatorRef that we can close later
        this.blockingRef = new BlockingIndicatorRef(overlayRef);
        // Create a component that can be attached to the overlay
        const filePreviewPortal = new ComponentPortal(BlockingIndicatorComponent);
        // Attach the component to the overlay
        overlayRef.attach(filePreviewPortal);
        return this.blockingRef;
    }
    close() {
        if (this.blockingRef) {
            this.blockingRef.close();
        }
    }
}
BlockingIndicatorService.ɵfac = function BlockingIndicatorService_Factory(t) { return new (t || BlockingIndicatorService)(ɵɵinject(Overlay)); };
BlockingIndicatorService.ɵprov = ɵɵdefineInjectable({ token: BlockingIndicatorService, factory: BlockingIndicatorService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(BlockingIndicatorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Overlay }]; }, null); })();

class BreadcrumbService {
    constructor() { }
    getBreadcrumbs(route, url = '', breadcrumbs = []) {
        const ROUTE_DATA_BREADCRUMB = 'breadcrumbItem';
        // get the child routes
        const children = route.children;
        // return if there are no more children
        if (children.length === 0) {
            return breadcrumbs;
        }
        // iterate over each children
        for (const child of children) {
            // verify primary route
            if (child.outlet !== PRIMARY_OUTLET) {
                continue;
            }
            // verify the custom data property "breadcrumb" is specified on the route
            if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
                return this.getBreadcrumbs(child, url, breadcrumbs);
            }
            // getting the route's URL segment
            const routeURL = child.snapshot.url.map(segment => segment.path).join('/');
            // append route URL to URL
            url += `/${routeURL}`;
            // adding to the breadcrumb
            const breadcrumb = {
                label: child.snapshot.data[ROUTE_DATA_BREADCRUMB].labelName,
                params: child.snapshot.params,
                url
            };
            breadcrumbs.push(breadcrumb);
            return this.getBreadcrumbs(child, url, breadcrumbs);
        }
    }
}
BreadcrumbService.ɵfac = function BreadcrumbService_Factory(t) { return new (t || BreadcrumbService)(); };
BreadcrumbService.ɵprov = ɵɵdefineInjectable({ token: BreadcrumbService, factory: BreadcrumbService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(BreadcrumbService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class RegisterSvgIconsService {
    constructor(matIconRegistry, sanitizer) {
        this.matIconRegistry = matIconRegistry;
        this.sanitizer = sanitizer;
    }
    registerIcons(arrayIcons, url) {
        (arrayIcons).forEach((icon) => {
            // console.log(JSON.parse(icon));
            console.log(`${url}/${icon.name}.svg`);
            this.matIconRegistry.addSvgIconInNamespace('assets', icon.name, this.sanitizer.bypassSecurityTrustResourceUrl(`${url}/${icon.name}.svg`), { viewBox: icon.viewBoxValue });
        });
    }
}
RegisterSvgIconsService.ɵfac = function RegisterSvgIconsService_Factory(t) { return new (t || RegisterSvgIconsService)(ɵɵinject(MatIconRegistry), ɵɵinject(DomSanitizer)); };
RegisterSvgIconsService.ɵprov = ɵɵdefineInjectable({ token: RegisterSvgIconsService, factory: RegisterSvgIconsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(RegisterSvgIconsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: MatIconRegistry }, { type: DomSanitizer }]; }, null); })();

function ValidateCasId(abstractControl) {
    if (abstractControl.value) {
        let errors = false;
        // there must be two dashes in the value;
        if ((abstractControl.value.match(/-/g) || []).length !== 2) {
            errors = true;
        }
        // but the dashes must be non-consecutive;
        if (abstractControl.value.indexOf('--') !== -1) {
            errors = true;
        }
        if (errors) {
            return {
                casId: true
            };
        }
    }
}

function ValidateCreditCardNumber(abstractControl) {
    const ccNumber = abstractControl.value;
    const commonValues = new SharedCommonValues();
    const creditCardRegEx = commonValues.creditCardRegEx;
    if (ccNumber) {
        const testAmericanExpress = creditCardRegEx.americanExpress.test(ccNumber);
        const testDinersClub = creditCardRegEx.dinersClub.test(ccNumber);
        const testDiscover = creditCardRegEx.discover.test(ccNumber);
        const testJCB = creditCardRegEx.jcb.test(ccNumber);
        const testMastercard = creditCardRegEx.mastercard.test(ccNumber);
        const testVisa = creditCardRegEx.visa.test(ccNumber);
        // if none of them are valid, return an error;
        if (!(testAmericanExpress ||
            testDinersClub ||
            testDiscover ||
            testJCB ||
            testMastercard ||
            testVisa)) {
            return {
                creditCardNumber: true
            };
        }
    }
}

const moment = moment_;
function ValidateDateOfBirth(abstractControl) {
    const sharedCommonValues = new SharedCommonValues();
    if (abstractControl.value) {
        const dateFormat = sharedCommonValues.dateFormat.input;
        const yearModifier = 11;
        const momentDate = moment(abstractControl.value, dateFormat);
        const dateRangePast = moment('01/01/1930', dateFormat);
        const today = new Date();
        const dateRangeFuture = moment(today).year(today.getFullYear() - yearModifier);
        let errors = false;
        // moment will allow a single slash and figure things out, but that's not allowed per the reqs;
        // reqs allow two different formats, so check for both;
        if (abstractControl.value.length === 10) {
            // is date valid;
            if (momentDate.isValid()) {
                // is date less than 1930;
                if (momentDate.isBefore(dateRangePast)) {
                    errors = true;
                }
                // is date less greater than now - 11 years;
                else if (momentDate.isAfter(dateRangeFuture)) {
                    errors = true;
                }
            }
            // otherwise invalid;
            else {
                errors = true;
            }
        }
        // otherwise invalid;
        else {
            errors = true;
        }
        if (errors) {
            return {
                dateOfBirth: true
            };
        }
    }
}

function ValidateDateCompare(fromControlName, toControlName) {
    return (abstractControl) => {
        const fromControl = abstractControl.get(fromControlName);
        let fromValue = fromControl.value;
        const toControl = abstractControl.get(toControlName);
        let toValue = toControl.value;
        const errors = toControl.errors || {};
        // if it's a full date needs to be converted to a regular date
        if (fromValue && fromValue.includes('/')) {
            fromValue = Date.parse(fromValue);
        }
        if (toValue && toValue.includes('/')) {
            toValue = Date.parse(toValue);
        }
        // if the from year isn't less than (or equal) to the to year, set an error;
        // there may be other errors, dont overwrite them;
        // if the years are valid, remove the error;
        if (fromValue && toValue && fromValue > toValue) {
            errors.dateCompare = true;
        }
        else {
            delete errors.dateCompare;
        }
        // if there are no errors present, return null;
        // angular will present an error even with an empty error object;
        toControl.setErrors(isEmpty(errors) ? null : errors);
    };
}

function ValidateDateCreditCard(monthControlName, yearControlName) {
    return (abstractControl) => {
        const monthControl = abstractControl.get(monthControlName);
        const yearControl = abstractControl.get(yearControlName);
        const errors = monthControl.errors || {};
        const monthValue = Number(monthControl.value);
        let yearValue = Number(yearControl.value);
        // only run the validation is both values are set;
        if (monthValue && yearValue) {
            // transform a 2 digit year into 4;
            // do this after the IF statement so an error message doesn't appear after selecting just a month;
            yearValue = yearValue + 2000;
            // build dates to compare (month is a zero-based index, so subtract one from our selected value);
            const dateCreditCard = new Date(yearValue, monthValue - 1);
            const dateNow = new Date();
            // if the expiration date is less than now, throw an error;
            if (dateCreditCard < dateNow) {
                errors.dateCreditCard = true;
            }
            else {
                delete errors.dateCreditCard;
            }
            // if there are no errors present, return null;
            // angular will present an error even with an empty error object;
            monthControl.setErrors(isEmpty(errors) ? null : errors);
        }
    };
}

function ValidateMatch(primaryControlName, secondaryControlName, secondaryRequired = true) {
    return (abstractControl) => {
        const primaryControl = abstractControl.get(primaryControlName);
        const secondaryControl = abstractControl.get(secondaryControlName);
        const errors = secondaryControl.errors || {};
        // only run if the secondary control is required;
        // or the user has entered an optional value;
        // so no value is allowed, or a matching value;
        if (secondaryRequired || secondaryControl.value) {
            // only run if both values have been entered, otherwise .toLowerCase() blows up;
            if (primaryControl.value && secondaryControl.value) {
                // if the values dont match, set a match error;
                // there may be other errors, dont overwrite them;
                // if they do match, make sure the match error is removed;
                if (primaryControl.value.toLowerCase() !== secondaryControl.value.toLowerCase()) {
                    errors.match = true;
                }
                else {
                    delete errors.match;
                }
            }
        }
        // if there are no errors present, return null;
        // angular will present an error even with an empty error object;
        secondaryControl.setErrors(isEmpty(errors) ? null : errors);
    };
}

function ValidateRequireEither(primaryControlName, secondaryControlName) {
    return (abstractControl) => {
        const primaryControl = abstractControl.get(primaryControlName);
        const primaryValue = primaryControl.value;
        const secondaryControl = abstractControl.get(secondaryControlName);
        const secondaryValue = secondaryControl.value;
        const isValueSet = (primaryValue && primaryValue.length) || (secondaryValue && secondaryValue.length);
        // dont need to show a specific field validation error;
        // but return an error so the form is invalid;
        // the error isn't assigned to a form field because we don't know which one to put it on since both share the requirement;
        if (!isValueSet) {
            return {
                atLeastOne: true
            };
        }
    };
}

function ValidateSchoolAutocomplete(validValues) {
    const commonValues = new SharedCommonValues();
    const validValuesClone = cloneDeep(validValues);
    // not in list is a valid value that doesn't exist in the validValues;
    // we used a cloned version of the array so the not in list value doesn't get appended to the view;
    validValuesClone.push(commonValues.autocomplete.notInList);
    return (abstractControl) => {
        const controlValue = abstractControl.value;
        if (controlValue) {
            // reduce the possible values down to find a match to the entered value;
            // transform case since the dataService will transform the content after save;
            // if we dont transform the content, then on edit they won't match;
            const filterdValues = filter(validValuesClone, (value) => {
                return value.schlName.toUpperCase() === controlValue.toUpperCase();
            });
            // if we didn't find exactly one, then it's an invalid entry;
            if (filterdValues.length !== 1) {
                return {
                    schoolAutocomplete: true
                };
            }
        }
    };
}

function ValidateStudentIdPrimary(studenIdControlName) {
    return (control) => {
        let errorsMin = null;
        // verify if there is errors to be validated
        if (control.errors) {
            // just execute if minlength or when the match is true
            if (control.errors.minlength) {
                if (control.value.length < control.errors.minlength.requiredLength) {
                    errorsMin = true;
                }
                else {
                    delete control.errors.studentIdPrimary;
                }
            }
            else if (control.errors.match) {
                if (control.parent.value.studentIdPrimary.length === control.parent.value.studentIdConfirm.length) {
                    delete control.errors.studentIdPrimary;
                }
            }
            if (errorsMin) {
                return { studentIdPrimary: true };
            }
        }
        else {
            // when the field has been validated the minglenght and then we press backspace key  errors are comming as null
            // so compare the new studentField value with the previous value saved in the parent form to make sure the validation for minlength is correct
            if (control.parent) {
                if (control.parent.value.studentIdPrimary && control.parent.value.studentIdConfirm) {
                    return control.parent.value.studentIdPrimary.length === control.value.length ? null : { studentIdPrimary: true };
                }
            }
        }
        return null;
    };
}

function RecipientDetailsComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 8);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r3.error, " ");
} }
function RecipientDetailsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 3);
    ɵɵelementStart(1, "div", 4);
    ɵɵelementStart(2, "button", 5);
    ɵɵlistener("click", function RecipientDetailsComponent_div_0_Template_button_click_2_listener() { ɵɵrestoreView(_r5); const ctx_r4 = ɵɵnextContext(); return ctx_r4.add(); });
    ɵɵi18nStart(3, 6);
    ɵɵelement(4, "mat-icon");
    ɵɵi18nEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(5, RecipientDetailsComponent_div_0_div_5_Template, 2, 1, "div", 7);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("disabled", ctx_r0.recipients.length >= ctx_r0.maxRecipients);
    ɵɵadvance(3);
    ɵɵproperty("ngIf", ctx_r0.error);
} }
function RecipientDetailsComponent_ts_spacer_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "ts-spacer");
} }
function RecipientDetailsComponent_div_2_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 4);
    ɵɵelementStart(1, "a", 20);
    ɵɵlistener("click", function RecipientDetailsComponent_div_2_div_2_div_2_Template_a_click_1_listener() { ɵɵrestoreView(_r29); const $index_r7 = ɵɵnextContext(2).index; const ctx_r27 = ɵɵnextContext(); return ctx_r27.edit($index_r7); });
    ɵɵi18nStart(2, 21);
    ɵɵelement(3, "mat-icon", 22);
    ɵɵelement(4, "span", 23);
    ɵɵi18nEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const $index_r7 = ɵɵnextContext(2).index;
    ɵɵadvance(1);
    ɵɵpropertyInterpolate1("id", "edit-recipient-", $index_r7, "-btn");
} }
function RecipientDetailsComponent_div_2_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 4);
    ɵɵelementStart(1, "a", 20);
    ɵɵlistener("click", function RecipientDetailsComponent_div_2_div_2_div_3_Template_a_click_1_listener() { ɵɵrestoreView(_r33); const $index_r7 = ɵɵnextContext(2).index; const ctx_r31 = ɵɵnextContext(); return ctx_r31.delete($index_r7); });
    ɵɵi18nStart(2, 24);
    ɵɵelement(3, "mat-icon", 25);
    ɵɵelement(4, "span", 23);
    ɵɵi18nEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const $index_r7 = ɵɵnextContext(2).index;
    ɵɵadvance(1);
    ɵɵpropertyInterpolate1("id", "delete-recipient-", $index_r7, "-btn");
} }
function RecipientDetailsComponent_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 13);
    ɵɵelementStart(1, "div", 18);
    ɵɵtemplate(2, RecipientDetailsComponent_div_2_div_2_div_2_Template, 5, 1, "div", 19);
    ɵɵtemplate(3, RecipientDetailsComponent_div_2_div_2_div_3_Template, 5, 1, "div", 19);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r8.editRecipient.observers.length);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r8.hideOptions.removeBtn && ctx_r8.deleteRecipient.observers.length);
} }
function RecipientDetailsComponent_div_2_div_3_a_8_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", 30);
    ɵɵlistener("click", function RecipientDetailsComponent_div_2_div_3_a_8_Template_a_click_0_listener() { ɵɵrestoreView(_r37); const ctx_r36 = ɵɵnextContext(3); return ctx_r36.openDialogBox("totalFee"); });
    ɵɵi18nStart(1, 31);
    ɵɵelement(2, "mat-icon");
    ɵɵelementStart(3, "div", 32);
    ɵɵelement(4, "mat-icon", 33);
    ɵɵelementEnd();
    ɵɵi18nEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const $index_r7 = ɵɵnextContext(2).index;
    ɵɵpropertyInterpolate1("id", "recpt-", $index_r7, "-totalFee-info-btn");
} }
function RecipientDetailsComponent_div_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 13);
    ɵɵelementStart(1, "div", 26);
    ɵɵelementStart(2, "div", 27);
    ɵɵelementStart(3, "label", 28);
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(5, "div", 27);
    ɵɵtext(6);
    ɵɵpipe(7, "currency");
    ɵɵtemplate(8, RecipientDetailsComponent_div_2_div_3_a_8_Template, 5, 1, "a", 29);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const recipient_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(4);
    ɵɵtextInterpolate1("", recipient_r6.fees.totalFee.description, ":");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(7, 3, recipient_r6.fees.totalFee.value), " ");
    ɵɵadvance(2);
    ɵɵproperty("ngIf", recipient_r6.isTNSchool && recipient_r6.fees.totalFee.value === 0);
} }
function RecipientDetailsComponent_div_2_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵi18nStart(1, 34);
    ɵɵelement(2, "span", 35);
    ɵɵelement(3, "span");
    ɵɵi18nEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const recipient_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(3);
    ɵɵi18nExp(recipient_r6.orderNumber);
    ɵɵi18nApply(1);
} }
function RecipientDetailsComponent_div_2_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵi18nStart(1, 36);
    ɵɵelement(2, "span", 37);
    ɵɵi18nEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const recipient_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(2);
    ɵɵi18nExp(recipient_r6.sendingSchl);
    ɵɵi18nApply(1);
} }
function RecipientDetailsComponent_div_2_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵi18nStart(1, 38);
    ɵɵelement(2, "span", 39);
    ɵɵi18nEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const recipient_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(2);
    ɵɵi18nExp(recipient_r6.studentName);
    ɵɵi18nApply(1);
} }
function RecipientDetailsComponent_div_2_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵi18nStart(1, 40);
    ɵɵelement(2, "span", 39);
    ɵɵi18nEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const recipient_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(2);
    ɵɵi18nExp(recipient_r6.studentPreviousName);
    ɵɵi18nApply(1);
} }
function RecipientDetailsComponent_div_2_div_14_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵi18nStart(1, 41);
    ɵɵelement(2, "span", 42);
    ɵɵi18nEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const recipient_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(2);
    ɵɵi18nExp(recipient_r6.attention);
    ɵɵi18nApply(1);
} }
function RecipientDetailsComponent_div_2_div_15_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵi18nStart(1, 43);
    ɵɵelement(2, "span", 44);
    ɵɵi18nEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const recipient_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(2);
    ɵɵi18nExp(recipient_r6.email);
    ɵɵi18nApply(1);
} }
function RecipientDetailsComponent_div_2_div_16_br_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "br");
} }
function RecipientDetailsComponent_div_2_div_16_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const recipient_r6 = ɵɵnextContext(2).$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", recipient_r6.address.state, " ");
} }
function RecipientDetailsComponent_div_2_div_16_span_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const recipient_r6 = ɵɵnextContext(2).$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1("", recipient_r6.address.zip, " ");
} }
function RecipientDetailsComponent_div_2_div_16_span_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1);
    ɵɵpipe(2, "uppercase");
    ɵɵelementEnd();
} if (rf & 2) {
    const recipient_r6 = ɵɵnextContext(2).$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(2, 1, recipient_r6.address.country), "");
} }
function RecipientDetailsComponent_div_2_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "span", 45);
    ɵɵi18n(2, 46);
    ɵɵelementEnd();
    ɵɵelementStart(3, "p");
    ɵɵtext(4);
    ɵɵelement(5, "br");
    ɵɵtext(6);
    ɵɵtemplate(7, RecipientDetailsComponent_div_2_div_16_br_7_Template, 1, 0, "br", 1);
    ɵɵtext(8);
    ɵɵtemplate(9, RecipientDetailsComponent_div_2_div_16_span_9_Template, 2, 1, "span", 1);
    ɵɵtemplate(10, RecipientDetailsComponent_div_2_div_16_span_10_Template, 2, 1, "span", 1);
    ɵɵtemplate(11, RecipientDetailsComponent_div_2_div_16_span_11_Template, 3, 3, "span", 1);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const recipient_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(4);
    ɵɵtextInterpolate1(" ", recipient_r6.address.addressLine1, "");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", recipient_r6.address.addressLine2, "");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", recipient_r6.address.addressLine2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", recipient_r6.address.city, ",");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", recipient_r6.address.state != "ZZ");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", recipient_r6.address.zip != "N/A");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", recipient_r6.address.country !== "US");
} }
function RecipientDetailsComponent_div_2_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 10);
    ɵɵelementStart(1, "div", 27);
    ɵɵelementStart(2, "span", 47);
    ɵɵtext(3, "Processing Option:");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 27);
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const recipient_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(5);
    ɵɵtextInterpolate1(" ", recipient_r6.processingOption.description, " ");
} }
function RecipientDetailsComponent_div_2_div_21_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 10);
    ɵɵelementStart(1, "div", 27);
    ɵɵelementStart(2, "span", 48);
    ɵɵtext(3, "Transcript Type:");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 27);
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const recipient_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(5);
    ɵɵtextInterpolate1(" ", recipient_r6.transcriptType, " ");
} }
function RecipientDetailsComponent_div_2_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r58 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 10);
    ɵɵelementStart(1, "div", 27);
    ɵɵelementStart(2, "span", 49);
    ɵɵtext(3, "Delivery Method:");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 27);
    ɵɵelementStart(5, "div", 50);
    ɵɵelementStart(6, "span");
    ɵɵtext(7);
    ɵɵelementEnd();
    ɵɵelementStart(8, "a", 30);
    ɵɵlistener("click", function RecipientDetailsComponent_div_2_div_22_Template_a_click_8_listener() { ɵɵrestoreView(_r58); const recipient_r6 = ɵɵnextContext().$implicit; const ctx_r56 = ɵɵnextContext(); return ctx_r56.openDialogBox("deliveryMethod", recipient_r6.deliveryMethod.helpText); });
    ɵɵi18nStart(9, 51);
    ɵɵelementStart(10, "div", 32);
    ɵɵelement(11, "mat-icon", 33);
    ɵɵelementEnd();
    ɵɵi18nEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r59 = ɵɵnextContext();
    const recipient_r6 = ctx_r59.$implicit;
    const $index_r7 = ctx_r59.index;
    ɵɵadvance(7);
    ɵɵtextInterpolate(recipient_r6.deliveryMethodDisplay);
    ɵɵadvance(1);
    ɵɵpropertyInterpolate1("id", "recpt-", $index_r7, "-delivMethod-info-btn");
} }
function RecipientDetailsComponent_div_2_div_23_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 10);
    ɵɵelementStart(1, "div", 27);
    ɵɵelementStart(2, "span", 52);
    ɵɵtext(3, "Quantity:");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 27);
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const recipient_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(5);
    ɵɵtextInterpolate1(" ", recipient_r6.quantity, " ");
} }
function RecipientDetailsComponent_div_2_div_24_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 10);
    ɵɵelementStart(1, "div", 27);
    ɵɵelementStart(2, "span", 53);
    ɵɵtext(3, "Campus:");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 27);
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const recipient_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(5);
    ɵɵtextInterpolate1(" ", recipient_r6.campus, " ");
} }
function RecipientDetailsComponent_div_2_div_25_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 10);
    ɵɵelementStart(1, "div", 27);
    ɵɵelementStart(2, "span", 54);
    ɵɵtext(3, "State:");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 27);
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const recipient_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(5);
    ɵɵtextInterpolate1(" ", recipient_r6.state, " ");
} }
function RecipientDetailsComponent_div_2_div_26_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 10);
    ɵɵelementStart(1, "div", 27);
    ɵɵelementStart(2, "span", 56);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 27);
    ɵɵtext(5);
    ɵɵpipe(6, "currency");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const fee_r64 = ctx.$implicit;
    ɵɵadvance(3);
    ɵɵtextInterpolate1("", fee_r64.description, ":");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(6, 2, fee_r64.value), " ");
} }
function RecipientDetailsComponent_div_2_div_26_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, RecipientDetailsComponent_div_2_div_26_div_1_Template, 7, 4, "div", 55);
    ɵɵelementEnd();
} if (rf & 2) {
    const recipient_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", recipient_r6.fees);
} }
function RecipientDetailsComponent_div_2_div_27_li_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "li");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const attachment_r67 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", attachment_r67.originalFileName ? attachment_r67.originalFileName : attachment_r67.attachmentResponse.originalFileName, " ");
} }
function RecipientDetailsComponent_div_2_div_27_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 10);
    ɵɵelementStart(1, "div", 27);
    ɵɵelementStart(2, "span", 57);
    ɵɵtext(3, "Documents Uploaded:");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 27);
    ɵɵelementStart(5, "ul", 58);
    ɵɵtemplate(6, RecipientDetailsComponent_div_2_div_27_li_6_Template, 2, 1, "li", 59);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const recipient_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(6);
    ɵɵproperty("ngForOf", recipient_r6.attachments);
} }
function RecipientDetailsComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 9);
    ɵɵelementStart(1, "div", 10);
    ɵɵtemplate(2, RecipientDetailsComponent_div_2_div_2_Template, 4, 2, "div", 11);
    ɵɵtemplate(3, RecipientDetailsComponent_div_2_div_3_Template, 9, 5, "div", 11);
    ɵɵelementEnd();
    ɵɵelement(4, "ts-spacer");
    ɵɵelementStart(5, "div", 12);
    ɵɵelementStart(6, "div", 13);
    ɵɵtemplate(7, RecipientDetailsComponent_div_2_div_7_Template, 4, 1, "div", 1);
    ɵɵtemplate(8, RecipientDetailsComponent_div_2_div_8_Template, 3, 1, "div", 1);
    ɵɵtemplate(9, RecipientDetailsComponent_div_2_div_9_Template, 3, 1, "div", 1);
    ɵɵtemplate(10, RecipientDetailsComponent_div_2_div_10_Template, 3, 1, "div", 1);
    ɵɵelementStart(11, "div");
    ɵɵi18nStart(12, 14);
    ɵɵelement(13, "span", 15);
    ɵɵi18nEnd();
    ɵɵelementEnd();
    ɵɵtemplate(14, RecipientDetailsComponent_div_2_div_14_Template, 3, 1, "div", 1);
    ɵɵtemplate(15, RecipientDetailsComponent_div_2_div_15_Template, 3, 1, "div", 1);
    ɵɵtemplate(16, RecipientDetailsComponent_div_2_div_16_Template, 12, 7, "div", 1);
    ɵɵelementEnd();
    ɵɵelementStart(17, "div", 13);
    ɵɵelementStart(18, "div", 16);
    ɵɵelement(19, "ts-spacer");
    ɵɵelementEnd();
    ɵɵtemplate(20, RecipientDetailsComponent_div_2_div_20_Template, 6, 1, "div", 17);
    ɵɵtemplate(21, RecipientDetailsComponent_div_2_div_21_Template, 6, 1, "div", 17);
    ɵɵtemplate(22, RecipientDetailsComponent_div_2_div_22_Template, 12, 2, "div", 17);
    ɵɵtemplate(23, RecipientDetailsComponent_div_2_div_23_Template, 6, 1, "div", 17);
    ɵɵtemplate(24, RecipientDetailsComponent_div_2_div_24_Template, 6, 1, "div", 17);
    ɵɵtemplate(25, RecipientDetailsComponent_div_2_div_25_Template, 6, 1, "div", 17);
    ɵɵtemplate(26, RecipientDetailsComponent_div_2_div_26_Template, 2, 1, "div", 1);
    ɵɵtemplate(27, RecipientDetailsComponent_div_2_div_27_Template, 7, 1, "div", 17);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const recipient_r6 = ctx.$implicit;
    const ctx_r2 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("ngIf", !ctx_r2.hideOptions.editBtn || !ctx_r2.hideOptions.removeBtn);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r2.hideOptions.recipientFeeTotalFee && (recipient_r6.fees.totalFee.value !== 0 || recipient_r6.isTNSchool && recipient_r6.fees.totalFee.value === 0));
    ɵɵadvance(4);
    ɵɵproperty("ngIf", recipient_r6.orderNumber);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", recipient_r6.sendingSchl);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", recipient_r6.studentName);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", recipient_r6.studentPreviousName);
    ɵɵadvance(3);
    ɵɵi18nExp(recipient_r6.recipient);
    ɵɵi18nApply(12);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", recipient_r6.attention);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", recipient_r6.email);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", recipient_r6.address);
    ɵɵadvance(4);
    ɵɵproperty("ngIf", recipient_r6.processingOption);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", recipient_r6.transcriptType);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", recipient_r6.deliveryMethod);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", recipient_r6.quantity);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", recipient_r6.campus);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", recipient_r6.state);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r2.hideOptions.allDeliveryFees && recipient_r6.fees && recipient_r6.fees.value !== 0);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", recipient_r6.attachments && recipient_r6.attachments.length > 0);
} }
class RecipientDetailsComponent {
    constructor() {
        this.deleteRecipient = new EventEmitter();
        this.editRecipient = new EventEmitter();
        this.openDialog = new EventEmitter();
        this.addRecipient = new EventEmitter();
        this.error = null;
        this.recipients = [];
        this.hideOptions = {
            allDeliveryFees: false,
            addBtn: false,
            editBtn: false,
            removeBtn: false,
            recipientFeeTotalFee: false
        };
    }
    ngOnInit() {
    }
    edit(itemIndex) {
        this.editRecipient.emit(itemIndex);
    }
    delete(itemIndex) {
        this.deleteRecipient.emit(itemIndex);
    }
    add() {
        this.addRecipient.emit();
    }
    openDialogBox(recptType, helpInfo) {
        const details = {
            recptType,
            helpInfo
        };
        this.openDialog.emit(details);
    }
}
RecipientDetailsComponent.ɵfac = function RecipientDetailsComponent_Factory(t) { return new (t || RecipientDetailsComponent)(); };
RecipientDetailsComponent.ɵcmp = ɵɵdefineComponent({ type: RecipientDetailsComponent, selectors: [["ts-recipient-details"]], inputs: { error: "error", maxRecipients: "maxRecipients", recipients: "recipients", hideOptions: "hideOptions" }, outputs: { deleteRecipient: "deleteRecipient", editRecipient: "editRecipient", openDialog: "openDialog", addRecipient: "addRecipient" }, decls: 3, vars: 3, consts: function () { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_add_recpt_btn$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS__1 = goog.getMsg("Add Recipient {$startTagMatIcon}add{$closeTagMatIcon}", { "startTagMatIcon": "\uFFFD#4\uFFFD", "closeTagMatIcon": "\uFFFD/#4\uFFFD" });
        i18n_0 = MSG_EXTERNAL_add_recpt_btn$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS__1;
    }
    else {
        i18n_0 = $localize `:@@add-recpt-btn␟220bc29a4af46a82c61cf4229654fe86e7f9e8b9␟418647627857443383:Add Recipient ${"\uFFFD#4\uFFFD"}:START_TAG_MAT_ICON:add${"\uFFFD/#4\uFFFD"}:CLOSE_TAG_MAT_ICON:`;
    } let i18n_2; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_recipient$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS__3 = goog.getMsg("{$startTagSpan}Recipient: {$closeTagSpan}{$interpolation} ", { "startTagSpan": "\uFFFD#13\uFFFD", "closeTagSpan": "\uFFFD/#13\uFFFD", "interpolation": "\uFFFD0\uFFFD" });
        i18n_2 = MSG_EXTERNAL_recipient$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS__3;
    }
    else {
        i18n_2 = $localize `:@@recipient␟e1db457ec1a5676ae1e9012acf200505dcb1e1ec␟4781726957868948354:${"\uFFFD#13\uFFFD"}:START_TAG_SPAN:Recipient: ${"\uFFFD/#13\uFFFD"}:CLOSE_TAG_SPAN:${"\uFFFD0\uFFFD"}:INTERPOLATION: `;
    } let i18n_4; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_edit_recipient____index___btn$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS____5 = goog.getMsg("{$startTagMatIcon}{$closeTagMatIcon}{$startTagSpan}Edit{$closeTagSpan}", { "startTagMatIcon": "\uFFFD#3\uFFFD", "closeTagMatIcon": "\uFFFD/#3\uFFFD", "startTagSpan": "\uFFFD#4\uFFFD", "closeTagSpan": "\uFFFD/#4\uFFFD" });
        i18n_4 = MSG_EXTERNAL_edit_recipient____index___btn$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS____5;
    }
    else {
        i18n_4 = $localize `:@@edit-recipient-{{$index}}-btn␟f99758ff637f3a9965c2f7166d3215d01bb64c6a␟760459201013500294:${"\uFFFD#3\uFFFD"}:START_TAG_MAT_ICON:${"\uFFFD/#3\uFFFD"}:CLOSE_TAG_MAT_ICON:${"\uFFFD#4\uFFFD"}:START_TAG_SPAN:Edit${"\uFFFD/#4\uFFFD"}:CLOSE_TAG_SPAN:`;
    } let i18n_6; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_delete_recipient____index___btn$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS____7 = goog.getMsg("{$startTagMatIcon}{$closeTagMatIcon}{$startTagSpan}Remove{$closeTagSpan}", { "startTagMatIcon": "\uFFFD#3\uFFFD", "closeTagMatIcon": "\uFFFD/#3\uFFFD", "startTagSpan": "\uFFFD#4\uFFFD", "closeTagSpan": "\uFFFD/#4\uFFFD" });
        i18n_6 = MSG_EXTERNAL_delete_recipient____index___btn$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS____7;
    }
    else {
        i18n_6 = $localize `:@@delete-recipient-{{$index}}-btn␟5fcfec8446c61a5350f9456b977093d6664bb887␟7451279490532815946:${"\uFFFD#3\uFFFD"}:START_TAG_MAT_ICON:${"\uFFFD/#3\uFFFD"}:CLOSE_TAG_MAT_ICON:${"\uFFFD#4\uFFFD"}:START_TAG_SPAN:Remove${"\uFFFD/#4\uFFFD"}:CLOSE_TAG_SPAN:`;
    } let i18n_8; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_recpt____index___totalFee_info_btn$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS____9 = goog.getMsg("{$startTagMatIcon}info{$closeTagMatIcon}{$startTagDiv}{$startTagMatIcon_1}{$closeTagMatIcon}{$closeTagDiv}", { "startTagMatIcon": "\uFFFD#2\uFFFD", "closeTagMatIcon": "[\uFFFD/#2\uFFFD|\uFFFD/#4\uFFFD]", "startTagDiv": "\uFFFD#3\uFFFD", "startTagMatIcon_1": "\uFFFD#4\uFFFD", "closeTagDiv": "\uFFFD/#3\uFFFD" });
        i18n_8 = MSG_EXTERNAL_recpt____index___totalFee_info_btn$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS____9;
    }
    else {
        i18n_8 = $localize `:@@recpt-{{$index}}-totalFee-info-btn␟b4419fae1f7d6f47fe7036e0e0ed384ccafa0063␟7060227699126896200:${"\uFFFD#2\uFFFD"}:START_TAG_MAT_ICON:info${"[\uFFFD/#2\uFFFD|\uFFFD/#4\uFFFD]"}:CLOSE_TAG_MAT_ICON:${"\uFFFD#3\uFFFD"}:START_TAG_DIV:${"\uFFFD#4\uFFFD"}:START_TAG_MAT_ICON_1:${"[\uFFFD/#2\uFFFD|\uFFFD/#4\uFFFD]"}:CLOSE_TAG_MAT_ICON:${"\uFFFD/#3\uFFFD"}:CLOSE_TAG_DIV:`;
    } i18n_8 = ɵɵi18nPostprocess(i18n_8); let i18n_10; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_orderNumber$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS___11 = goog.getMsg("{$startTagSpan}Order Number: {$closeTagSpan}{$startTagSpan_1} {$interpolation}{$closeTagSpan}", { "startTagSpan": "\uFFFD#2\uFFFD", "closeTagSpan": "[\uFFFD/#2\uFFFD|\uFFFD/#3\uFFFD]", "startTagSpan_1": "\uFFFD#3\uFFFD", "interpolation": "\uFFFD0\uFFFD" });
        i18n_10 = MSG_EXTERNAL_orderNumber$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS___11;
    }
    else {
        i18n_10 = $localize `:@@orderNumber␟2c91cad1f2779998617e56ef2b87d7dae3e9357e␟322646199687958322:${"\uFFFD#2\uFFFD"}:START_TAG_SPAN:Order Number: ${"[\uFFFD/#2\uFFFD|\uFFFD/#3\uFFFD]"}:CLOSE_TAG_SPAN:${"\uFFFD#3\uFFFD"}:START_TAG_SPAN_1: ${"\uFFFD0\uFFFD"}:INTERPOLATION:${"[\uFFFD/#2\uFFFD|\uFFFD/#3\uFFFD]"}:CLOSE_TAG_SPAN:`;
    } i18n_10 = ɵɵi18nPostprocess(i18n_10); let i18n_12; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_sending_school$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS___13 = goog.getMsg("{$startTagSpan}Sending School: {$closeTagSpan}{$interpolation} ", { "startTagSpan": "\uFFFD#2\uFFFD", "closeTagSpan": "\uFFFD/#2\uFFFD", "interpolation": "\uFFFD0\uFFFD" });
        i18n_12 = MSG_EXTERNAL_sending_school$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS___13;
    }
    else {
        i18n_12 = $localize `:@@sending school␟a928583c0b7a9cf76a0ab09ec5ef684f1ecc9ea9␟1240774809235719080:${"\uFFFD#2\uFFFD"}:START_TAG_SPAN:Sending School: ${"\uFFFD/#2\uFFFD"}:CLOSE_TAG_SPAN:${"\uFFFD0\uFFFD"}:INTERPOLATION: `;
    } let i18n_14; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_studentName$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS___15 = goog.getMsg("{$startTagSpan}Student: {$closeTagSpan}{$interpolation} ", { "startTagSpan": "\uFFFD#2\uFFFD", "closeTagSpan": "\uFFFD/#2\uFFFD", "interpolation": "\uFFFD0\uFFFD" });
        i18n_14 = MSG_EXTERNAL_studentName$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS___15;
    }
    else {
        i18n_14 = $localize `:@@studentName␟8a22abd141d2a90388e71902ce5fe6c9391b5f1c␟6307049856784672439:${"\uFFFD#2\uFFFD"}:START_TAG_SPAN:Student: ${"\uFFFD/#2\uFFFD"}:CLOSE_TAG_SPAN:${"\uFFFD0\uFFFD"}:INTERPOLATION: `;
    } let i18n_16; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_studentPreviousName$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS___17 = goog.getMsg("{$startTagSpan}Previous Name: {$closeTagSpan}{$interpolation} ", { "startTagSpan": "\uFFFD#2\uFFFD", "closeTagSpan": "\uFFFD/#2\uFFFD", "interpolation": "\uFFFD0\uFFFD" });
        i18n_16 = MSG_EXTERNAL_studentPreviousName$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS___17;
    }
    else {
        i18n_16 = $localize `:@@studentPreviousName␟e1ed43c5385adef09b2ea05bd841a9de3d5d3c85␟658254088246619243:${"\uFFFD#2\uFFFD"}:START_TAG_SPAN:Previous Name: ${"\uFFFD/#2\uFFFD"}:CLOSE_TAG_SPAN:${"\uFFFD0\uFFFD"}:INTERPOLATION: `;
    } let i18n_18; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_attention$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS___19 = goog.getMsg("{$startTagSpan}Attention: {$closeTagSpan}{$interpolation} ", { "startTagSpan": "\uFFFD#2\uFFFD", "closeTagSpan": "\uFFFD/#2\uFFFD", "interpolation": "\uFFFD0\uFFFD" });
        i18n_18 = MSG_EXTERNAL_attention$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS___19;
    }
    else {
        i18n_18 = $localize `:@@attention␟c450cd0835bb79fcad82fc6fdc1f84201158ddaf␟583939742549424378:${"\uFFFD#2\uFFFD"}:START_TAG_SPAN:Attention: ${"\uFFFD/#2\uFFFD"}:CLOSE_TAG_SPAN:${"\uFFFD0\uFFFD"}:INTERPOLATION: `;
    } let i18n_20; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_email$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS___21 = goog.getMsg("{$startTagSpan}Email: {$closeTagSpan}{$interpolation} ", { "startTagSpan": "\uFFFD#2\uFFFD", "closeTagSpan": "\uFFFD/#2\uFFFD", "interpolation": "\uFFFD0\uFFFD" });
        i18n_20 = MSG_EXTERNAL_email$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS___21;
    }
    else {
        i18n_20 = $localize `:@@email␟fa9b5aa419364da9d454654b1a917d2a26d1cc17␟799334878867874694:${"\uFFFD#2\uFFFD"}:START_TAG_SPAN:Email: ${"\uFFFD/#2\uFFFD"}:CLOSE_TAG_SPAN:${"\uFFFD0\uFFFD"}:INTERPOLATION: `;
    } let i18n_22; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_recipientAddress$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS___23 = goog.getMsg("Recipient Address:");
        i18n_22 = MSG_EXTERNAL_recipientAddress$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS___23;
    }
    else {
        i18n_22 = $localize `:@@recipientAddress␟ed771133d72d11a27f1af2283cdc3a69a89a7240␟3572582107672494574:Recipient Address:`;
    } let i18n_24; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_recpt____index___delivMethod_info_btn$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS___25 = goog.getMsg("{$startTagDiv}{$startTagMatIcon}{$closeTagMatIcon}{$closeTagDiv}", { "startTagDiv": "\uFFFD#10\uFFFD", "startTagMatIcon": "\uFFFD#11\uFFFD", "closeTagMatIcon": "\uFFFD/#11\uFFFD", "closeTagDiv": "\uFFFD/#10\uFFFD" });
        i18n_24 = MSG_EXTERNAL_recpt____index___delivMethod_info_btn$$LIB_PAGES_RECIPIENT_DETAILS_RECIPIENT_DETAILS_COMPONENT_TS___25;
    }
    else {
        i18n_24 = $localize `:@@recpt-{{$index}}-delivMethod-info-btn␟a18b5acf219e63103c5aa386e5d2d1b1894acf36␟2698336392460870372:${"\uFFFD#10\uFFFD"}:START_TAG_DIV:${"\uFFFD#11\uFFFD"}:START_TAG_MAT_ICON:${"\uFFFD/#11\uFFFD"}:CLOSE_TAG_MAT_ICON:${"\uFFFD/#10\uFFFD"}:CLOSE_TAG_DIV:`;
    } return [["class", "row nsc-row--20 align-items-center", 4, "ngIf"], [4, "ngIf"], ["class", "mat-body-2", "tabindex", "0", 4, "ngFor", "ngForOf"], [1, "row", "nsc-row--20", "align-items-center"], [1, "col-auto"], ["mat-raised-button", "", "id", "add-recpt-btn", "type", "button", "color", "primary", 1, "nsc-ts-button", 3, "disabled", "click"], i18n_0, ["class", "col", 4, "ngIf"], [1, "col"], ["tabindex", "0", 1, "mat-body-2"], [1, "row"], ["class", "col-12 col-lg-6", 4, "ngIf"], [1, "row", "nsc-ts-recipient-details__content"], [1, "col-12", "col-lg-6"], i18n_2, ["aria-label", "Recipient", 1, "lbl-name"], [1, "d-lg-none"], ["class", "row", 4, "ngIf"], [1, "row", "nsc-row--12", "align-items-center"], ["class", "col-auto", 4, "ngIf"], ["role", "button", "tabindex", "0", 1, "d-inline-flex", "align-items-center", "nsc-ts-recipient-details__button", 3, "id", "click"], i18n_4, ["svgIcon", "assets:ts-edit"], [1, "d-md-block"], i18n_6, ["svgIcon", "assets:ts-delete-trush"], [1, "row", "nsc-ts-recipient-details__total-fee", "nsc-ts-recipient-details__content"], [1, "col-6"], ["aria-label", "", 1, "lbl-name"], ["role", "button", "tabindex", "0", "aria-label", "info", "class", "nsc-ts-recipient-details__delivery-method-icon", 3, "id", "click", 4, "ngIf"], ["role", "button", "tabindex", "0", "aria-label", "info", 1, "nsc-ts-recipient-details__delivery-method-icon", 3, "id", "click"], i18n_8, ["matSuffix", ""], ["svgIcon", "assets:ts-info", 1, "nsc-ts-svgIcon", "nsc-ts-svgIcon__info"], i18n_10, ["aria-label", "order number", 1, "lbl-name"], i18n_12, ["aria-label", "sending school", 1, "lbl-name"], i18n_14, ["aria-label", "student name", 1, "lbl-name"], i18n_16, i18n_18, ["aria-label", "Attention", 1, "lbl-name"], i18n_20, ["aria-label", "Email", 1, "lbl-name"], ["aria-label", "Recipient Address:", 1, "lbl-name"], i18n_22, ["aria-label", "Processing Option", 1, "lbl-name"], ["aria-label", "Transcript Type", 1, "lbl-name"], ["aria-label", "Delivery Method", 1, "lbl-name"], [1, "nsc-ts-recipient-details__delivery-method"], i18n_24, ["aria-label", "Quantity", 1, "lbl-name"], ["aria-label", "campus", 1, "lbl-name"], ["aria-label", "state", 1, "lbl-name"], ["class", "row", 4, "ngFor", "ngForOf"], ["aria-label", "fee.description ", 1, "lbl-name"], ["aria-label", "Documents Uploaded", 1, "lbl-name"], [1, "nsc-ts-attachments"], [4, "ngFor", "ngForOf"]]; }, template: function RecipientDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, RecipientDetailsComponent_div_0_Template, 6, 2, "div", 0);
        ɵɵtemplate(1, RecipientDetailsComponent_ts_spacer_1_Template, 1, 0, "ts-spacer", 1);
        ɵɵtemplate(2, RecipientDetailsComponent_div_2_Template, 28, 18, "div", 2);
    } if (rf & 2) {
        ɵɵproperty("ngIf", !ctx.hideOptions.addBtn);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.hideOptions.addBtn);
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.recipients);
    } }, directives: [NgIf, NgForOf, MatButton, MatIcon, SpacerComponent, MatSuffix], pipes: [CurrencyPipe, UpperCasePipe], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(RecipientDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'ts-recipient-details',
                templateUrl: './recipient-details.component.html',
                styleUrls: ['./recipient-details.component.scss']
            }]
    }], function () { return []; }, { deleteRecipient: [{
            type: Output
        }], editRecipient: [{
            type: Output
        }], openDialog: [{
            type: Output
        }], addRecipient: [{
            type: Output
        }], error: [{
            type: Input
        }], maxRecipients: [{
            type: Input
        }], recipients: [{
            type: Input
        }], hideOptions: [{
            type: Input
        }] }); })();

class RecipientDetailsModule {
}
RecipientDetailsModule.ɵfac = function RecipientDetailsModule_Factory(t) { return new (t || RecipientDetailsModule)(); };
RecipientDetailsModule.ɵmod = ɵɵdefineNgModule({ type: RecipientDetailsModule });
RecipientDetailsModule.ɵinj = ɵɵdefineInjector({ imports: [[
            CommonModule,
            MaterialModule,
            SpacerModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(RecipientDetailsModule, { declarations: [RecipientDetailsComponent], imports: [CommonModule,
        MaterialModule,
        SpacerModule], exports: [RecipientDetailsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(RecipientDetailsModule, [{
        type: NgModule,
        args: [{
                declarations: [RecipientDetailsComponent],
                imports: [
                    CommonModule,
                    MaterialModule,
                    SpacerModule
                ],
                exports: [
                    RecipientDetailsComponent
                ]
            }]
    }], null, null); })();

function OrderConfirmationCommonComponent_div_6_br_16_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "br");
} }
function OrderConfirmationCommonComponent_div_6_span_18_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r3.billingInfo.payment.state, " ");
} }
function OrderConfirmationCommonComponent_div_6_span_19_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1("", ctx_r4.billingInfo.payment.zip, " ");
} }
function OrderConfirmationCommonComponent_div_6_span_20_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1);
    ɵɵpipe(2, "uppercase");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(2, 1, ctx_r5.billingInfo.payment.country), "");
} }
function OrderConfirmationCommonComponent_div_6_div_21_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 9);
    ɵɵelementStart(1, "div", 10);
    ɵɵelementStart(2, "label", 17);
    ɵɵtext(3, "Email:");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 12);
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext(2);
    ɵɵadvance(5);
    ɵɵtextInterpolate1(" ", ctx_r6.billingInfo.payment.email, " ");
} }
function OrderConfirmationCommonComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 8);
    ɵɵelementStart(1, "div", 9);
    ɵɵelementStart(2, "div", 10);
    ɵɵelementStart(3, "label", 11);
    ɵɵtext(4, "Credit Card:");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(5, "div", 12);
    ɵɵtext(6);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(7, "div", 9);
    ɵɵelementStart(8, "div", 10);
    ɵɵelementStart(9, "label", 13);
    ɵɵtext(10, "Billing Address:");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(11, "div", 14);
    ɵɵelementStart(12, "p");
    ɵɵtext(13);
    ɵɵelement(14, "br");
    ɵɵtext(15);
    ɵɵtemplate(16, OrderConfirmationCommonComponent_div_6_br_16_Template, 1, 0, "br", 15);
    ɵɵtext(17);
    ɵɵtemplate(18, OrderConfirmationCommonComponent_div_6_span_18_Template, 2, 1, "span", 15);
    ɵɵtemplate(19, OrderConfirmationCommonComponent_div_6_span_19_Template, 2, 1, "span", 15);
    ɵɵtemplate(20, OrderConfirmationCommonComponent_div_6_span_20_Template, 3, 3, "span", 15);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(21, OrderConfirmationCommonComponent_div_6_div_21_Template, 6, 1, "div", 16);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(6);
    ɵɵtextInterpolate1(" ", ctx_r0.billingInfo.payment.creditCard, " ");
    ɵɵadvance(7);
    ɵɵtextInterpolate1(" ", ctx_r0.billingInfo.payment.addressLine1, "");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ctx_r0.billingInfo.payment.addressLine2, "");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.billingInfo.payment.addressLine2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r0.billingInfo.payment.city, ",");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.billingInfo.payment.state != "ZZ");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.billingInfo.payment.zip != "N/A");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.billingInfo.payment.country !== "US");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.billingInfo.payment.email);
} }
function OrderConfirmationCommonComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 18);
    ɵɵelementStart(1, "p");
    ɵɵi18n(2, 19);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵi18nExp(ctx_r1.schlMessage);
    ɵɵi18nApply(2);
} }
const _c2$3 = ["*"];
class OrderConfirmationCommonComponent {
    constructor() {
        this.openPopup = new EventEmitter();
    }
    ngOnInit() {
    }
    openDialogBox(details) {
        this.openPopup.emit(details);
    }
}
OrderConfirmationCommonComponent.ɵfac = function OrderConfirmationCommonComponent_Factory(t) { return new (t || OrderConfirmationCommonComponent)(); };
OrderConfirmationCommonComponent.ɵcmp = ɵɵdefineComponent({ type: OrderConfirmationCommonComponent, selectors: [["ts-order-confirmation-common"]], inputs: { cardsTitle: "cardsTitle", billingInfo: "billingInfo", schlMessage: "schlMessage", recipientsInfo: "recipientsInfo" }, outputs: { openPopup: "openPopup" }, ngContentSelectors: _c2$3, decls: 14, vars: 6, consts: function () { let i18n_0; if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
        const MSG_EXTERNAL_schlMessage$$LIB_PAGES_ORDER_CONFIRMATION_COMMON_ORDER_CONFIRMATION_COMMON_COMPONENT_TS__1 = goog.getMsg("{$interpolation}", { "interpolation": "\uFFFD0\uFFFD" });
        i18n_0 = MSG_EXTERNAL_schlMessage$$LIB_PAGES_ORDER_CONFIRMATION_COMMON_ORDER_CONFIRMATION_COMMON_COMPONENT_TS__1;
    }
    else {
        i18n_0 = $localize `:@@schlMessage␟bf9fea6e9758b865b80ae669b13a29a579d45940␟361628537236134310:${"\uFFFD0\uFFFD"}:INTERPOLATION:`;
    } return [[3, "title"], ["tabindex", "0", 1, "row", "mat-typography"], [1, "col-12", "col-lg-12"], ["class", "col-12 col-6", 4, "ngIf"], ["size", "md"], [3, "recipients", "hideOptions", "openDialog"], ["size", "lg"], ["class", "nsc-ts-form-actions no-outline", "tabindex", "0", "role", "alert", 4, "ngIf"], [1, "col-12", "col-6"], [1, "row"], [1, "col-4"], ["aria-label", "credit card", 1, "lbl-name"], [1, "col-6"], ["aria-label", "billing address", 1, "lbl-name"], [1, "col-8"], [4, "ngIf"], ["class", "row", 4, "ngIf"], [1, "lbl-name"], ["tabindex", "0", "role", "alert", 1, "nsc-ts-form-actions", "no-outline"], i18n_0]; }, template: function OrderConfirmationCommonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵelementStart(0, "ts-card");
        ɵɵelement(1, "ts-card-title", 0);
        ɵɵelementStart(2, "ts-card-content");
        ɵɵelementStart(3, "div", 1);
        ɵɵelementStart(4, "div", 2);
        ɵɵprojection(5);
        ɵɵelementEnd();
        ɵɵtemplate(6, OrderConfirmationCommonComponent_div_6_Template, 22, 9, "div", 3);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(7, "ts-spacer", 4);
        ɵɵelementStart(8, "ts-card");
        ɵɵelement(9, "ts-card-title", 0);
        ɵɵelementStart(10, "ts-card-content");
        ɵɵelementStart(11, "ts-recipient-details", 5);
        ɵɵlistener("openDialog", function OrderConfirmationCommonComponent_Template_ts_recipient_details_openDialog_11_listener($event) { return ctx.openDialogBox($event); });
        ɵɵelementEnd();
        ɵɵelement(12, "ts-spacer", 6);
        ɵɵtemplate(13, OrderConfirmationCommonComponent_div_13_Template, 3, 1, "div", 7);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("title", ctx.cardsTitle.requestor);
        ɵɵadvance(5);
        ɵɵproperty("ngIf", ctx.billingInfo);
        ɵɵadvance(3);
        ɵɵproperty("title", ctx.cardsTitle.order);
        ɵɵadvance(2);
        ɵɵproperty("recipients", ctx.recipientsInfo.recipients)("hideOptions", ctx.recipientsInfo.hideOptions);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.schlMessage);
    } }, directives: [CardComponent, CardTitleComponent, CardContentComponent, NgIf, SpacerComponent, RecipientDetailsComponent], pipes: [UpperCasePipe], styles: [".no-outline[_ngcontent-%COMP%]:focus, .no-outline[_ngcontent-%COMP%]:focus-within{outline:none}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(OrderConfirmationCommonComponent, [{
        type: Component,
        args: [{
                selector: 'ts-order-confirmation-common',
                templateUrl: './order-confirmation-common.component.html',
                styleUrls: ['./order-confirmation-common.component.scss']
            }]
    }], function () { return []; }, { openPopup: [{
            type: Output
        }], cardsTitle: [{
            type: Input
        }], billingInfo: [{
            type: Input
        }], schlMessage: [{
            type: Input
        }], recipientsInfo: [{
            type: Input
        }] }); })();

class OrderConfirmationCommonModule {
}
OrderConfirmationCommonModule.ɵfac = function OrderConfirmationCommonModule_Factory(t) { return new (t || OrderConfirmationCommonModule)(); };
OrderConfirmationCommonModule.ɵmod = ɵɵdefineNgModule({ type: OrderConfirmationCommonModule });
OrderConfirmationCommonModule.ɵinj = ɵɵdefineInjector({ imports: [[
            CommonModule,
            CardsModule,
            RecipientDetailsModule,
            SpacerModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(OrderConfirmationCommonModule, { declarations: [OrderConfirmationCommonComponent], imports: [CommonModule,
        CardsModule,
        RecipientDetailsModule,
        SpacerModule], exports: [OrderConfirmationCommonComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(OrderConfirmationCommonModule, [{
        type: NgModule,
        args: [{
                declarations: [OrderConfirmationCommonComponent],
                imports: [
                    CommonModule,
                    CardsModule,
                    RecipientDetailsModule,
                    SpacerModule,
                ],
                exports: [
                    OrderConfirmationCommonComponent
                ]
            }]
    }], null, null); })();

class SchoolsService {
    constructor(http, securityService) {
        this.http = http;
        this.securityService = securityService;
        this.data$ = new BehaviorSubject([]);
        this.unsubscribe$ = new Subject();
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    getData(apiUrl) {
        this.http
            .get(apiUrl)
            .pipe(takeUntil(this.unsubscribe$), catchError((error) => this.securityService.catchResponse(error, 'schoolsService')))
            .subscribe((data) => {
            const sortedValues = sortBy(data, 'name');
            this.data$.next(sortedValues);
        });
    }
}
SchoolsService.ɵfac = function SchoolsService_Factory(t) { return new (t || SchoolsService)(ɵɵinject(HttpClient), ɵɵinject(SecurityService)); };
SchoolsService.ɵprov = ɵɵdefineInjectable({ token: SchoolsService, factory: SchoolsService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(SchoolsService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: SecurityService }]; }, null); })();

class StatesService {
    constructor(http, securityService) {
        this.http = http;
        this.securityService = securityService;
        this.data$ = new BehaviorSubject({});
        this.unsubscribe$ = new Subject();
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    getData(apiUrl) {
        this.http
            .get(apiUrl)
            .pipe(takeUntil(this.unsubscribe$), catchError(error => this.securityService.catchResponse(error, 'statesService')))
            .subscribe((data) => {
            const us = [
                {
                    label: 'States',
                    options: []
                },
                {
                    label: 'Territories',
                    options: []
                },
                {
                    label: 'Army Post Offices',
                    options: []
                }
            ];
            const canada = [
                {
                    label: 'Provinces',
                    options: []
                },
                {
                    label: 'Territories',
                    options: []
                }
            ];
            let international = '';
            // transform the data into a structure our component is expecting (a SelectOption);
            const newValues = data.map((option) => {
                return {
                    name: option.description,
                    value: option.code.toUpperCase(),
                    category: option.category
                };
            });
            // now organize the values by country;
            newValues.forEach((state) => {
                switch (state.category) {
                    case 'U': // states;
                        us[0].options.push(state);
                        break;
                    case 'T': // territories;
                        us[1].options.push(state);
                        break;
                    case 'A': // army post offices;
                        us[2].options.push(state);
                        break;
                    case 'C': // canada;
                        // canadian regions are not broken up, in the back-end;
                        // but we want to break the up in the front-end;
                        if (['NT', 'NU', 'YT'].indexOf(state.value.toString()) === -1) {
                            // add to canda provinces;
                            canada[0].options.push(state);
                        }
                        else {
                            // add to canada territories;
                            canada[1].options.push(state);
                        }
                        break;
                    case 'I':
                        international = state.value.toString();
                        break;
                }
            });
            // return all three arrays for each component to hide/show as needed;
            this.data$.next({ us, canada, international });
        });
    }
}
StatesService.ɵfac = function StatesService_Factory(t) { return new (t || StatesService)(ɵɵinject(HttpClient), ɵɵinject(SecurityService)); };
StatesService.ɵprov = ɵɵdefineInjectable({ token: StatesService, factory: StatesService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(StatesService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: SecurityService }]; }, null); })();

class CountriesService {
    constructor(http, securityService) {
        this.http = http;
        this.securityService = securityService;
        this.data$ = new BehaviorSubject([]);
        this.unsubscribe$ = new Subject();
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    getData(apiUrl) {
        this.http
            .get(apiUrl)
            .pipe(takeUntil(this.unsubscribe$), catchError(error => this.securityService.catchResponse(error, 'countriesService')))
            .subscribe((data) => {
            // transform the data into a structure our component is expecting;
            const newValue = data.map((option) => {
                return {
                    name: option.description,
                    value: option.code.toUpperCase()
                };
            });
            this.data$.next(newValue);
        });
    }
}
CountriesService.ɵfac = function CountriesService_Factory(t) { return new (t || CountriesService)(ɵɵinject(HttpClient), ɵɵinject(SecurityService)); };
CountriesService.ɵprov = ɵɵdefineInjectable({ token: CountriesService, factory: CountriesService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(CountriesService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: SecurityService }]; }, null); })();

class OrganizationsService {
    constructor(http, securityService) {
        this.http = http;
        this.securityService = securityService;
        this.data$ = new BehaviorSubject([]);
        this.unsubscribe$ = new Subject();
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    getData(apiUrl) {
        this.http
            .get(apiUrl)
            .pipe(takeUntil(this.unsubscribe$), catchError(error => this.securityService.catchResponse(error, 'organizationsService')))
            .subscribe((data) => {
            // transform the data into a structure our component is expecting;
            const newValue = data.map((option) => {
                return {
                    ficeCode: option.ficeCode,
                    name: option.schlName,
                    orgType: option.orgType,
                    sourceType: option.sourceType,
                    value: option.schlName.toUpperCase()
                };
            });
            const sortedValues = sortBy(newValue, 'name');
            this.data$.next(sortedValues);
        });
    }
}
OrganizationsService.ɵfac = function OrganizationsService_Factory(t) { return new (t || OrganizationsService)(ɵɵinject(HttpClient), ɵɵinject(SecurityService)); };
OrganizationsService.ɵprov = ɵɵdefineInjectable({ token: OrganizationsService, factory: OrganizationsService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(OrganizationsService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: SecurityService }]; }, null); })();

class RecipientTypesService {
    constructor(http, securityService) {
        this.http = http;
        this.securityService = securityService;
        this.data$ = new BehaviorSubject([]);
        this.unsubscribe$ = new Subject();
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    getData(apiUrl) {
        this.http
            .get(apiUrl)
            .pipe(takeUntil(this.unsubscribe$), catchError(error => this.securityService.catchResponse(error, 'recipientTypesService')))
            .subscribe((data) => {
            // transform the data into a structure our component is expecting;
            const newValue = data.map((option) => {
                return {
                    name: option.description,
                    value: option.code.toUpperCase()
                };
            });
            const sortedValues = sortBy(newValue, 'name');
            this.data$.next(sortedValues);
        });
    }
}
RecipientTypesService.ɵfac = function RecipientTypesService_Factory(t) { return new (t || RecipientTypesService)(ɵɵinject(HttpClient), ɵɵinject(SecurityService)); };
RecipientTypesService.ɵprov = ɵɵdefineInjectable({ token: RecipientTypesService, factory: RecipientTypesService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(RecipientTypesService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: SecurityService }]; }, null); })();

class RecipientService {
    constructor(http) {
        this.http = http;
    }
    get(apiUrl) {
        return this.http.get(apiUrl);
    }
}
RecipientService.ɵfac = function RecipientService_Factory(t) { return new (t || RecipientService)(ɵɵinject(HttpClient)); };
RecipientService.ɵprov = ɵɵdefineInjectable({ token: RecipientService, factory: RecipientService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(RecipientService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }]; }, null); })();

class SchoolsByStateService {
    constructor(http, securityService) {
        this.http = http;
        this.securityService = securityService;
    }
    get(apiUrl) {
        return this.http
            .get(apiUrl)
            .pipe(catchError(error => this.securityService.catchResponse(error, 'schoolsByState')));
    }
}
SchoolsByStateService.ɵfac = function SchoolsByStateService_Factory(t) { return new (t || SchoolsByStateService)(ɵɵinject(HttpClient), ɵɵinject(SecurityService)); };
SchoolsByStateService.ɵprov = ɵɵdefineInjectable({ token: SchoolsByStateService, factory: SchoolsByStateService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(SchoolsByStateService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: SecurityService }]; }, null); })();

class FeesService {
    constructor(http, securityService) {
        this.http = http;
        this.securityService = securityService;
    }
    get(postData, url) {
        return this.http
            .post(url, postData)
            .pipe(catchError((error) => this.securityService.catchResponse(error, 'feesService')));
    }
}
FeesService.ɵfac = function FeesService_Factory(t) { return new (t || FeesService)(ɵɵinject(HttpClient), ɵɵinject(SecurityService)); };
FeesService.ɵprov = ɵɵdefineInjectable({ token: FeesService, factory: FeesService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵsetClassMetadata(FeesService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: SecurityService }]; }, null); })();

/*
 * Public API Surface of ts-ui-components
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AdvancedLinkComponent, AutocompleteSearchService, BlockingIndicatorComponent, BlockingIndicatorModule, BlockingIndicatorRef, BlockingIndicatorService, BreadcrumbService, BreadcrumbsComponent, BreadcrumbsModule, CardComponent, CardContentComponent, CardTitleComponent, CardsModule, CheckApiResponse, ConvertDeliveryMethod, CountriesService, DataService, DeliveryFeeSummaryComponent, DeliveryFeeSummaryModule, DialogAddresValidationComponent, DialogBoxComponent, DialogBoxModule, DialogBoxService, DialogTimeoutComponent, DialogTimeoutModule, DynamicTableComponent, DynamicTableModule, DynamicTableService, FeesService, FormFieldAddressAutocompleteComponent, FormFieldAddressAutocompleteModule, FormFieldAutocompleteComponent, FormFieldAutocompleteModule, FormFieldConfirmComponent, FormFieldConfirmModule, FormFieldFilesComponent, FormFieldFilesModule, FormFieldInputComponent, FormFieldInputModule, FormFieldSearchComponent, FormFieldSearchModule, FormFieldSelectComponent, FormFieldSelectModule, FormFieldSelectOptgroupComponent, FormFieldSelectOptgroupModule, FormFieldToggleComponent, FormFieldToggleModule, ManageFields, ManageUploadFilesComponent, ManageUploadFilesModule, MaterialModule, MessageComponent, MessageModule, OrderConfirmationCommonComponent, OrderConfirmationCommonModule, OrganizationsService, RecipientDetailsComponent, RecipientDetailsModule, RecipientService, RecipientTypesService, RegisterSvgIconsService, SchoolsByStateService, SchoolsService, ScrollToTopComponent, ScrollToTopModule, SecurityService, SharedCommonValues, SpacerComponent, SpacerModule, StatesService, SystemMessageComponent, SystemMessageModule, TimeoutService, ValidateCasId, ValidateCreditCardNumber, ValidateDateCompare, ValidateDateCreditCard, ValidateDateOfBirth, ValidateMatch, ValidateRequireEither, ValidateSchoolAutocomplete, ValidateStudentIdPrimary, ValidationMessage, VerifyAddressService, WebAimContrastChecker };
//# sourceMappingURL=ts-ui-components.js.map
